(function () {
  var roots = document.querySelectorAll('[data-cap-ai-consultant]');

  // Exact Capucinne Consultant sparkle from Figma frame 1000002921 (313:1331).
  var SPARKLE_SVG = '<svg viewBox="0 0 24 24" fill="currentColor" stroke="none" aria-hidden="true" focusable="false">' +
    '<path d="M18.6563 11.7478 13.98 10.0237 12.2522 5.34375a1.867 1.867 0 0 0-3.5044 0l-1.72405 4.68-4.68 1.72405a1.867 1.867 0 0 0 0 3.5044L7.02 16.9763l1.72781 4.6799a1.867 1.867 0 0 0 3.50439 0l1.7241-4.6762 4.68-1.7278a1.867 1.867 0 0 0 0-3.5044Zm-5.9419 3.2963a1.126 1.126 0 0 0-.6666.6665L10.5 19.9012l-1.54406-4.1906a1.126 1.126 0 0 0-.66657-.6665L4.09875 13.5l4.19062-1.5441a1.126 1.126 0 0 0 .66657-.6665L10.5 7.09875l1.5441 4.19065a1.126 1.126 0 0 0 .6665.6665L16.9013 13.5l-4.1869 1.5441ZM13.125 3.75c0-.62132.5037-1.125 1.125-1.125h1.125V1.5a1.125 1.125 0 0 1 2.25 0v1.125h1.125a1.125 1.125 0 0 1 0 2.25h-1.125V6a1.125 1.125 0 0 1-2.25 0V4.875H14.25A1.125 1.125 0 0 1 13.125 3.75Zm10.5 4.5c0 .62132-.5037 1.125-1.125 1.125h-.375v.375a1.125 1.125 0 0 1-2.25 0v-.375H19.5a1.125 1.125 0 0 1 0-2.25h.375V6.75a1.125 1.125 0 0 1 2.25 0v.375h.375c.6213 0 1.125.50368 1.125 1.125Z"></path>' +
    '</svg>';
  var USER_SVG = '<svg viewBox="0 0 20 20" fill="currentColor" stroke="none" aria-hidden="true" focusable="false">' +
    '<path d="M18.3109 16.4062a9.57 9.57 0 0 0-4.7484-4.1585 5.938 5.938 0 1 0-7.125 0 9.57 9.57 0 0 0-4.74844 4.1585.9375.9375 0 1 0 1.62266.9375C4.72734 14.8969 7.22734 13.4375 10 13.4375s5.2727 1.4602 6.6883 3.9062a.9375.9375 0 1 0 1.6226-.9375ZM5.9375 7.5A4.0625 4.0625 0 1 1 10 11.5625 4.067 4.067 0 0 1 5.9375 7.5Z"></path>' +
    '</svg>';

  Array.prototype.forEach.call(roots, function (root) {
    var rawEndpoint = (root.getAttribute('data-agent-endpoint') || '').trim();
    var rawVoiceEndpoint = (root.getAttribute('data-voice-endpoint') || '').trim();
    var localAgentOrigin = (root.getAttribute('data-local-agent-origin') || '').trim();
    var endpoint = resolveEndpoint(rawEndpoint, localAgentOrigin);
    var voiceEndpoint = resolveEndpoint(rawVoiceEndpoint, localAgentOrigin);
    var searchUrl = root.getAttribute('data-search-url') || '/search';
    var shopDomain = root.getAttribute('data-shop-domain') || '';
    var locale = root.getAttribute('data-locale') || '';
    var currency = root.getAttribute('data-currency') || '';
    // Optional Worker route that stores an uploaded photo and returns a public
    // URL (Cloudflare R2) for the dashboard. Opt-in through data-upload-endpoint
    // only (audit ISS-18, 2026-09-28): R2 is not provisioned, the /upload route
    // answers 503, and sending every photo twice cost shoppers upload time for
    // nothing. The photo Claude sees travels as meta.image either way.
    var uploadEndpoint = resolveEndpoint((root.getAttribute('data-upload-endpoint') || '').trim(), localAgentOrigin);

    // Logged-in Shopify customer identity, rendered into the widget root by the
    // Liquid (blank/absent for guests). Captured once and attached to every
    // chat request's meta so the dashboard can show shopper identity. Reading a
    // missing attribute yields '' so this is fully fail-safe for guests.
    var customerMeta = (function () {
      var data = {};
      var id = (root.getAttribute('data-customer-id') || '').trim();
      var name = (root.getAttribute('data-customer-name') || '').trim();
      var email = (root.getAttribute('data-customer-email') || '').trim();
      var phone = (root.getAttribute('data-customer-phone') || '').trim();
      if (id) data.customer_id = id;
      if (name) data.customer_name = name;
      if (email) data.customer_email = email;
      if (phone) data.customer_phone = phone;
      return data;
    })();
    var conversationStore = window.CapucinneAIConversation || null;
    var savedConversation = conversationStore ? conversationStore.load() : {};
    var conversationId = savedConversation.conversationId || ('cap-ai-' + Date.now().toString(36) + '-' + Math.random().toString(36).slice(2, 8));
    var cartId = savedConversation.cartId || '';
    var checkoutUrl = savedConversation.checkoutUrl || '';
    var searchState = (window.CapucinneAISearch && window.CapucinneAISearch.createState()) || { lastQuery: '' };
    // The whole conversation is kept and sent (merchant 2026-09-15: every line
    // must be remembered, even 100 balloons in); 400 entries is only a storage guard.
    var HISTORY_CAP = 400;
    var history = Array.isArray(savedConversation.history) ? savedConversation.history.slice(-HISTORY_CAP) : [];
    // Turns saved before every turn carried its time get the thread's last
    // save time, so the consultant can tell an old visit from a new request.
    history.forEach(function (entry) {
      if (entry && !(Number(entry.at) > 0) && Number(savedConversation.updatedAt) > 0) entry.at = Number(savedConversation.updatedAt);
    });

    var helper = root.querySelector('[data-cap-ai-helper]');
    var helperOpen = root.querySelector('[data-cap-ai-helper-open]');
    var helperClose = root.querySelector('[data-cap-ai-helper-close]');
    var welcome = root.querySelector('[data-cap-ai-welcome]');
    var chat = root.querySelector('[data-cap-ai-chat]');
    var messages = root.querySelector('[data-cap-ai-messages]');
    var recommendations = root.querySelector('[data-cap-ai-recommendations]');
    var promptButtons = root.querySelectorAll('[data-cap-ai-prompt]');
    var forms = root.querySelectorAll('[data-cap-ai-form], [data-cap-ai-chat-form]');

    // --- Composer: a growing, wrapping text box ------------------------------
    // ChatGPT/Claude style (merchant 2026-09-21): a long message breaks onto new
    // lines and the box grows up to about five lines, then scrolls, so the
    // shopper can read and edit everything they typed. Enter sends, Shift+Enter
    // adds a line break, and Enter is left alone while an IME is composing.
    // Every programmatic write (voice transcript, restored draft, the clear after
    // sending, Start over) re-measures too, through the value setter.
    var COMPOSER_FIELDS = '[data-cap-ai-input], [data-cap-ai-chat-input]';
    function composerField(form) {
      return form ? form.querySelector(COMPOSER_FIELDS) || form.querySelector('input[type="search"]') : null;
    }
    function autosizeComposer(field) {
      if (!field || field.tagName !== 'TEXTAREA') return;
      var form = field.form || field.closest('form');
      // Empty, or not laid out yet (a hidden view): fall back to the one-line CSS height.
      // While the shopper is speaking the mic cluster squeezes the field and every
      // interim transcript rewrites it: stay one line and keep the newest words in
      // view instead of growing (and re-flowing the chat) word by word.
      var speaking = !!form && form.hasAttribute('data-voice-status');
      if (!field.value || !field.getClientRects().length || speaking) {
        field.style.height = '';
        field.style.overflowY = '';
        if (form) form.classList.remove('is-multiline');
        if (speaking && field.value) field.scrollTop = field.scrollHeight;
        return;
      }
      var styles = window.getComputedStyle(field);
      var max = parseFloat(styles.maxHeight) || 132;
      field.style.height = 'auto';
      var needed = field.scrollHeight;
      field.style.height = Math.min(needed, max) + 'px';
      field.style.overflowY = needed > max + 1 ? 'auto' : 'hidden';
      var oneLine = (parseFloat(styles.lineHeight) || 20) + (parseFloat(styles.paddingTop) || 0) + (parseFloat(styles.paddingBottom) || 0);
      if (form) form.classList.toggle('is-multiline', needed > oneLine * 1.4);
    }
    var nativeTextareaValue = Object.getOwnPropertyDescriptor(HTMLTextAreaElement.prototype, 'value');
    Array.prototype.forEach.call(root.querySelectorAll('textarea' + COMPOSER_FIELDS.replace(', ', ', textarea')), function (field) {
      if (nativeTextareaValue && nativeTextareaValue.set) {
        try {
          Object.defineProperty(field, 'value', {
            configurable: true,
            get: function () { return nativeTextareaValue.get.call(this); },
            set: function (next) { nativeTextareaValue.set.call(this, next); autosizeComposer(this); }
          });
        } catch (error) { /* keep the native property */ }
      }
      field.addEventListener('input', function () { autosizeComposer(field); });
      field.addEventListener('focus', function () { autosizeComposer(field); });
      field.addEventListener('keydown', function (event) {
        if (event.key !== 'Enter' || event.shiftKey || event.altKey || event.isComposing || event.keyCode === 229) return;
        event.preventDefault();
        var form = field.form;
        if (!form) return;
        if (typeof form.requestSubmit === 'function') form.requestSubmit();
        else form.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
      });
    });
    function autosizeAllComposers() {
      Array.prototype.forEach.call(root.querySelectorAll('textarea' + COMPOSER_FIELDS.replace(', ', ', textarea')), autosizeComposer);
    }
    window.addEventListener('resize', autosizeAllComposers);
    // Re-measure whenever the field's width changes without a window resize
    // (the mic cluster appearing, the helper panel opening or closing) - only
    // on width, so setting the height never loops back into the observer.
    if (window.ResizeObserver) {
      var composerWidths = [];
      var composerObserver = new ResizeObserver(function (entries) {
        entries.forEach(function (entry) {
          var width = Math.round(entry.contentRect.width);
          var index = composerWidths.findIndex ? composerWidths.findIndex(function (item) { return item.el === entry.target; }) : -1;
          if (index === -1) { composerWidths.push({ el: entry.target, width: width }); autosizeComposer(entry.target); return; }
          if (composerWidths[index].width === width) return;
          composerWidths[index].width = width;
          autosizeComposer(entry.target);
        });
      });
      Array.prototype.forEach.call(root.querySelectorAll('textarea' + COMPOSER_FIELDS.replace(', ', ', textarea')), function (field) { composerObserver.observe(field); });
    }
    // A voice session starting or ending (data-voice-status on the form) and the
    // soft keyboard opening or closing (cap-ai-keyboard on the root, which
    // changes the height cap) re-measure too.
    if (window.MutationObserver) {
      var keyboardUp = root.classList.contains('cap-ai-keyboard');
      new MutationObserver(function () {
        var up = root.classList.contains('cap-ai-keyboard');
        if (up === keyboardUp) return;
        keyboardUp = up;
        autosizeAllComposers();
      }).observe(root, { attributes: true, attributeFilter: ['class'] });
      var voiceObserver = new MutationObserver(autosizeAllComposers);
      Array.prototype.forEach.call(forms, function (form) {
        voiceObserver.observe(form, { attributes: true, attributeFilter: ['data-voice-status'] });
      });
    }
    var uploadButtons = root.querySelectorAll('[data-cap-ai-upload-trigger]');
    var uploadInputs = root.querySelectorAll('[data-cap-ai-upload]');
    var voiceInputButtons = root.querySelectorAll('[data-cap-ai-voice-input]');
    var voiceOutputButtons = root.querySelectorAll('[data-cap-ai-voice-output]');
    var voiceEndButtons = root.querySelectorAll('[data-cap-ai-voice-end]');
    var mobileAskButton = root.querySelector('[data-cap-ai-mobile-ask]');
    var isChatting = false;
    // Latest live-cart snapshot { cart: [...], cart_total: '...' }, refreshed
    // best-effort from /cart.js. Never blocks a message; empty until resolved.
    var cartSnapshot = { cart: [], cart_total: '' };

    // --- Stick-to-bottom auto-scroll ----------------------------------------
    // The message list (never the window) is the scroller. It follows new
    // content — appended turns, carousels, lead/cart cards, the typed-out ack,
    // hydrated card images, a growing composer — ONLY while the shopper is
    // within STICK_THRESHOLD_PX of the bottom. Scrolling up to read flips the
    // flag off so the view is never yanked; the shopper's own next message (or
    // a forced call) pins it again.
    var STICK_THRESHOLD_PX = 120;
    var stickToBottom = true;
    // Where our own scroll-to-bottom last landed. Scroll events are dispatched
    // asynchronously (after any content appended in the same tick), so a
    // programmatic pin can otherwise read as "far from the bottom" and unstick
    // itself — only a position that moved AWAY from this value is the shopper.
    var lastAutoScrollTop = -1;
    // When the shopper last touched the list (wheel, touch, pointer/scrollbar,
    // keys). The browser also moves scrollTop on its own when content shrinks
    // for a moment (a typing bubble swapped for its answer) — that clamp is
    // never the shopper leaving the bottom, and a gesture is what tells them apart.
    var userScrollAt = 0;
    // True while restoreConversation replays a saved thread — restored turns
    // must not animate in (see addMessage / renderRecommendations).
    var isRestoring = false;

    function isNearBottom() {
      if (!messages) return true;
      return (messages.scrollHeight - messages.scrollTop - messages.clientHeight) <= STICK_THRESHOLD_PX;
    }

    function recentUserGesture(withinMs) {
      return !!userScrollAt && (Date.now() - userScrollAt) < withinMs;
    }

    if (messages) {
      ['wheel', 'touchstart', 'pointerdown', 'keydown'].forEach(function (type) {
        messages.addEventListener(type, function () { userScrollAt = Date.now(); }, { passive: true });
      });

      messages.addEventListener('scroll', function () {
        // Our own pin lands exactly on lastAutoScrollTop.
        if (lastAutoScrollTop >= 0 && Math.abs(messages.scrollTop - lastAutoScrollTop) <= 1) return;
        // Moved up with no gesture: the browser clamped after content shrank.
        if (!recentUserGesture(1500) && lastAutoScrollTop >= 0 && messages.scrollTop < lastAutoScrollTop) return;
        stickToBottom = isNearBottom();
      }, { passive: true });

      // Growth watcher: every node appended to the list (message, carousel,
      // lead card, cart card) and any later size change inside it (typed-out
      // ack line, quick replies, images resolving) re-pins the view while
      // stuck. The list itself is observed too, so a shrinking viewport (soft
      // keyboard, window resize) keeps the latest turn in view.
      if (typeof window.ResizeObserver === 'function' && typeof window.MutationObserver === 'function') {
        var growthObserver = new window.ResizeObserver(function () {
          scrollMessages();
        });
        try { growthObserver.observe(messages); } catch (error) { /* ignore */ }
        var appendObserver = new window.MutationObserver(function (records) {
          records.forEach(function (record) {
            Array.prototype.forEach.call(record.addedNodes, function (node) {
              if (node && node.nodeType === 1) {
                try { growthObserver.observe(node); } catch (error) { /* ignore */ }
              }
            });
            Array.prototype.forEach.call(record.removedNodes, function (node) {
              if (node && node.nodeType === 1) {
                try { growthObserver.unobserve(node); } catch (error) { /* ignore */ }
              }
            });
          });
          scrollMessages();
        });
        appendObserver.observe(messages, { childList: true });
      }
    }

    function prefersReducedMotion() {
      return !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
    }

    // One AI surface since 2026-09-15 (the header search modal is gone):
    // internal analytics events are labelled ai_consultant. No UTM tagging
    // (that would re-attribute the visitor's GA session source).
    var AI_SURFACE = 'ai_consultant';
    var lastUserQuery = '';
    var voiceSession = window.CapucinneAIVoice && window.CapucinneAIVoice.create({
      buttons: voiceInputButtons,
      outputButtons: voiceOutputButtons,
      endButtons: voiceEndButtons,
      statusTargets: forms,
      locale: locale,
      voiceEndpoint: voiceEndpoint,
      // Text is rendered by updateMessage immediately (never gated by voice), so
      // the live answer no longer flows through the voice session. renderFinal is
      // still used by the standalone speaker REPLAY (speakLast) to repaint the
      // last answer into its bubble; renderProgress is retained for the legacy
      // present() path. Both point at renderAnswer for consistent markdown.
      renderFinal: renderAnswer,
      renderProgress: renderAnswer,
      onTranscript: function (text, input) {
        if (input) input.value = '';
        sendMessage(text, true);
      }
    });

    if (helperClose) {
      helperClose.addEventListener('click', function () {
        root.classList.add('is-helper-hidden');
        if (helper) helper.hidden = true;
        if (helperOpen) helperOpen.hidden = false;
      });
    }

    if (helperOpen) {
      helperOpen.addEventListener('click', function () {
        root.classList.remove('is-helper-hidden');
        if (helper) helper.hidden = false;
        helperOpen.hidden = true;
      });
    }

    Array.prototype.forEach.call(promptButtons, function (button) {
      button.addEventListener('click', function () {
        if (voiceSession && voiceSession.prime) voiceSession.prime();
        var prompt = button.getAttribute('data-prompt') || button.textContent || '';
        trackAiEvent('prompt_click', { prompt_text: prompt.trim() });
        sendMessage(prompt.trim(), true);
      });
    });

    // Always-visible "Create your own" custom-design entry point in the chat.
    Array.prototype.forEach.call(root.querySelectorAll('[data-cap-ai-custom-cta]'), function (button) {
      button.addEventListener('click', function () {
        trackAiEvent('custom_cta_click', {});
        // Now a real link to the converting custom-design landing page: track
        // and let the browser navigate. Only the legacy button form (no href)
        // starts the in-chat intake.
        if (button.tagName === 'A' && button.getAttribute('href')) return;
        if (voiceSession && voiceSession.prime) voiceSession.prime();
        sendMessage('I want to design a custom piece', true);
      });
    });

    // --- Mode toggle (Figma 627): Capucinne Consultant <-> Search Designs ---
    // "Search Designs" swaps the whole panel for the classic catalog-search
    // view; "Use Capucinne Consultant" returns to wherever the shopper was
    // (their running chat, else the welcome).
    var searchview = root.querySelector('[data-cap-ai-searchview]');

    function enterSearchMode() {
      if (!searchview) return;
      root.classList.add('is-search-mode');
      searchview.hidden = false;
      if (welcome) welcome.hidden = true;
      if (chat) chat.hidden = true;
      // Desktop only: focusing on mobile pops the keyboard mid-switch and
      // throws the sheet around ("focus is lost"). On phones the shopper taps
      // the field themselves.
      if (window.matchMedia && window.matchMedia('(min-width: 768px)').matches) {
        var input = searchview.querySelector('[data-cap-ai-searchview-input]');
        if (input) { try { input.focus({ preventScroll: true }); } catch (error) { input.focus(); } }
      }
      trackAiEvent('search_designs_open', {});
    }

    function exitSearchMode() {
      if (!searchview || searchview.hidden) return;
      root.classList.remove('is-search-mode');
      searchview.hidden = true;
      // Let the returning panel fade/rise in like the search view does.
      root.classList.add('is-mode-anim');
      window.setTimeout(function () { root.classList.remove('is-mode-anim'); }, 420);
      if (isChatting) {
        if (chat) chat.hidden = false;
      } else if (welcome) {
        welcome.hidden = false;
        if (window.matchMedia && window.matchMedia('(min-width: 768px)').matches) {
          var composer = root.querySelector('[data-cap-ai-input]');
          if (composer) { try { composer.focus({ preventScroll: true }); } catch (error) { /* ignore */ } }
        }
      }
    }

    // Mobile keyboard stability: when the on-screen keyboard opens/resizes the
    // visual viewport, keep the focused composer in view instead of letting the
    // sheet slide it off-screen ("moves out of focus").
    if (window.matchMedia && window.matchMedia('(max-width: 767px)').matches) {
      root.addEventListener('focusin', function (event) {
        // The PAGE surface glues its stage to the visual viewport instead
        // (syncViewportMetrics): a scrollIntoView here scrolled the locked,
        // overflow-hidden document up under the keyboard with no way back
        // (merchant iPhone 2026-09-06, "the second time it moves out again").
        if (isPageSurface) return;
        var target = event.target;
        if (target && target.matches && target.matches('input[type="search"], textarea')) {
          window.setTimeout(function () {
            if (document.activeElement !== target) return;
            try { target.scrollIntoView({ block: 'nearest', behavior: 'smooth' }); } catch (error) { /* ignore */ }
          }, 260);
        }
      });
    }

    Array.prototype.forEach.call(root.querySelectorAll('[data-cap-ai-mode]'), function (button) {
      button.addEventListener('click', function () {
        if (button.getAttribute('data-cap-ai-mode') === 'search') enterSearchMode();
        else exitSearchMode();
      });
    });

    Array.prototype.forEach.call(forms, function (form) {
      form.addEventListener('submit', function (event) {
        event.preventDefault();
        // Unlock speech inside this tap/submit gesture so an auto-spoken answer
        // can play on mobile even when the shopper only typed (no mic).
        if (voiceSession && voiceSession.prime) voiceSession.prime();
        var input = composerField(form);
        var value = input ? input.value.trim() : '';
        if (!value) return;

        input.value = '';
        sendMessage(value, true);
      });
    });

    // --- Draft persistence -------------------------------------------------
    // Never make the shopper retype: if the modal closes before they send (a
    // backdrop tap or Escape on mobile), keep their unsent text and restore it
    // when the composer is next focused. Cleared the moment a message is sent.
    // Scoped to the AI composer(s) only — the classic search bar is excluded.
    var DRAFT_KEY = 'capucinneAiDraft';
    function readDraft() { try { return sessionStorage.getItem(DRAFT_KEY) || ''; } catch (error) { return ''; } }
    function writeDraft(value) {
      try {
        if (value) sessionStorage.setItem(DRAFT_KEY, value);
        else sessionStorage.removeItem(DRAFT_KEY);
      } catch (error) { /* storage disabled — best effort */ }
    }
    var draftInputs = root.querySelectorAll(COMPOSER_FIELDS);
    Array.prototype.forEach.call(draftInputs, function (input) {
      if (input.closest('[data-cap-ai-classic]')) return;
      input.addEventListener('input', function () { writeDraft(input.value.trim()); });
      input.addEventListener('focus', function () {
        if (input.value) return;
        var draft = readDraft();
        if (!draft) return;
        input.value = draft;
        try { input.setSelectionRange(draft.length, draft.length); } catch (error) { /* ignore */ }
      });
    });

    // Composer focus / typing keeps the latest turn in view (ChatGPT-style),
    // but only while the shopper is already near the bottom — scrollMessages
    // honours the stick-to-bottom flag, so reading back up is never disturbed.
    Array.prototype.forEach.call(root.querySelectorAll('[data-cap-ai-input], [data-cap-ai-chat-input]'), function (input) {
      input.addEventListener('focus', function () { scrollMessages(); });
      input.addEventListener('input', function () { scrollMessages(); });
    });

    // --- Lead capture ------------------------------------------------------
    // After the shopper has received useful recommendations, offer to email
    // them this conversation + their picks (with marketing consent), and later
    // a $100 discount opt-in. Leads flow through the worker /lead endpoint to
    // the dashboard CRM (and Klaviyo when configured). Each prompt shows at
    // most once per session; a final transcript beacon fires when the chat
    // closes so the emailed copy is complete.
    var leadEndpoint = endpoint ? endpoint.replace(/\/chat(?:\?.*)?$/, '/lead') : '';
    var leadRecTurns = 0;
    // True while the email -> discount chain (see runDiscountChain) is in
    // flight, so maybeOfferLead never stacks the standalone $100 card on top
    // of a claim that is about to succeed.
    var discountChainPending = false;
    var leadCardSeq = 0;

    var LEAD_SAVE_ERROR = 'We couldn\'t save your email just now. Please try again — or reload the page if it keeps happening.';
    var LEAD_CHALLENGE_ERROR = 'Our security check needs a quick refresh — please reload the page and try again.';
    var LEAD_INVALID_EMAIL = 'Please enter a valid email address.';

    // Cloudflare bot-challenge detection. The merchant's own Cloudflare zone
    // can interpose an interactive challenge on the app-proxy POSTs (seen live
    // 2026-09-02: GETs passed, /chat and /lead POSTs came back as a 403 "Just a
    // moment" HTML page). The worker's JSON endpoints never answer with HTML,
    // so a 403/503 whose body is text/html is the challenge page — a reload
    // (which lets the challenge run) fixes it, a retry does not.
    function isSecurityChallenge(response) {
      if (!response) return false;
      // Cloudflare labels its own interstitials explicitly on same-origin
      // fetches — the precise signal. The 403 + HTML heuristic stays as a
      // secondary check (the worker never answers with HTML); a 503 HTML page
      // is a maintenance/throttle page, not a challenge, so it is NOT one.
      var mitigated = '';
      try { mitigated = String(response.headers.get('cf-mitigated') || ''); } catch (error) { mitigated = ''; }
      if (/challenge/i.test(mitigated)) return true;
      if (response.status !== 403) return false;
      var type = '';
      try { type = String(response.headers.get('content-type') || ''); } catch (error) { type = ''; }
      return /text\/html/i.test(type);
    }

    function responseError(response, label) {
      var error = new Error(label + ' ' + response.status);
      error.status = response.status;
      error.challenge = isSecurityChallenge(response);
      return error;
    }

    function leadFlag(key, value) {
      var k = 'capAiLead.' + key;
      try {
        if (arguments.length > 1) { sessionStorage.setItem(k, value); return value; }
        return sessionStorage.getItem(k) || '';
      } catch (error) { return ''; }
    }

    function leadTranscript() {
      return history.slice(-40).map(function (entry) {
        return { role: entry.role, content: String(entry.content || '').slice(0, 2000) };
      });
    }

    function leadRecommendations() {
      var out = [];
      history.forEach(function (entry) {
        (entry.recommendations || []).forEach(function (rec) {
          if (rec && rec.url && !out.some(function (r) { return r.url === rec.url; })) {
            // image included so the Klaviyo recommendation email can render the
            // piece, not just name it (marketing spec: recommended_products).
            out.push({ title: rec.title || '', url: rec.url, price: rec.price || '', image: rec.image || '' });
          }
        });
      });
      return out.slice(-12);
    }

    function postLead(payload, useBeacon) {
      if (!leadEndpoint) return Promise.reject(new Error('no lead endpoint'));
      var body = JSON.stringify(Object.assign({
        conversation_id: conversationId,
        ai_surface: AI_SURFACE, // the lead's channel in the CRM (ai_consultant since the header modal went)
        shop_domain: root.getAttribute('data-shop-domain') || '',
        locale: locale,
        transcript: leadTranscript(),
        recommendations: leadRecommendations()
      }, payload));
      if (useBeacon && navigator.sendBeacon) {
        try {
          navigator.sendBeacon(leadEndpoint, new Blob([body], { type: 'application/json' }));
          return Promise.resolve({ ok: true });
        } catch (error) { /* fall back to fetch below */ }
      }
      return fetch(leadEndpoint, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: body }).then(function (res) {
        if (!res.ok) throw responseError(res, 'lead save failed');
        return res.json().catch(function () { return {}; });
      });
    }

    // postLead with ONE automatic retry after ~1.5 s, so a blip never surfaces
    // as an error to the shopper. The second failure is the one reported.
    function postLeadWithRetry(payload) {
      return postLead(payload).catch(function (error) {
        // A bot challenge is only cleared by a reload — retrying just delays
        // the reload prompt and sends a second blocked request.
        if (error && error.challenge) throw error;
        return new Promise(function (resolve) { window.setTimeout(resolve, 1500); })
          .then(function () { return postLead(payload); });
      });
    }

    // Flat code chip + one-tap Copy button (clipboard API, execCommand
    // fallback). Shared by the $100 card reveal and the email -> discount chain
    // so both paths render the identical affordance.
    function buildCodeChip(code) {
      var frag = document.createDocumentFragment();
      var codeEl = document.createElement('strong');
      codeEl.className = 'cap-ai-consultant__lead-code';
      codeEl.textContent = code;
      var copyBtn = document.createElement('button');
      copyBtn.type = 'button';
      copyBtn.className = 'cap-ai-consultant__lead-copy';
      copyBtn.textContent = 'Copy';
      copyBtn.setAttribute('aria-label', 'Copy discount code ' + code);
      copyBtn.addEventListener('click', function () {
        var done = function () {
          copyBtn.textContent = 'Copied';
          window.setTimeout(function () { copyBtn.textContent = 'Copy'; }, 1800);
        };
        var fallbackCopy = function () {
          var tmp = document.createElement('textarea');
          tmp.value = code;
          tmp.setAttribute('readonly', '');
          tmp.style.position = 'absolute';
          tmp.style.left = '-9999px';
          document.body.appendChild(tmp);
          tmp.select();
          try { document.execCommand('copy'); done(); } catch (error) { /* stays "Copy" */ }
          document.body.removeChild(tmp);
        };
        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(code).then(done).catch(fallbackCopy);
        } else {
          fallbackCopy();
        }
      });
      frag.appendChild(codeEl);
      frag.appendChild(copyBtn);
      return frag;
    }

    // Speak a line INTO the conversation as a real assistant turn: it persists
    // with the session, restores on reopen, and reaches the dashboard CRM
    // transcript — a card alone is UI chrome that no transcript ever sees.
    function speakAssistantLine(line) {
      try {
        addMessage('assistant', line);
        history.push({ role: 'assistant', content: line, at: Date.now() });
        history = history.slice(-HISTORY_CAP);
        saveConversation();
        scrollMessages();
      } catch (error) { /* the card already carries the information */ }
    }

    // The merchant's flow (2026-09-02): once the shopper shares their email,
    // the consultant CONTINUES by handing over the $100 welcome code — in the
    // chat and by email — instead of asking a second time via another card.
    // Failure is silent: the standalone $100 card remains as a second chance.
    function setStandaloneDiscountSubmits(disabled) {
      Array.prototype.forEach.call(messages.querySelectorAll('.cap-ai-consultant__lead[data-lead-kind="discount"] form button[type="submit"]'), function (button) {
        button.disabled = !!disabled;
      });
    }

    function runDiscountChain(email, card) {
      var state = leadFlag('discountPrompt');
      // Already handed over, or the shopper explicitly said "No thanks" to the
      // $100 offer — an explicit decline is respected, never overridden.
      if (state === 'submitted' || state === 'dismissed') { discountChainPending = false; return; }
      discountChainPending = true;
      // A standalone $100 card that is still on screen must not race this
      // claim into a second minted code; it is removed on success and
      // re-enabled on failure.
      setStandaloneDiscountSubmits(true);
      postLead({ email: email, consent: false, discount_optin: true, stage: 'discount' })
        .then(function (data) {
          leadFlag('discountPrompt', 'submitted');
          trackAiEvent('lead_discount_optin', {});
          // A standalone $100 card that is still waiting for a tap is now
          // redundant — the code has been handed over.
          Array.prototype.forEach.call(messages.querySelectorAll('.cap-ai-consultant__lead[data-lead-kind="discount"]'), function (other) {
            if (other.querySelector('form')) (other.closest('.cap-ai-consultant__message--lead') || other).remove();
          });
          var code = data && data.discount_code ? String(data.discount_code) : '';
          if (code) {
            speakAssistantLine('Thank you! As a welcome gift, here is your $100 discount code: ' + code + '. Use it at checkout — we have also emailed it to ' + email + '.');
            var codeLine = document.createElement('p');
            codeLine.className = 'cap-ai-consultant__lead-code-line';
            codeLine.appendChild(document.createTextNode('Your $100 welcome code: '));
            codeLine.appendChild(buildCodeChip(code));
            card.appendChild(codeLine);
          } else {
            speakAssistantLine('Thank you! Your $100 welcome discount is on its way to ' + email + ' by email.');
          }
          scrollMessages();
        })
        .catch(function () { /* the later $100 card remains a second chance */ })
        .then(function () {
          discountChainPending = false;
          setStandaloneDiscountSubmits(false);
        });
    }

    function buildLeadCard(kind) {
      // Rendered as a message FROM the consultant (merchant 2026-09-03): the
      // usual sparkle avatar beside a soft assistant-style bubble that holds
      // the copy and the form — not a stand-alone bordered box. The bubble
      // keeps the .cap-ai-consultant__lead hook + data-lead-kind; the row is
      // .cap-ai-consultant__message--lead (never --assistant, so quick-reply
      // hosting, transcript counts and probes still see only real turns).
      var message = document.createElement('div');
      message.className = 'cap-ai-consultant__message cap-ai-consultant__message--lead';
      var avatar = document.createElement('span');
      avatar.className = 'cap-ai-consultant__avatar';
      avatar.innerHTML = SPARKLE_SVG;
      var card = document.createElement('div');
      card.className = 'cap-ai-consultant__bubble cap-ai-consultant__lead';
      card.setAttribute('data-lead-kind', kind);
      message.appendChild(avatar);
      message.appendChild(card);
      var errorId = 'cap-ai-lead-error-' + (++leadCardSeq);
      var errorEl = null;
      var text = document.createElement('p');
      text.className = 'cap-ai-consultant__lead-text';
      var form = document.createElement('form');
      form.className = 'cap-ai-consultant__lead-form';
      var input = document.createElement('input');
      input.type = 'email';
      input.required = true;
      input.className = 'cap-ai-consultant__lead-input';
      input.placeholder = 'your@email.com';
      input.autocomplete = 'email';
      input.setAttribute('aria-label', 'Email address');
      var submit = document.createElement('button');
      submit.type = 'submit';
      submit.className = 'cap-ai-consultant__lead-submit';
      var consent = document.createElement('p');
      consent.className = 'cap-ai-consultant__lead-consent';
      consent.textContent = 'By subscribing you agree to receive personalised offers and marketing emails from Capucinne. Unsubscribe anytime.';
      var dismiss = document.createElement('button');
      dismiss.type = 'button';
      dismiss.className = 'cap-ai-consultant__lead-dismiss';
      dismiss.textContent = 'No thanks';

      if (kind === 'discount') {
        text.textContent = 'Would you like to receive a $100 discount? Subscribe to personalised promotions and special offers from Capucinne, and we’ll send your discount code by email.';
        submit.textContent = 'Get My $100 Discount';
      } else {
        text.textContent = 'Would you like us to email you a copy of this conversation and your personalised product recommendations? Please enter your email address below.';
        submit.textContent = 'Email me this conversation';
      }
      var knownEmail = leadFlag('email') || root.getAttribute('data-customer-email') || '';
      if (knownEmail) input.value = knownEmail;

      form.appendChild(input);
      form.appendChild(submit);
      card.appendChild(text);
      card.appendChild(form);
      card.appendChild(consent);
      card.appendChild(dismiss);

      // Visible, announced error line under the form (role="alert"), so a
      // failed save never reads as a silent red border. Created on demand,
      // removed on the next attempt.
      function showLeadError(message) {
        card.classList.add('is-error');
        if (!errorEl) {
          errorEl = document.createElement('p');
          errorEl.className = 'cap-ai-consultant__lead-error';
          errorEl.id = errorId;
          errorEl.setAttribute('role', 'alert');
        }
        errorEl.textContent = message;
        if (!errorEl.parentNode) form.insertAdjacentElement('afterend', errorEl);
        input.setAttribute('aria-describedby', errorId);
      }
      function clearLeadError() {
        card.classList.remove('is-error');
        input.removeAttribute('aria-invalid');
        input.removeAttribute('aria-describedby');
        if (errorEl && errorEl.parentNode) errorEl.remove();
      }

      dismiss.addEventListener('click', function () {
        leadFlag(kind + 'Prompt', 'dismissed');
        message.remove();
      });
      var submitLabel = submit.textContent;
      form.addEventListener('submit', function (event) {
        event.preventDefault();
        // The email -> discount chain is already claiming the code for this
        // shopper; a second claim from the standalone card would mint twice.
        if (kind === 'discount' && discountChainPending) return;
        var email = (input.value || '').trim();
        if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
          showLeadError(LEAD_INVALID_EMAIL);
          input.setAttribute('aria-invalid', 'true');
          input.focus();
          return;
        }
        clearLeadError();
        submit.disabled = true;
        submit.textContent = 'Sending…';
        // Marketing spec: ONE consent step. The first (email) card records the
        // marketing consent and triggers the recommendations flow; the $100 CTA
        // is a discount CLAIM event, never a second subscription.
        postLeadWithRetry(kind === 'discount'
          ? { email: email, consent: false, discount_optin: true, stage: 'discount' }
          : { email: email, consent: true, discount_optin: false, stage: 'recommendations' })
          .then(function (data) {
            leadFlag('email', email);
            leadFlag(kind + 'Prompt', 'submitted');
            trackAiEvent(kind === 'discount' ? 'lead_discount_optin' : 'lead_email_capture', {});
            // LIVE CODE REVEAL (merchant 2026-09-02): when the worker minted a
            // unique code, show it right here with one-tap copy — the email
            // carries the same code. Without a code (minting unavailable) the
            // original email-only wording stands.
            if (kind === 'discount' && data && data.discount_code) {
              var code = String(data.discount_code);
              text.textContent = 'Wonderful — here is your $100 code: ';
              text.appendChild(buildCodeChip(code));
              var tail = document.createElement('span');
              tail.textContent = ' Use it at checkout — it is also on its way to ' + email + ' by email.';
              text.appendChild(tail);
              speakAssistantLine('Your $100 discount code is ' + code + '. Use it at checkout — we have also emailed it to ' + email + '.');
            } else {
              text.textContent = kind === 'discount'
                ? 'Wonderful — your $100 discount code is on its way to ' + email + '.'
                : 'Lovely — we’ll email this conversation and your recommendations to ' + email + '.';
            }
            form.remove();
            consent.remove();
            dismiss.remove();
            // Email shared -> the consultant continues with the welcome gift.
            if (kind !== 'discount' && leadFlag('discountPrompt') !== 'submitted' && leadFlag('discountPrompt') !== 'dismissed') {
              discountChainPending = true;
              window.setTimeout(function () { runDiscountChain(email, card); }, 1200);
            }
          })
          .catch(function (error) {
            submit.disabled = false;
            submit.textContent = submitLabel;
            showLeadError(error && error.challenge ? LEAD_CHALLENGE_ERROR : LEAD_SAVE_ERROR);
          });
      });
      return message;
    }

    function maybeOfferLead() {
      if (leadRecTurns < 2 || !messages) return;
      var emailState = leadFlag('emailPrompt');
      if (!emailState) {
        leadFlag('emailPrompt', 'shown');
        messages.appendChild(buildLeadCard('email'));
        scrollMessages();
        return;
      }
      if (leadRecTurns >= 3 && !leadFlag('discountPrompt') && !discountChainPending) {
        leadFlag('discountPrompt', 'shown');
        messages.appendChild(buildLeadCard('discount'));
        scrollMessages();
      }
    }

    function sendLeadCloseBeacon() {
      var email = leadFlag('email');
      if (!email) return;
      // CRM-only final transcript update — consent was recorded at the first
      // step and the worker sends no Klaviyo traffic for stage 'close'.
      postLead({
        email: email,
        consent: false,
        discount_optin: leadFlag('discountPrompt') === 'submitted',
        stage: 'close'
      }, true);
    }
    window.addEventListener('pagehide', sendLeadCloseBeacon);

    Array.prototype.forEach.call(uploadButtons, function (button, index) {
      button.addEventListener('click', function () {
        var input = uploadInputs[index] || uploadInputs[0];
        if (input) input.click();
      });
    });

    Array.prototype.forEach.call(uploadInputs, function (input) {
      input.addEventListener('change', function () {
        if (!input.files || !input.files.length) return;
        var file = input.files[0];
        input.value = '';
        handleUpload(file);
      });
    });

    // A photo pasted into the message box, or dropped on the chat, goes the
    // same way as one picked with the photo button (audit ISS-18, 2026-09-28:
    // a pasted picture simply vanished, and a dropped one opened in the tab).
    // A paste that also carries text (copied from a web page) stays text.
    Array.prototype.forEach.call(root.querySelectorAll(COMPOSER_FIELDS), function (field) {
      field.addEventListener('paste', function (event) {
        var data = event.clipboardData;
        if (!data) return;
        var file = data.files && data.files.length ? firstImageFile(data.files) : null;
        if (!file && data.items) {
          for (var i = 0; i < data.items.length && !file; i++) {
            var item = data.items[i];
            var candidate = item && item.kind === 'file' && item.getAsFile ? item.getAsFile() : null;
            if (candidate && isLikelyImageFile(candidate)) file = candidate;
          }
        }
        if (!file) return;
        var text = '';
        try { text = data.getData('text/plain') || ''; } catch (error) { text = ''; }
        if (text.trim()) return;
        event.preventDefault();
        handleUpload(file);
      });
    });

    function isFileDrag(event) {
      var types = event && event.dataTransfer && event.dataTransfer.types;
      if (!types) return false;
      for (var i = 0; i < types.length; i++) {
        if (types[i] === 'Files') return true;
      }
      return false;
    }
    root.addEventListener('dragover', function (event) {
      if (!isFileDrag(event)) return;
      event.preventDefault();
      try { event.dataTransfer.dropEffect = 'copy'; } catch (error) { /* read-only in some browsers */ }
    });
    root.addEventListener('drop', function (event) {
      if (!isFileDrag(event)) return;
      event.preventDefault();
      var files = event.dataTransfer.files;
      if (!files || !files.length) return;
      handleUpload(firstImageFile(files) || files[0]);
    });

    // The embedded classic search bar (data-cap-ai-classic) is a plain native
    // form that GETs to the Shopify search page — no JS needed. Track the
    // fallback usage so AI-vs-classic search can be measured.
    var classicSearchForms = root.querySelectorAll('[data-cap-ai-classic]');
    Array.prototype.forEach.call(classicSearchForms, function (form) {
      form.addEventListener('submit', function () {
        var field = form.querySelector('input[type="search"]');
        trackAiEvent('classic_search_submit', { ai_query: field ? field.value.trim() : '' });
      });
    });

    Array.prototype.forEach.call(voiceInputButtons, function (button) {
      button.addEventListener('click', function (event) {
        event.preventDefault();

        var form = button.closest('form');
        var input = composerField(form);
        if (voiceSession) {
          if (!voiceSession.isEnabled()) trackAiEvent('voice_started', {});
          voiceSession.toggle(input, button);
        }
      });
    });

    Array.prototype.forEach.call(voiceOutputButtons, function (button) {
      button.addEventListener('click', function (event) {
        event.preventDefault();
        if (!voiceSession) return;

        // The speaker is a simple sound on/off toggle — NOT a replay. Tapping it
        // while sound is on mutes immediately and stops all current speech and
        // generation (so it never keeps reading or repeats). Tapping it while
        // off turns sound on (a gesture, so mobile allows the next answer's
        // audio) — without replaying anything already read.
        if (voiceSession.isOutputEnabled()) {
          voiceSession.setOutputEnabled(false);
        } else {
          if (voiceSession.prime) voiceSession.prime();
          voiceSession.setOutputEnabled(true);
        }
      });
    });

    Array.prototype.forEach.call(voiceEndButtons, function (button) {
      button.addEventListener('click', function (event) {
        event.preventDefault();
        if (voiceSession) voiceSession.stop();
      });
    });

    root.addEventListener('capucinne:voice-pending', function (event) {
      if (!voiceSession) return;
      var detail = event && event.detail ? event.detail : {};
      var input = detail.input || root.querySelector('[data-cap-ai-input]');
      var button = root.querySelector('[data-cap-ai-voice-input]');
      voiceSession.activatePending(input, button);
    });

    // On the full-page consultant (the <section>, which carries the bottom nav)
    // the chat is a viewport-fit surface on EVERY width (merchant 2026-09-02,
    // ChatGPT/Claude-style): the stage is sized from the VISUAL viewport
    // (--cap-ai-vh, so an open iOS keyboard shrinks it) minus the measured
    // sticky site header (--cap-page-header-h), the message list scrolls inside
    // the panel and the composer stays on screen — the window never has to
    // scroll. JS marks the page section with `is-page-fit`.
    var isFullPage = root.tagName === 'SECTION' && root.querySelector('.cap-ai-consultant__mobile-nav');
    var isPageSurface = !!isFullPage;
    var HEADER_FALLBACK_PX = 120;
    var KEYBOARD_MIN_OVERLAP = 120;
    var keyboardOpen = false;
    // innerHeight while no field of ours is focused: browsers that shrink the
    // LAYOUT viewport for the keyboard (Android Chrome, in-app browsers) show
    // the keyboard only as a drop from this.
    var restInnerHeight = window.innerHeight;

    function pageHeaderElement() {
      return document.querySelector('.capucinne-site-header') ||
        document.querySelector('#shopify-section-header');
    }

    // --cap-page-header-h: the space the sticky site header (announcement strip
    // included) takes above the section at scrollY 0. Anything else rendered
    // between the header and this section counts too (the section's own
    // document offset), so the stage always ends exactly at the viewport
    // bottom. Scroll-independent, so a compacting header never feeds back.
    function measurePageHeader() {
      if (!isPageSurface) return;
      var header = pageHeaderElement();
      var headerH = 0;
      if (header) {
        try { headerH = header.getBoundingClientRect().height; } catch (error) { headerH = 0; }
      }
      if (!(headerH > 0)) headerH = HEADER_FALLBACK_PX;
      var scrollY = window.pageYOffset || document.documentElement.scrollTop || 0;
      var docTop = 0;
      try { docTop = root.getBoundingClientRect().top + scrollY; } catch (error) { docTop = 0; }
      var top = Math.max(headerH, docTop);
      // Sanity clamp: a runaway offset must never leave the chat with no room.
      var vh = (window.visualViewport && window.visualViewport.height) || window.innerHeight || 0;
      if (vh > 0) top = Math.min(top, Math.round(vh * 0.4));
      root.style.setProperty('--cap-page-header-h', Math.max(0, Math.round(top)) + 'px');
    }

    // --cap-ai-vh: the VISUAL viewport height (falls back to the window). When
    // the soft keyboard overlaps by more than KEYBOARD_MIN_OVERLAP the section
    // gets `cap-ai-keyboard` (the bottom nav sits behind the keyboard, so its
    // strip is handed to the chat) and the latest turn is kept in view.
    var lastVh = '';
    var lastVvTop = '';
    var keyboardSettleTimer = 0;
    // The keyboard glue exists for narrow TOUCH surfaces only: a desktop
    // window resize or zoom must never flip the keyboard state.
    function narrowTouchSurface() {
      try { return window.matchMedia('(max-width: 1023px)').matches && window.matchMedia('(pointer: coarse)').matches; } catch (error) { return false; }
    }
    function syncViewportMetrics() {
      if (!isPageSurface) return;
      var vv = window.visualViewport;
      var height = vv ? vv.height : window.innerHeight;
      var vh = Math.round(height) + 'px';
      // Style writes only on change: a write per 60 ms tick re-laid the stage
      // out for nothing and read as shaking (merchant iPhone 2026-09-07).
      if (vh !== lastVh) { lastVh = vh; root.style.setProperty('--cap-ai-vh', vh); }
      // The soft keyboard's height is innerHeight - visual height (iOS keeps
      // innerHeight constant). The visual viewport's PAN (offsetTop) is not
      // part of it.
      var overlap = vv ? Math.max(0, window.innerHeight - vv.height) : 0;
      var active = document.activeElement;
      var fieldFocused = !!(active && root.contains(active) && /^(?:INPUT|TEXTAREA)$/.test(active.tagName));
      var touch = narrowTouchSurface();
      if (!fieldFocused) {
        restInnerHeight = window.innerHeight;
        // Short phones (iPhone SE class): from the RESTING height, so the
        // compaction never toggles with the keyboard.
        root.classList.toggle('cap-ai-short', touch && restInnerHeight <= 640);
      } else if (touch && overlap <= KEYBOARD_MIN_OVERLAP && restInnerHeight - window.innerHeight > KEYBOARD_MIN_OVERLAP) {
        // Browsers that shrink the LAYOUT viewport for the keyboard (Android
        // Chrome, in-app browsers) show it only as a drop from the rest height.
        overlap = restInnerHeight - window.innerHeight;
      }
      var open = touch && overlap > KEYBOARD_MIN_OVERLAP;
      // The visual viewport's pan while the keyboard is up: the keyboard-glued
      // stage (CSS, cap-ai-keyboard) translates by it so its bottom edge is
      // always the keyboard's top edge, whatever Safari scrolled.
      var vvTop = (open && vv ? Math.max(0, Math.round(vv.offsetTop)) : 0) + 'px';
      if (vvTop !== lastVvTop) { lastVvTop = vvTop; root.style.setProperty('--cap-ai-vv-top', vvTop); }
      if (open === keyboardOpen) return;
      keyboardOpen = open;
      if (keyboardSettleTimer) { window.clearTimeout(keyboardSettleTimer); keyboardSettleTimer = 0; }
      if (open) {
        root.classList.add('cap-ai-keyboard');
        // ONE settle after the keyboard animation - never per event.
        keyboardSettleTimer = window.setTimeout(function () { keyboardSettleTimer = 0; settleUnderKeyboard(); }, 320);
      } else {
        root.classList.remove('cap-ai-keyboard');
        alignPageToChat();
      }
    }

    // Keyboard open: the stage is sized to the visual viewport, so undo any
    // pan iOS applied (the input is now inside the visual viewport at scroll
    // 0) and keep the latest turn + the composer in view.
    // Keyboard open, ONE settle after the animation: keep the latest turn and
    // the composer in view. The stage is glued to the visual viewport by CSS,
    // so Safari's pan is left alone - undoing it on every tick is what shook
    // the layout; the pan and any focus scroll are undone once, at keyboard
    // close, by alignPageToChat.
    function settleUnderKeyboard() {
      scrollMessages();
    }

    // A focus scroll (Safari's own, or a scrollIntoView) can scroll an
    // overflow-hidden ancestor - the stage, main, body, html - by a few
    // hundred px with no gesture to bring it back (merchant iPhone
    // 2026-09-06: "pushed up ... the second time it moves out again"). Every
    // scroll container between the composer and the document, except the
    // message list, goes back to 0.
    function unscrollAncestors() {
      var start = root.querySelector('[data-cap-ai-chat-form]') || root;
      var node = start;
      while (node && node.nodeType === 1) {
        try { if (node !== messages && node.scrollTop > 0) node.scrollTop = 0; } catch (error) { /* noop */ }
        node = node.parentNode;
      }
      try {
        var se = document.scrollingElement || document.documentElement;
        if (se && se.scrollTop > 0) se.scrollTop = 0;
        if (document.body && document.body.scrollTop > 0) document.body.scrollTop = 0;
      } catch (error) { /* noop */ }
    }

    // The viewport-fit chat is laid out for scrollY 0 (section top right under
    // the sticky header). Bring the window back there whenever the chat opens
    // or the keyboard closes — the panel is the scroller, never the page.
    // DOCUMENT LOCK ON PHONES/TABLETS (merchant iPhone test 2026-09-03): the
    // window could drift by the announcement-bar height (iOS URL-bar collapse,
    // the focus scroll on the composer, a swipe on the header) and the sticky
    // logo row then covered the chat header - with no way back, because the
    // message list is a contained scroller that never chains to the window.
    // Below 1024px the page chat IS the screen: lock the document while it is
    // open (html.cap-ai-chat-lock); the bottom nav is the way out.
    var CHAT_LOCK_QUERY = '(max-width: 1023px)';
    function syncChatLock() {
      if (!isPageSurface) return;
      var narrow = false;
      try { narrow = !!(window.matchMedia && window.matchMedia(CHAT_LOCK_QUERY).matches); } catch (error) { narrow = false; }
      var lock = isChatting && narrow;
      if (lock) document.documentElement.classList.add('cap-ai-chat-lock');
      else document.documentElement.classList.remove('cap-ai-chat-lock');
    }

    function alignPageToChat() {
      if (!isPageSurface || !isChatting) return;
      unscrollAncestors();
      try {
        var scrollY = window.pageYOffset || document.documentElement.scrollTop || 0;
        if (scrollY > 1) window.scrollTo(0, 0);
      } catch (error) { /* best effort */ }
    }

    if (isPageSurface) {
      root.classList.add('is-page-fit');
      var pageMetricsFrame = 0;
      var schedulePageMetrics = function () {
        if (pageMetricsFrame) return;
        pageMetricsFrame = window.requestAnimationFrame(function () {
          pageMetricsFrame = 0;
          measurePageHeader();
          syncViewportMetrics();
          syncChatLock();
        });
      };

      measurePageHeader();
      syncViewportMetrics();
      window.addEventListener('resize', schedulePageMetrics, { passive: true });
      window.addEventListener('orientationchange', schedulePageMetrics, { passive: true });
      // The header may compact on scroll; re-measure (scroll-independent maths
      // above keeps this from feeding back into the layout).
      window.addEventListener('scroll', schedulePageMetrics, { passive: true });
      window.addEventListener('load', schedulePageMetrics);
      if (window.visualViewport) {
        window.visualViewport.addEventListener('resize', schedulePageMetrics, { passive: true });
        window.visualViewport.addEventListener('scroll', function () {
          // The pan is written synchronously (no rAF lag) so the glued stage
          // tracks Safari frame for frame; everything else waits for the rAF.
          if (keyboardOpen) {
            var vvTop = Math.max(0, Math.round(window.visualViewport.offsetTop)) + 'px';
            if (vvTop !== lastVvTop) { lastVvTop = vvTop; root.style.setProperty('--cap-ai-vv-top', vvTop); }
          }
          schedulePageMetrics();
        }, { passive: true });
      }
      // iOS belt-and-braces: the visualViewport events can land once, late
      // (at the end of the keyboard animation) or not at all. While the
      // composer gains or loses focus the metrics are re-read every 60 ms for
      // a moment, so the glued stage never waits on an event.
      var viewportPoll = 0;
      var pollViewport = function (ms) {
        var until = Date.now() + ms;
        if (viewportPoll) window.clearInterval(viewportPoll);
        viewportPoll = window.setInterval(function () {
          schedulePageMetrics();
          if (Date.now() >= until) { window.clearInterval(viewportPoll); viewportPoll = 0; }
        }, 100);
      };
      var pageChatInput = root.querySelector('[data-cap-ai-chat-input]');
      if (pageChatInput) {
        pageChatInput.addEventListener('focus', function () { pollViewport(1200); });
        pageChatInput.addEventListener('blur', function () { pollViewport(700); });
      }
      // Late header changes (announcement strip mounting, web fonts) are
      // caught by observing the header element itself.
      if (typeof window.ResizeObserver === 'function') {
        var headerEl = pageHeaderElement();
        if (headerEl) {
          try { new window.ResizeObserver(schedulePageMetrics).observe(headerEl); } catch (error) { /* ignore */ }
        }
      }
      if (document.fonts && document.fonts.ready && document.fonts.ready.then) {
        document.fonts.ready.then(schedulePageMetrics).catch(function () { /* ignore */ });
      }
    }

    if (mobileAskButton) {
      mobileAskButton.addEventListener('click', function () {
        var input = isChatting
          ? root.querySelector('[data-cap-ai-chat-input]')
          : root.querySelector('[data-cap-ai-input]');
        var target = isChatting && chat ? chat : welcome;

        // Viewport-fit chat: the panel is already on screen, so never scroll
        // the window — re-pin the list and hand focus to the composer.
        if (isChatting && isPageSurface) {
          alignPageToChat();
          scrollMessages(true);
          if (input) {
            try { input.focus({ preventScroll: true }); } catch (error) { input.focus(); }
          }
          return;
        }

        if (target && target.scrollIntoView) {
          target.scrollIntoView({
            behavior: 'smooth',
            block: 'center'
          });
        }

        if (input) {
          window.setTimeout(function () {
            input.focus();
          }, 220);
        }
      });
    }

    // The greeting teaches how to use the consultant (merchant 2026-09-15: the
    // long helper panel was "crammed", "every second matters" - say it here,
    // briefly). The first two sentences are fixed: probes, the worker's
    // GREETING_LINE_RE and the lead transcript key on them.
    var GREETING_BASE = 'Welcome to Capucinne. I am your personal jewelry consultant. Tell me what you have in mind: an engagement ring, wedding band, gift or custom design, and any gemstone, style, color, price range or occasion. Ask naturally, as you would in our store. Unsure where to begin? Tap a prompt below';
    var GREETING_SEARCH_TAIL = ', or browse with the search field at the top.';

    // The header search field is hidden on phones on this page (<= 767px), so
    // the greeting points at it only when a search form is actually on screen.
    function headerSearchVisible() {
      var forms = document.querySelectorAll('form.capucinne-site-header__search');
      for (var i = 0; i < forms.length; i++) {
        if (forms[i].getClientRects().length && forms[i].offsetHeight > 0) return true;
      }
      return false;
    }

    function greetingText() {
      return GREETING_BASE + (headerSearchVisible() ? GREETING_SEARCH_TAIL : '.');
    }
    // How long the greeting "types" (the is-loading dots bubble) before the
    // text is revealed in place — long enough to read as a chat starting, short
    // enough never to feel like waiting.
    var GREETING_TYPING_MS = 450;

    function openChat(options) {
      if (isChatting) return;
      isChatting = true;
      root.classList.add('is-chatting');
      if (welcome) welcome.hidden = true;
      if (chat) chat.hidden = false;
      if (messages) messages.innerHTML = '';
      stickToBottom = true;
      // Viewport-fit page: the chat now fills the viewport below the header, so
      // the window belongs at the top (the list is the scroller from here on).
      alignPageToChat();
      syncChatLock();

      if (!options || options.showWelcome !== false) {
        showGreeting();
      }

      // Once a chat is open, watch for a human teammate taking over this thread.
      startTakeoverPolling();
    }

    // Greeting entrance: the chat starts like a conversation — the assistant
    // "types" (the same is-loading dots as a pending reply) for a beat, then the
    // greeting text swaps in with the usual answer reveal. Reduced motion gets
    // the text instantly. restoreConversation never calls this.
    // The first send waits for this so the conversation reads in order:
    // the consultant finishes writing its greeting, THEN the shopper's message
    // appears, THEN the reply is composed (merchant 2026-09-03: it all popped
    // in at once). Resolved immediately for restored chats / reduced motion.
    var greetingReady = Promise.resolve();
    var GREETING_WORD_MS = 24;

    function showGreeting() {
      if (prefersReducedMotion()) {
        addMessage('assistant', greetingText());
        return;
      }
      var pending = addMessage('assistant', '...', { loading: true });
      greetingReady = new Promise(function (resolve) {
        window.setTimeout(function () {
          if (!pending || !pending.isConnected) { resolve(); return; }
          typeAssistantText(pending, greetingText(), resolve);
        }, GREETING_TYPING_MS);
      });
    }

    // Word-by-word typewriter for a presentation-only assistant line (the
    // greeting): swaps the typing dots for the text as it is "written", then
    // hands the finished bubble to the normal renderer. Never used for backend
    // turns, never touches history.
    function typeAssistantText(message, text, done) {
      var bubble = message && message.querySelector ? message.querySelector('.cap-ai-consultant__bubble') : null;
      if (!bubble) { if (done) done(); return; }
      message.classList.remove('is-loading');
      message.classList.remove('is-thinking-ack');
      bubble.removeAttribute('aria-label');
      bubble.textContent = '';
      var words = String(text || '').split(/\s+/).filter(Boolean);
      var i = 0;
      var p = document.createElement('p');
      p.className = 'is-typing-out';
      bubble.appendChild(p);
      (function step() {
        if (!message.isConnected) { if (done) done(); return; }
        if (i >= words.length) {
          bubble.textContent = '';
          renderAnswer(bubble, text);
          bubble.classList.add('is-answer-reveal');
          scrollMessages();
          if (done) done();
          return;
        }
        p.textContent += (i ? ' ' : '') + words[i];
        i += 1;
        scrollMessages();
        window.setTimeout(step, GREETING_WORD_MS);
      })();
    }

    // Swap a typing-state assistant bubble for final text with the existing
    // reveal (is-answer-reveal fade). Presentation only: no history, no voice,
    // no fallback link — the greeting is not a backend turn.
    function revealAssistantText(message, text) {
      var bubble = message && message.querySelector ? message.querySelector('.cap-ai-consultant__bubble') : null;
      if (!bubble) return;
      message.classList.remove('is-loading');
      message.classList.remove('is-thinking-ack');
      bubble.removeAttribute('aria-label');
      bubble.textContent = '';
      renderAnswer(bubble, text);
      bubble.classList.add('is-answer-reveal');
      scrollMessages();
    }

    function restoreConversation() {
      if (!history.length) return;
      isRestoring = true;
      openChat({ showWelcome: false });
      // The page thread always opens with the consultant's greeting; a
      // restored thread replays it too (in place, no animation) so it never
      // starts with the shopper's own message (merchant iPhone test).
      if (isPageSurface) addMessage('assistant', greetingText(), { restored: true });
      history.forEach(function (entry) {
        var role = entry.role === 'assistant' ? 'assistant' : 'user';
        // Restored turns are marked so they render in place without the
        // entrance animations (a replayed thread is not a live conversation).
        var row = addMessage(role, entry.content || '', { restored: true });
        // The reply's link buttons (video call, contact ...) come back with it.
        if (role === 'assistant' && Array.isArray(entry.links) && entry.links.length) {
          try { renderLinkRow(row, entry.links); } catch (error) { /* the text is restored regardless */ }
        }
        // Re-render the product cards that were shown with this turn so a chat
        // started in the header search modal keeps its images when the shared
        // session is restored on the consultant page.
        if (role === 'assistant' && Array.isArray(entry.recommendations) && entry.recommendations.length) {
          renderRecommendations(entry.recommendations, entry.browse);
        } else if (role === 'assistant' && entry.browse && entry.browse.url) {
          // A card-less turn's "View all matching ..." button comes back too.
          renderBrowseRow(entry.browse);
        }
      });
      isRestoring = false;
      scrollMessages(true);
      // The replayed carousels finish laying out a beat later (count line,
      // arrows); re-pin after those settle so a restored thread opens at its
      // latest turn. Both honour the stick flag.
      window.setTimeout(function () { scrollMessages(); }, 450);
      window.setTimeout(function () { scrollMessages(); }, 1300);
    }

    function saveConversation() {
      if (!conversationStore) return;
      conversationStore.save({
        conversationId: conversationId,
        history: history,
        cartId: cartId,
        checkoutUrl: checkoutUrl
      });
    }

    restoreConversation();

    // Immediate conversation (merchant 2026-09-03): the consultant PAGE opens
    // straight into the chat — the greeting types out the moment the page is
    // on screen, the theme's starter prompts become tappable chips under it,
    // and on desktop the composer already has focus, so the shopper can start
    // typing without a click or a scroll. A restored thread is already open
    // (no greeting); the header-modal embed keeps its welcome card.
    function showStarterPrompts() {
      if (!isChatting || !messages) return;
      if (messages.querySelector('.cap-ai-consultant__message--user')) return;
      var labels = [];
      Array.prototype.forEach.call(promptButtons, function (button) {
        var prompt = (button.getAttribute('data-prompt') || button.textContent || '').trim();
        if (prompt) labels.push(prompt);
      });
      if (!labels.length) return;
      addQuickReplies(null, labels, { limit: 5, event: 'prompt_click', starter: true });
    }

    // Focus only where a caret is welcome: a keyboard/mouse device. On touch
    // devices a programmatic focus would pop the keyboard over the greeting.
    function focusComposerOnEntry() {
      if (!isPageSurface) return;
      var fine = false;
      try { fine = !!(window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches); } catch (error) { fine = false; }
      if (!fine) return;
      var input = root.querySelector('[data-cap-ai-chat-input]');
      if (!input) return;
      try { input.focus({ preventScroll: true }); } catch (error) { try { input.focus(); } catch (e) { /* ignore */ } }
    }

    // START OVER (merchant 2026-09-04: "there should be a reset button, maybe /
    // if the conversation is too long it gets confused"). Clears the thread,
    // the saved session and this turn's working state, then reopens exactly
    // where a first-time visitor lands: the greeting and the starter prompts on
    // the page, the welcome card in the header modal. Consent decisions (an
    // email already shared, an offer explicitly declined) are deliberately KEPT
    // - a fresh conversation is not a reason to ask for them again - and so is
    // the shopper's real cart.
    var RESET_CONFIRM_MS = 4000;
    var resetConfirmTimer = null;

    function clearResetConfirm() {
      if (resetConfirmTimer) window.clearTimeout(resetConfirmTimer);
      resetConfirmTimer = null;
      Array.prototype.forEach.call(root.querySelectorAll('[data-cap-ai-reset]'), function (button) {
        button.classList.remove('is-confirming');
        var label = button.querySelector('span');
        if (label) label.textContent = 'Start over';
        button.setAttribute('aria-label', 'Start a new conversation');
        var header = button.closest('.cap-ai-consultant__chat-header');
        if (header) header.classList.remove('is-reset-confirming');
      });
    }

    function armResetConfirm(button) {
      resetConfirmTimer = window.setTimeout(clearResetConfirm, RESET_CONFIRM_MS);
      Array.prototype.forEach.call(root.querySelectorAll('[data-cap-ai-reset]'), function (other) {
        other.classList.toggle('is-confirming', other === button);
      });
      var label = button.querySelector('span');
      // Two words: on a 320px phone the longer "Tap again to reset" ran into
      // the chat title (UX walkthrough 2026-09-06). The aria-label keeps the
      // full sentence; the header hides its status/subtitle while armed.
      if (label) label.textContent = 'Tap again';
      button.setAttribute('aria-label', 'Tap again to start a new conversation');
      var header = button.closest('.cap-ai-consultant__chat-header');
      if (header) header.classList.add('is-reset-confirming');
    }

    function resetConversation(options) {
      var silent = !!(options && options.silent);
      clearResetConfirm();
      if (!silent) trackAiEvent('conversation_reset', {});

      // Close the OLD thread properly before letting go of it: the CRM keeps
      // the finished transcript, and a live voice session belonged to it.
      // Takeover polling is left running - it reads conversationId at poll
      // time, so it simply follows the new one.
      if (!silent) { try { sendLeadCloseBeacon(); } catch (error) { /* the thread is going anyway */ } }
      if (voiceSession && voiceSession.stop) { try { voiceSession.stop(); } catch (error) { /* ignore */ } }

      history = [];
      // A reply still on its way, and anything waiting for it, belong to the
      // old thread (completeAssistant drops that reply when it lands).
      activeReply = null;
      queuedTurns = [];
      conversationId = 'cap-ai-' + Date.now().toString(36) + '-' + Math.random().toString(36).slice(2, 8);
      lastUserQuery = '';
      leadRecTurns = 0;
      discountChainPending = false;
      stickToBottom = true;
      lastAutoScrollTop = -1;
      if (searchState) searchState.lastQuery = '';
      takeoverCursor = '';
      takeoverSeen = {};
      takeoverNoticeShown = false;
      takeoverWasPaused = false;
      writeDraft('');
      if (conversationStore && conversationStore.clear) { try { conversationStore.clear(); } catch (error) { /* ignore */ } }
      saveConversation();

      if (messages) messages.innerHTML = '';
      if (recommendations) recommendations.hidden = true;
      Array.prototype.forEach.call(root.querySelectorAll('input[type="search"], ' + COMPOSER_FIELDS), function (input) { input.value = ''; });

      isChatting = false;
      root.classList.remove('is-chatting');
      if (chat) chat.hidden = true;

      if (isPageSurface) {
        // The page has no welcome step: come straight back to the greeting.
        openChat();
        greetingReady.then(showStarterPrompts);
        focusComposerOnEntry();
      } else if (welcome) {
        // The header modal keeps its welcome card.
        welcome.hidden = false;
      }
      syncChatLock();

      // BOTH roots share one stored thread. On the consultant page the header
      // modal is mounted too, and a root that still holds the old history would
      // write it straight back on its next save - so tell the other one.
      if (!silent) {
        try {
          document.dispatchEvent(new CustomEvent('capucinne:ai-reset', { detail: { source: root } }));
        } catch (error) { /* one-root pages are unaffected */ }
      }
    }

    document.addEventListener('capucinne:ai-reset', function (event) {
      if (event && event.detail && event.detail.source === root) return;
      resetConversation({ silent: true });
    });

    Array.prototype.forEach.call(root.querySelectorAll('[data-cap-ai-reset]'), function (button) {
      button.addEventListener('click', function (event) {
        event.preventDefault();
        if (button.classList.contains('is-confirming')) { resetConversation(); return; }
        // Nothing to lose yet (greeting only) — reset without asking twice.
        if (!history.length) { resetConversation(); return; }
        armResetConfirm(button);
      });
    });

    if (isPageSurface && !isChatting) {
      openChat();
      greetingReady.then(showStarterPrompts);
      focusComposerOnEntry();
    }
    // Record this page into the per-session viewed-pages trail (de-duped, capped)
    // so the dashboard can show where the shopper has been. Best-effort only.
    recordPageView();
    // Kick off a live cart snapshot so the first message already carries it. The
    // result is cached; sendMessage refreshes it opportunistically.
    refreshCartSnapshot();
    // Surface session start.
    trackAiEvent('consultant_opened', {});

    // Deep-link handoff (?q=) is for the consultant page
    // (/pages/capucinne-consultant?q=...). CLASSIC search results pages carry
    // ?q= for the native search — auto-sending that here injected every classic
    // search into the AI conversation uninvited.
    (function () {
      if (window.location.pathname.indexOf('/search') !== -1) return;
      var initialQuery = '';
      try {
        initialQuery = (new URLSearchParams(window.location.search).get('q') || '').trim();
      } catch (error) {
        initialQuery = '';
      }
      if (initialQuery) {
        window.setTimeout(function () {
          sendMessage(initialQuery, true);
        }, 60);
      }
    })();

    // Proactive nudges (Tidio-style "Need help choosing the right ring?"). Fully
    // additive + fail-safe: fetches merchant-configured rules from the Worker and
    // shows a subtle, dismissible teaser when a trigger matches. Any error or
    // empty rule set => nothing happens and the normal chat is unaffected.
    initProactive();

    // ONE REPLY AT A TIME (audit ISS-45, 2026-09-28): two messages sent a few
    // seconds apart fired two requests with their own history snapshots, both
    // replies asked the same question and the thread was stored out of order.
    // A message sent while a reply is still coming shows in the chat at once
    // but waits here; when the reply lands, everything that waited goes out as
    // ONE follow-up turn whose history already holds that reply. The composer
    // stays usable (Enter sends, Shift+Enter adds a line); chips, starter
    // prompts, voice and Try again all come through sendMessage too.
    var activeReply = null;
    var queuedTurns = [];

    function sendMessage(message, requestAnswer, meta) {
      if (!message) return;
      // The message is now committed to the conversation — drop the saved draft
      // so a later close/reopen does not resurrect already-sent text.
      writeDraft('');
      lastUserQuery = message;
      trackAiEvent('message_sent', { ai_query: message });
      // Opportunistically refresh the cart for the NEXT turn (async, never
      // awaited) so the snapshot tracks add/remove during the conversation.
      refreshCartSnapshot();
      openChat();
      // Sequenced: the greeting finishes writing before this message lands.
      greetingReady.then(function () {
      // When this turn carries a locally-previewed image attachment, render it as
      // a thumbnail inside the shopper's bubble. Purely presentational — the
      // attachments/meta forwarded to the backend are untouched.
      var userRow = addMessage('user', message, (meta && meta.preview) ? { attachment: meta.preview } : null);
      // The shopper answered by typing: the chips under the previous turn are
      // done (a tapped chip removes its own row before calling in here).
      clearQuickReplies();

      if (recommendations && recommendations.children.length) {
        recommendations.hidden = false;
      }

      if (!requestAnswer) return;

      // A reply is still on its way: this message waits for it (drainQueuedTurns).
      if (activeReply) {
        queuedTurns.push({ message: message, meta: meta, row: userRow });
        return;
      }
      requestReply(message, meta);
      });
    }

    // Send everything that waited for the reply that just landed. The waiting
    // bubbles move below that reply's cards and buttons first, so the thread
    // reads in order. Only one photo goes per turn: a second one waits for
    // the next reply.
    function drainQueuedTurns() {
      if (activeReply || !queuedTurns.length) return;
      var group = [queuedTurns.shift()];
      var hasImage = !!(group[0].meta && group[0].meta.image);
      while (queuedTurns.length) {
        var nextHasImage = !!(queuedTurns[0].meta && queuedTurns[0].meta.image);
        if (nextHasImage && hasImage) break;
        hasImage = hasImage || nextHasImage;
        group.push(queuedTurns.shift());
      }
      if (messages) {
        group.concat(queuedTurns).forEach(function (item) {
          if (item.row && item.row.isConnected) messages.appendChild(item.row);
        });
      }
      // Chips under the reply that landed answer a question the shopper has
      // already moved past.
      clearQuickReplies();
      var meta = {};
      group.forEach(function (item) {
        if (!item.meta || typeof item.meta !== 'object') return;
        Object.keys(item.meta).forEach(function (key) {
          if (key !== 'preview') meta[key] = item.meta[key];
        });
      });
      requestReply(group.map(function (item) { return item.message; }).join('\n'), meta);
    }

    function settleReply(pending) {
      if (!activeReply || activeReply !== pending) return;
      activeReply = null;
      drainQueuedTurns();
    }

    function requestReply(message, meta) {
      // Thinking-first: the instant the shopper sends, append an assistant ACK
      // bubble with a short, rotating, on-brand line plus a subtle thinking
      // indicator — so the experience acknowledges immediately (Sidekick-style)
      // instead of showing bare dots. When the real answer arrives, updateMessage
      // replaces this in place. Fully client-side + fail-safe (see addMessage).
      var pending = addMessage('assistant', '...', {
        loading: true,
        ack: nextAckLine()
      });
      activeReply = pending;
      // A failed photo turn retries WITH its photo, never as bare text.
      var retryMeta = uploadRetryMeta(meta);

      // Snapshot prior turns for the backend, then record this user turn so the
      // next request carries full conversation context (e.g. "show me images of
      // it" can resolve the piece discussed earlier).
      var priorHistory = history.slice(-HISTORY_CAP); // the whole conversation, not a window
      history.push({ role: 'user', content: message, at: Date.now() });
      saveConversation();

      if (!endpoint) {
        window.setTimeout(function () {
          runFallback(message, pending, { searchLink: true, retryMeta: retryMeta });
        }, 200);
        return;
      }

      var requestMeta = {};

      // The AI surface this chat was invoked from (only the consultant page
      // remains since 2026-09-15; the dashboard keeps the field).
      requestMeta.ai_surface = AI_SURFACE;

      // Identity (logged-in shopper) on every turn so the dashboard can show
      // who is chatting. Empty object for guests — nothing is added.
      Object.keys(customerMeta).forEach(function (key) {
        requestMeta[key] = customerMeta[key];
      });

      // The market's rate and country (Ivan 2026-10-26): the consultant reads
      // budgets, and writes its chips and amounts, in the shopper's currency.
      var market = marketMeta();
      if (market.currency_rate) requestMeta.currency_rate = market.currency_rate;
      if (market.country) requestMeta.country = market.country;

      // Live cart (with product images) + formatted total, and the per-session
      // page trail. All best-effort: absent/empty values are simply omitted so
      // the request is never delayed or broken by capture.
      if (cartSnapshot.cart && cartSnapshot.cart.length) {
        requestMeta.cart = cartSnapshot.cart;
        if (cartSnapshot.cart_total) requestMeta.cart_total = cartSnapshot.cart_total;
      }
      var viewedPages = getViewedPages();
      if (viewedPages.length) requestMeta.viewed_pages = viewedPages;

      if (meta && typeof meta === 'object') {
        Object.keys(meta).forEach(function (key) {
          // `preview` is a presentational, local object-URL used only to render
          // the shopper's image thumbnail in the transcript. It is never part of
          // the backend contract, so keep it out of the request meta (the photo
          // itself travels as `image`, a stored copy's URL in `attachments`).
          if (key === 'preview') return;
          requestMeta[key] = meta[key];
        });
      }

      if (cartId) requestMeta.cart_id = cartId;
      if (checkoutUrl) requestMeta.checkout_url = checkoutUrl;

      var payload = {
        message: message,
        conversation_id: conversationId,
        history: priorHistory,
        shop_domain: shopDomain,
        locale: locale,
        currency: currency || marketCurrencyCode(),
        cart_id: cartId,
        checkout_url: checkoutUrl,
        meta: requestMeta
      };

      fetch(buildRequestEndpoint(endpoint, payload), {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(payload)
      })
        .then(function (response) {
          if (!response.ok) throw responseError(response, 'AI endpoint returned');
          return response.json();
        })
        .then(function (data) {
          rememberCommerceState(data);
          // Execute any client-side cart actions the AI emitted this turn against
          // the REAL Online Store cart (/cart/add.js, /cart/change.js), then
          // refresh the snapshot + header count and render an in-chat
          // confirmation. Fully wrapped + fail-safe: a cart-action failure can
          // never disturb the answer/recommendations rendered below.
          runCartActions(data && data.cart_actions);
          var answer = data.answer || data.message || data.content || data.text;
          if (window.CapucinneAISearch && window.CapucinneAISearch.cleanAnswer) {
            answer = window.CapucinneAISearch.cleanAnswer(answer);
          }
          var recs = data.recommendations || data.products;
          var isFallbackMode = data && data.mode === 'fallback';
          var hasRecs = Array.isArray(recs) && recs.length;

          // A human teammate has taken over: do NOT render an AI answer. Show a
          // brief hand-off note and keep polling for the specialist's reply.
          if (data && data.mode === 'paused') {
            completeAssistant(pending, 'Your message has been sent to a Capucinne specialist — they will reply right here.', message, { fallbackLink: false }, function () {});
            startTakeoverPolling();
            return;
          }

          // Only trust the backend reply when it is a real AI answer.
          if (answer && !isFallbackMode) {
            completeAssistant(pending, answer, message, {
              fallbackLink: !hasRecs,
              searchQuery: getServerSearchQuery(message, data),
              recommendations: recs,
              browse: data.browse,
              links: data.links
            }, function () {
              renderRecommendations(recs, data.browse);
              addQuickReplies(message, data.quick_replies || data.suggestions);
              revealLatestReply(pending);
            });
            return;
          }

          // mode:"fallback" (Claude/MCP unavailable) or an empty reply: stay
          // conversational. The worker's own fallback copy + quick replies are
          // already discovery-shaped, so they are preferred when present. The
          // store-search link is offered only on an OPENING turn — mid-thread
          // (e.g. clarifying a cart add, "14k white gold 6 1/2") a keyword link
          // would derail the conversation.
          runFallback(message, pending, {
            serverFallback: (answer || (data && data.quick_replies))
              ? { answer: answer, quickReplies: data.quick_replies || data.suggestions, links: data.links }
              : null,
            searchLink: !priorHistory.length,
            retryMeta: retryMeta
          });
        })
        .catch(function (error) {
          runFallback(message, pending, { challenge: !!(error && error.challenge), searchLink: true, retryMeta: retryMeta });
        });
    }

    // Fallback turn: the AI request failed (network, 5xx, a Cloudflare bot
    // challenge) or the backend answered mode:"fallback". This NEVER runs a
    // local product search and never renders a carousel — the merchant's flow
    // is discovery -> recommendation -> email -> discount, and a keyword-matched
    // product dump ("wife's birthday" -> a men's wedding band) breaks it on the
    // very turn the consultant is unavailable. Instead: the worker's own
    // conversational copy when it sent any, otherwise the discovery-first line
    // (or the reload prompt for a security challenge) with the calm error
    // treatment and a one-tap Try again.
    //
    // options: { serverFallback: {answer, quickReplies, links} | null,
    //            challenge: bool, searchLink: bool, retryMeta: object | null }
    function runFallback(message, pending, options) {
      var opts = options || {};
      var serverFallback = opts.serverFallback;
      var serverAnswer = serverFallback && serverFallback.answer ? String(serverFallback.answer).trim() : '';
      var text, replies, isError;

      if (serverAnswer) {
        text = serverAnswer;
        replies = serverFallback.quickReplies;
        isError = false;
      } else if (opts.challenge) {
        text = CHALLENGE_MESSAGE;
        replies = null;
        isError = true;
      } else {
        text = FALLBACK_MESSAGE;
        replies = FALLBACK_QUICK_REPLIES;
        isError = true;
      }

      // The store-search link is a GET (it passes a bot challenge that blocks
      // POSTs) and is still gated by shouldShowFallbackLink: a genuine product
      // query only, never a clarifying turn or an echoed sentence.
      completeAssistant(pending, text, message, {
        fallbackLink: !!opts.searchLink,
        searchQuery: opts.searchLink ? getSearchQuery(message) : '',
        error: isError,
        retryMessage: isError ? message : '',
        retryMeta: isError ? opts.retryMeta || null : null,
        links: serverAnswer ? serverFallback.links : null
      }, function () {
        if (replies) addQuickReplies(message, replies);
      });
    }

    var FALLBACK_MESSAGE = 'I\'m having a little trouble reaching our consultant right now. Tell me the occasion, the stone or colour you love, and your budget — I\'ll pull the best matches the moment I\'m back.';
    var FALLBACK_QUICK_REPLIES = ['Engagement ring', 'Wedding band', 'A gift', 'For myself'];
    var CHALLENGE_MESSAGE = 'Our security check needs a quick refresh — please reload the page and send that again.';

    function completeAssistant(pending, text, originalQuery, options, onComplete) {
      // The shopper pressed Start over while this reply was on its way: its
      // bubble is gone and it belongs to the old thread, not the new history.
      if (pending && pending.isConnected === false) { settleReply(pending); return; }
      var entry = { role: 'assistant', content: text, at: Date.now() };
      var recs = options && options.recommendations;
      // Persist the products shown with this turn (compactly) so they survive a
      // cross-surface restore (search modal -> consultant page).
      if (Array.isArray(recs) && recs.length) {
        entry.recommendations = recs.slice(0, 6).map(compactRec).filter(function (rec) { return rec.url; });
        // A turn that surfaced products counts toward the lead-capture offers.
        leadRecTurns++;
        window.setTimeout(maybeOfferLead, 1600);
      }
      // Persist the "Browse all …" collection link shown with this turn.
      if (options && options.browse && options.browse.url) {
        entry.browse = { url: String(options.browse.url), label: String(options.browse.label || '') };
      }
      // ...and the worker's link buttons (video call, contact, custom design,
      // size guide), so they come back with a restored thread.
      var links = sanitizeCtaLinks(options && options.links);
      if (links.length) entry.links = links;
      history.push(entry);
      history = history.slice(-HISTORY_CAP);
      saveConversation();
      try {
        updateMessage(pending, text, originalQuery, options, onComplete);
        if (links.length) {
          try { renderLinkRow(pending, links); } catch (error) { /* the answer text stands on its own */ }
        }
      } finally {
        // Whatever happened above, a message that waited for this reply goes out now.
        settleReply(pending);
      }
    }

    // Reduce a recommendation to the few fields needed to re-render its card on
    // restore, normalising whatever shape the AI/fallback returned.
    function compactRec(item) {
      var n = window.CapucinneAISearch && window.CapucinneAISearch.normalizeProduct
        ? window.CapucinneAISearch.normalizeProduct(item, locale, currency)
        : (item || {});
      var out = {
        url: n.url || '',
        image: n.image || '',
        title: n.title || '',
        price: n.price || '',
        label: n.label || ''
      };
      // The metal a card is priced in, so a restored card shows that market price.
      if (item && item.price_metal) out.price_metal = String(item.price_metal);
      return out;
    }

    function rememberCommerceState(data) {
      if (!data || typeof data !== 'object') return;
      if (data.cart_id) cartId = String(data.cart_id);
      if (data.checkout_url) checkoutUrl = String(data.checkout_url);
      saveConversation();
    }

    // "View all matching rings ->" - the strong call to action under the AI's
    // product results (merchant 2026-09-22). The worker attaches { url, label }
    // for the store collection or search that matches the shopper's ask, with
    // their budget as a price filter (merchant 2026-07-31 / 09-04), so the full
    // range is one tap away beyond the ~6 chat cards. It used to be the last
    // tile of the swipe row, which most shoppers never reached.
    function browseCtaCopy(browse) {
      var url = String(browse.url || '');
      var label = String(browse.label || '').replace(/^\s*browse\s+all\s+/i, '').trim();
      var blob = (url + ' ' + label).toLowerCase();
      var noun = 'designs';
      if (/necklace/.test(blob)) noun = 'necklaces';
      else if (/earring/.test(blob)) noun = 'earrings';
      else if (/bracelet/.test(blob)) noun = 'bracelets';
      else if (/wedding[\s-]sets?|ring[\s-]sets?/.test(blob)) noun = 'sets';
      else if (/\bbands?\b|-bands?\b/.test(blob)) noun = 'bands';
      else if (/\/collections\//.test(url) && !/all-products|ready-to-ship/.test(url)) noun = 'rings';
      // "matching designs under $800" / "designs" say nothing the title does not.
      var detail = label.replace(/^(?:matching\s+)?designs\b\s*/i, '').trim();
      if (detail) detail = detail.charAt(0).toUpperCase() + detail.slice(1);
      return { title: 'View all matching ' + noun, detail: detail };
    }

    // One call-to-action shape for the browse button and the worker's link
    // buttons: a title, an optional detail line and a decorative arrow. The
    // visible text is the accessible name; `hint` adds words for screen
    // readers only.
    function buildCtaAnchor(className, href, title, detail, hint) {
      var link = document.createElement('a');
      link.className = className;
      link.href = String(href);
      var text = document.createElement('span');
      text.className = 'cap-ai-consultant__browse-cta-text';
      var titleEl = document.createElement('span');
      titleEl.className = 'cap-ai-consultant__browse-cta-title';
      titleEl.textContent = title;
      text.appendChild(titleEl);
      if (detail) {
        var detailEl = document.createElement('span');
        detailEl.className = 'cap-ai-consultant__browse-cta-detail';
        detailEl.textContent = detail;
        text.appendChild(detailEl);
      }
      if (hint) {
        var hintEl = document.createElement('span');
        hintEl.className = 'visually-hidden';
        hintEl.textContent = ' ' + hint;
        text.appendChild(hintEl);
      }
      // No trailing arrow: it read as an AI-generated button (merchant 2026-10-20).
      link.appendChild(text);
      return link;
    }

    function buildBrowseCta(browse) {
      if (!browse || !browse.url) return null;
      var copy = browseCtaCopy(browse);
      var row = document.createElement('div');
      row.className = 'cap-ai-consultant__browse-cta-row';
      var link = buildCtaAnchor('cap-ai-consultant__browse-cta', browse.url, copy.title, copy.detail);
      link.addEventListener('click', function () {
        trackAiEvent('browse_cta_click', { browse_url: link.getAttribute('href'), ai_query: lastUserQuery });
      });
      row.appendChild(link);
      if (isRestoring) row.classList.add('is-restored');
      return row;
    }

    // LINK BUTTONS UNDER A REPLY (audit ISS-01, 2026-09-28): the worker sends
    // links: [{ kind, label, url }] for the free video call (Calendly), the
    // contact page, custom design or the size guide - the answer text itself
    // never carries a URL. Only https links to capucinne.com or calendly.com
    // are shown; anything else is dropped. At most three per reply.
    // Functions, not var tables: restoreConversation replays saved links
    // before a var initialiser this far down the file has run.
    function ctaLinkLabel(kind) {
      if (kind === 'consultation') return 'Book a free video call';
      if (kind === 'contact') return 'Contact us';
      if (kind === 'custom_design') return 'Design your own piece';
      if (kind === 'size_guide') return 'Find your ring size';
      return '';
    }

    function sanitizeCtaLinks(list) {
      var out = [];
      if (!Array.isArray(list)) return out;
      var seen = {};
      list.forEach(function (item) {
        if (out.length >= 3 || !item || typeof item !== 'object') return;
        var parsed = null;
        try { parsed = new URL(String(item.url || '').trim()); } catch (error) { parsed = null; }
        if (!parsed || parsed.protocol !== 'https:' || parsed.port || parsed.username || parsed.password) return;
        var host = parsed.hostname.toLowerCase();
        if (host !== 'capucinne.com' && host !== 'www.capucinne.com' && host !== 'calendly.com') return;
        if (seen[parsed.href]) return;
        var kind = String(item.kind || '').toLowerCase();
        if (!ctaLinkLabel(kind)) kind = host === 'calendly.com' ? 'consultation' : 'link';
        var label = String(item.label || '').replace(/\s+/g, ' ').trim().slice(0, 60) || ctaLinkLabel(kind);
        if (!label) return;
        seen[parsed.href] = true;
        out.push({ kind: kind, label: label, url: parsed.href });
      });
      return out;
    }

    function isCalendlyUrl(url) {
      try { return new URL(url).hostname.toLowerCase() === 'calendly.com'; } catch (error) { return false; }
    }

    // The video call opens Calendly's booking popup in the page (widget.js is
    // loaded site-wide by layout/theme.liquid). Without it - blocked, or not
    // loaded yet - the link opens the booking page in a new tab. Every other
    // link is an ordinary same-tab link to the store.
    function buildLinkCta(link) {
      var calendly = isCalendlyUrl(link.url);
      var anchor = buildCtaAnchor(
        'cap-ai-consultant__browse-cta cap-ai-consultant__link-cta cap-ai-consultant__link-cta--' + link.kind.replace(/_/g, '-'),
        link.url,
        link.label,
        '',
        calendly ? '(opens the booking calendar)' : ''
      );
      if (calendly) {
        anchor.target = '_blank';
        anchor.rel = 'noopener';
      }
      anchor.addEventListener('click', function (event) {
        trackAiEvent('link_cta_click', { link_kind: link.kind, link_url: link.url, ai_query: lastUserQuery });
        if (!calendly || event.defaultPrevented || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
        var widget = window.Calendly;
        if (!widget || typeof widget.initPopupWidget !== 'function') return;
        event.preventDefault();
        try {
          widget.initPopupWidget({ url: link.url });
        } catch (error) {
          window.open(link.url, '_blank', 'noopener');
        }
      });
      return anchor;
    }

    // Right under the reply text, inside its message row and ahead of any
    // quick-reply chips, so "the button below" is directly below.
    function renderLinkRow(host, links) {
      var list = sanitizeCtaLinks(links);
      if (!list.length || !host || !messages || !messages.contains(host)) return;
      var old = host.querySelector('.cap-ai-consultant__links');
      if (old) old.remove();
      var row = document.createElement('div');
      row.className = 'cap-ai-consultant__links';
      if (isRestoring) row.classList.add('is-restored');
      list.forEach(function (link) { row.appendChild(buildLinkCta(link)); });
      var chips = host.querySelector('.cap-ai-consultant__quick-replies');
      host.classList.add('has-links');
      if (chips) host.insertBefore(row, chips);
      else host.appendChild(row);
      scrollMessages();
    }

    // Card-less turns (e.g. "that's the full in-chat set") get the same button
    // under the answer.
    function renderBrowseRow(browse) {
      var row = buildBrowseCta(browse);
      if (!row || !messages) return;
      messages.appendChild(row);
      scrollMessages();
    }

    // Render AI product recommendations inline after the response, reusing the
    // storefront product-card markup so the consultant CSS styles them.
    function renderRecommendations(list, browse) {
      if (!messages || !Array.isArray(list) || !list.length) {
        if (browse) renderBrowseRow(browse);
        return;
      }

      var row = document.createElement('div');
      row.className = 'cap-ai-consultant__recommendations';
      row.setAttribute('role', 'list');
      row.setAttribute('aria-label', 'Recommended products');

      list.slice(0, 8).forEach(function (item, index) {
        var normalized = window.CapucinneAISearch && window.CapucinneAISearch.normalizeProduct
          ? window.CapucinneAISearch.normalizeProduct(item, locale, currency)
          : item;
        var card = buildRecommendationCard(normalized);
        if (!card) return;
        // A non-USD market: the card shows its exact market price (Ivan 2026-10-26).
        if (marketPricing()) {
          applyMarketPrice(card, { url: (normalized && normalized.url) || item.url || '', price: item.price || '', price_metal: item.price_metal || '' });
        }

        // Number each card (1,2,3…) so the shopper can correlate the answer's
        // "#1 / first ring" with the first card and pick by number ("add #1").
        // The CSS agent styles .cap-home-product-card__num. Position is its
        // visual rank in this row (index+1), matching the answer's numbering.
        addCardPositionBadge(card, index + 1);

        card.style.animationDelay = (index * 70) + 'ms';
        row.appendChild(card);
        trackRecommendationClick(card, normalized, index);
        // CARD = PRODUCT PAGE, "CHOOSE OPTIONS" = IN-CHAT CART CARD (merchant
        // 2026-09-22): the photo, the title and the rest of the card open the
        // product page like any shop listing; only the button opens the metal /
        // size / Add to cart card here in the chat. The arrows on the photo page
        // through the piece's other photos without leaving the chat.
        wireCardOptions(card, normalized);
        wireCardGallery(card, normalized);

        // Only enrich cards that arrived without an image (sparse AI
        // recommendations carrying just a handle/title). Cards that already
        // have an image are final, so skip the extra /products/X.js fetch — that
        // double render is what made the results row flicker as each card was
        // rebuilt. Cards without an image show a shimmer placeholder while the
        // real image loads; if it never resolves the placeholder simply stays,
        // so a recommendation is never silently dropped.
        var needsHydration = (!normalized || !normalized.image) &&
          window.CapucinneAISearch && window.CapucinneAISearch.hydrateProduct;

        if (needsHydration) {
          window.CapucinneAISearch.hydrateProduct(normalized, locale, currency).then(function (hydrated) {
            // Swap the real image INTO the existing placeholder rather than
            // rebuilding the whole card — keeps position/animation stable and
            // avoids flicker. Keep the shimmer placeholder if no image resolved.
            if (hydrated && hydrated.image) {
              setCardImage(card, hydrated.image, hydrated.title || (normalized && normalized.title));
              scrollMessages();
            }
          }).catch(function () {
            // Network failure: leave the tasteful placeholder in place.
          });
        }
      });

      if (!row.children.length) {
        if (browse) renderBrowseRow(browse);
        return;
      }
      var carousel = buildRecommendationCarousel(row);
      // A replayed carousel renders in place — no entrance animation.
      if (isRestoring) carousel.classList.add('is-restored');
      messages.appendChild(carousel);
      var browseCta = buildBrowseCta(browse);
      if (browseCta) messages.appendChild(browseCta);
      trackAiEvent('recommendation_impression', { item_count: row.children.length, ai_query: lastUserQuery });
      scrollMessages();
    }

    // "Choose options" -> the add-to-cart options picker, right here in the chat
    // (Ivan 2026-09-17, merchant 2026-09-22). A click immediately drops a
    // "Loading options..." placeholder at the bottom and smooth-scrolls the chat
    // to it; the picker then fades in in its place and takes keyboard focus. A
    // second click on the same piece glides back to its open picker instead of
    // adding another. Everything else on the card - the photo, the title, the
    // price - opens the product page (a shopper who clicks the photo expects the
    // product and its photos); ctrl/cmd/middle click opens it in a new tab. The
    // handle comes from the card's own URL (never guessed); the picker is the
    // one add_to_cart uses.
    function wireCardOptions(card, product) {
      if (!card || !product) return;
      var url = String(product.url || '');
      var handle = url.replace(/[?#].*$/, '').replace(/\/+$/, '').split('/').pop() || '';
      if (!handle) return;
      var title = String(product.title || '');
      var choose = null;
      var content = card.querySelector('.cap-home-product-card__content');
      if (content) {
        choose = document.createElement('button');
        choose.type = 'button';
        choose.className = 'cap-home-product-card__options';
        choose.textContent = 'Choose options';
        choose.setAttribute('aria-label', 'Choose options for ' + (title || 'this piece'));
        content.appendChild(choose);
      }
      card.classList.add('has-options');

      var pending = false;
      function openOptions() {
        trackAiEvent('card_options_open', { ai_product: title.slice(0, 120) });
        var existing = findOpenPicker(handle);
        if (existing) { revealInteraction(existing, true, 'is-revisited'); return; }
        if (pending) return;
        pending = true;
        var placeholder = document.createElement('div');
        placeholder.className = 'cap-ai-consultant__variant-loading';
        placeholder.setAttribute('role', 'status');
        placeholder.setAttribute('aria-live', 'polite');
        placeholder.textContent = 'Loading options' + (title ? ' for ' + title : '') + '…';
        messages.appendChild(placeholder);
        revealInteraction(placeholder, false, '');
        if (choose) { choose.setAttribute('aria-busy', 'true'); }
        renderVariantPicker(handle, title, 1, {
          reveal: true,
          focus: true,
          requestHandle: handle,
          placeholder: placeholder,
          onDone: function () {
            pending = false;
            if (choose) choose.removeAttribute('aria-busy');
            if (placeholder.parentNode) placeholder.parentNode.removeChild(placeholder);
          }
        });
      }

      if (choose) {
        choose.addEventListener('click', function (event) {
          event.preventDefault();
          event.stopPropagation();
          openOptions();
        });
      }

      // The photo and the title are real links. The label, the price and the
      // space around them go to the same page; buttons (Choose options, the
      // photo pager) act on their own. A drag or a text selection (copying a
      // price or a name) is not a click on the card.
      var downX = 0;
      var downY = 0;
      card.addEventListener('pointerdown', function (event) { downX = event.clientX; downY = event.clientY; });
      function cardTarget(event) {
        var target = event.target;
        if (event.defaultPrevented) return false;
        if (target && target.closest && target.closest('a[href], button, .cap-home-product-card__gallery-pager')) return false;
        return true;
      }
      function trackCardClick() {
        trackAiEvent('recommendation_click', {
          product_url: url,
          product_title: title,
          product_price: String(product.price || ''),
          ai_query: lastUserQuery
        });
      }
      card.addEventListener('click', function (event) {
        if (!cardTarget(event)) return;
        if (Math.abs(event.clientX - downX) > 6 || Math.abs(event.clientY - downY) > 6) return;
        var selection = window.getSelection && window.getSelection();
        if (selection && String(selection).trim() && card.contains(selection.anchorNode)) return;
        trackCardClick();
        if (event.metaKey || event.ctrlKey || event.shiftKey) {
          window.open(url, '_blank', 'noopener');
          return;
        }
        window.location.assign(url);
      });
      // Middle click never fires 'click': open the page in a new tab like a link would.
      card.addEventListener('auxclick', function (event) {
        if (event.button !== 1 || !cardTarget(event)) return;
        event.preventDefault();
        trackCardClick();
        window.open(url, '_blank', 'noopener');
      });
    }

    // More photos without leaving the chat (merchant 2026-09-22). Each card gets a
    // small pager at the bottom of its photo - previous, dots, next - sitting
    // beside the photo link, never inside it, and clear of the row's own swipe
    // arrows at mid-height. It appears once the piece's own photos are known:
    // /products/{handle}.js (about 2 KB) is fetched when the card nears the
    // viewport and shared with the options picker. Up to six photos; a piece
    // with one photo shows no controls. A tap on the photo itself still opens
    // the product page. A whole row loads together, the moment it comes near
    // the viewport, so photos are ready on the cards further along it too.
    // No initialisers here: a restored conversation renders its cards before
    // this line runs, and `= null` would throw away the observer it created.
    var galleryObserver;
    function galleryImageKey(src) {
      return String(src || '')
        .replace(/^https?:/, '')
        .replace(/[?#].*$/, '')
        .replace(/_(?:\d+x\d*|\d*x\d+|pico|icon|thumb|small|compact|medium|large|grande|master)(?=\.[a-z0-9]+$)/i, '')
        .toLowerCase();
    }
    function gallerySized(src, width) {
      var out = String(src || '');
      if (out.indexOf('//') === 0) out = 'https:' + out;
      if (!/cdn\.shopify\.com|\/cdn\/shop\//.test(out)) return out;
      out = out.replace(/([?&])width=\d+(&|$)/, '$1').replace(/[?&]$/, '');
      return out + (out.indexOf('?') === -1 ? '?' : '&') + 'width=' + width;
    }
    function galleryChevron(direction) {
      var ns = 'http://www.w3.org/2000/svg';
      var svg = document.createElementNS(ns, 'svg');
      svg.setAttribute('viewBox', '0 0 16 16');
      svg.setAttribute('aria-hidden', 'true');
      svg.setAttribute('focusable', 'false');
      var path = document.createElementNS(ns, 'path');
      path.setAttribute('d', direction === 'prev' ? 'M10 3 5 8l5 5' : 'M6 3l5 5-5 5');
      path.setAttribute('fill', 'none');
      path.setAttribute('stroke', 'currentColor');
      path.setAttribute('stroke-width', '1.8');
      path.setAttribute('stroke-linecap', 'round');
      path.setAttribute('stroke-linejoin', 'round');
      svg.appendChild(path);
      return svg;
    }
    function wireCardGallery(card, product) {
      if (!card || !product) return;
      var url = String(product.url || '');
      var handle = url.replace(/[?#].*$/, '').replace(/\/+$/, '').split('/').pop() || '';
      var media = card.querySelector('.cap-home-product-card__media');
      if (!handle || !media || !media.parentNode) return;
      var title = String(product.title || '') || 'this piece';

      var gallery = document.createElement('div');
      gallery.className = 'cap-home-product-card__gallery';
      media.parentNode.insertBefore(gallery, media);
      gallery.appendChild(media);

      function makeButton(direction) {
        var button = document.createElement('button');
        button.type = 'button';
        button.className = 'cap-home-product-card__gallery-btn cap-home-product-card__gallery-btn--' + direction;
        button.setAttribute('aria-label', (direction === 'prev' ? 'Previous photo of ' : 'Next photo of ') + title);
        button.hidden = true;
        button.appendChild(galleryChevron(direction));
        return button;
      }
      var prev = makeButton('prev');
      var next = makeButton('next');
      var dots = document.createElement('span');
      dots.className = 'cap-home-product-card__gallery-dots';
      dots.setAttribute('aria-hidden', 'true');
      dots.hidden = true;
      var status = document.createElement('span');
      status.className = 'visually-hidden';
      status.setAttribute('aria-live', 'polite');
      var pager = document.createElement('div');
      pager.className = 'cap-home-product-card__gallery-pager';
      pager.hidden = true;
      pager.appendChild(prev);
      pager.appendChild(dots);
      pager.appendChild(next);
      gallery.appendChild(pager);
      gallery.appendChild(status);
      // The pager is a control: taps on it (between the arrows, on the dots)
      // never fall through to the photo link or the card.
      pager.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();
      });

      var photos = [];
      var index = 0;
      var state = 'idle';

      function renderDots() {
        dots.innerHTML = '';
        photos.forEach(function (src, i) {
          var dot = document.createElement('span');
          dot.className = 'cap-home-product-card__gallery-dot' + (i === index ? ' is-active' : '');
          dots.appendChild(dot);
        });
        var many = photos.length > 1;
        pager.hidden = !many;
        prev.hidden = !many;
        next.hidden = !many;
        dots.hidden = !many;
        gallery.classList.toggle('has-photos', many);
      }

      // The shown photo, its dot and the announcement move together, once the
      // photo has actually loaded. A photo that will not load leaves the set and
      // the pager steps on to the next one in the same direction.
      var shown = 0;
      function show(target, direction) {
        var count = photos.length;
        if (count < 2) return;
        var want = (target + count) % count;
        var src = photos[want];
        var probe = new Image();
        probe.onload = function () {
          var at = photos.indexOf(src);
          if (at === -1 || probe.__stale) return;
          var img = media.querySelector('.cap-home-product-card__image');
          if (!img) { setCardImage(card, src, title); img = media.querySelector('.cap-home-product-card__image'); }
          if (img) img.src = src;
          shown = at;
          index = at;
          if (img) img.alt = title + ', photo ' + (at + 1) + ' of ' + photos.length;
          Array.prototype.forEach.call(dots.children, function (dot, i) { dot.classList.toggle('is-active', i === at); });
          status.textContent = 'Photo ' + (at + 1) + ' of ' + photos.length;
          var warm = new Image();
          warm.src = photos[(at + (direction < 0 ? photos.length - 1 : 1)) % photos.length];
        };
        probe.onerror = function () {
          var at = photos.indexOf(src);
          if (at === -1) return;
          photos.splice(at, 1);
          if (shown > at) shown -= 1;
          index = shown;
          if (photos.length < 2) {
            // Down to one photo: hand focus back to the photo before the pager hides.
            if (pager.contains(document.activeElement)) { try { media.focus({ preventScroll: true }); } catch (error) { media.focus(); } }
            renderDots();
            status.textContent = '';
            return;
          }
          renderDots();
          show(direction < 0 ? at - 1 : at, direction);
        };
        if (show.pending) show.pending.__stale = true;
        show.pending = probe;
        probe.src = src;
      }

      function load(then) {
        if (state === 'ready') { if (then) then(); return; }
        if (state === 'loading') return;
        state = 'loading';
        loadProductJson(handle).then(function (data) {
          state = 'ready';
          var list = data && Array.isArray(data.images) ? data.images : [];
          var img = media.querySelector('.cap-home-product-card__image');
          var current = img ? img.getAttribute('src') : '';
          var seen = {};
          var out = [];
          if (current) { out.push(current); seen[galleryImageKey(current)] = true; }
          list.forEach(function (src) {
            var key = galleryImageKey(src);
            if (!key || seen[key]) return;
            seen[key] = true;
            out.push(gallerySized(src, 600));
          });
          photos = out.slice(0, 6);
          index = 0;
          shown = 0;
          if (!img && photos.length) setCardImage(card, photos[0], title);
          renderDots();
          if (then) then();
        });
      }

      function step(delta) {
        return function (event) {
          event.preventDefault();
          event.stopPropagation();
          load(function () { show(shown + delta, delta); });
          trackAiEvent('card_photo_' + (delta > 0 ? 'next' : 'prev'), { ai_product: title.slice(0, 120) });
        };
      }
      prev.addEventListener('click', step(-1));
      next.addEventListener('click', step(1));
      gallery.addEventListener('pointerenter', function () { load(); });
      gallery.addEventListener('focusin', function () { load(); });

      var row = card.parentNode;
      if ('IntersectionObserver' in window && row) {
        if (!galleryObserver) {
          galleryObserver = new IntersectionObserver(function (entries, observer) {
            entries.forEach(function (entry) {
              if (!entry.isIntersecting || !entry.target.__capGalleryLoads) return;
              observer.unobserve(entry.target);
              entry.target.__capGalleryLoads.forEach(function (fn) { fn(); });
            });
          }, { rootMargin: '240px 0px' });
        }
        if (!row.__capGalleryLoads) {
          row.__capGalleryLoads = [];
          galleryObserver.observe(row);
        }
        row.__capGalleryLoads.push(function () { load(); });
      } else {
        load();
      }
    }

    // An options picker already in the chat for this piece (not yet added).
    function findOpenPicker(handle) {
      if (!messages || !handle) return null;
      var pickers = messages.querySelectorAll('.cap-ai-consultant__variant-picker');
      for (var i = pickers.length - 1; i >= 0; i--) {
        var p = pickers[i];
        if (p.getAttribute('data-request-handle') === handle || p.getAttribute('data-handle') === handle) return p;
      }
      return null;
    }

    // Smooth-scroll the MESSAGE LIST (never the window) so an element is fully in
    // view, play its entrance class, and optionally move keyboard focus into it.
    // A deliberate shopper action, so it overrides the "shopper scrolled up,
    // leave them" rule.
    function revealInteraction(el, focus, animationClass) {
      if (!messages || !el || !el.isConnected) return;
      if (animationClass) {
        el.classList.remove('is-revealed', 'is-revisited');
        void el.offsetWidth;
        el.classList.add(animationClass);
      }
      window.requestAnimationFrame(function () {
        if (!el.isConnected) return;
        var listRect = messages.getBoundingClientRect();
        var rect = el.getBoundingClientRect();
        var top = rect.top - listRect.top + messages.scrollTop;
        var target = rect.height > messages.clientHeight - 24
          ? top - 12
          : top + rect.height - messages.clientHeight + 16;
        var maxTop = Math.max(0, messages.scrollHeight - messages.clientHeight);
        target = Math.round(Math.max(0, Math.min(target, maxTop)));
        stickToBottom = target >= maxTop - 2;
        lastAutoScrollTop = target;
        try {
          messages.scrollTo({ top: target, behavior: prefersReducedMotion() ? 'auto' : 'smooth' });
        } catch (error) {
          messages.scrollTop = target;
        }
        if (focus) {
          var control = el.querySelector('select:not([disabled])') || el.querySelector('.cap-ai-consultant__variant-add');
          if (control) {
            try { control.focus({ preventScroll: true }); } catch (error) { /* ignore */ }
          }
        }
      });
    }

    // Wrap the scroll row in a carousel with elegant prev/next arrows so desktop
    // shoppers browse the recommendations like a book. Touch/mobile keep the
    // natural swipe (the arrows are hidden there via CSS).
    function buildRecommendationCarousel(row) {
      var carousel = document.createElement('div');
      carousel.className = 'cap-ai-consultant__carousel';
      var prev = buildCarouselArrow('prev');
      var next = buildCarouselArrow('next');
      carousel.appendChild(prev);
      carousel.appendChild(row);
      carousel.appendChild(next);

      // Say out loud how many designs there are and how to reach the rest.
      // Merchant feedback 2026-07-31: with 5 pieces attached they could not tell
      // more existed past the fold, nor how to get to #5.
      var count = document.createElement('p');
      count.className = 'cap-ai-consultant__carousel-count';
      carousel.appendChild(count);
      var coarsePointer = !!(window.matchMedia && window.matchMedia('(pointer: coarse)').matches);

      function updateCount(overflowing, atEnd) {
        var total = row.querySelectorAll('.cap-home-product-card').length;
        if (!total) { count.textContent = ''; return; }
        var label = total === 1 ? '1 design' : total + ' designs';
        if (overflowing && !atEnd) {
          label += coarsePointer ? ' — swipe for more' : ' — use the side arrows for more';
        }
        count.textContent = label;
      }

      function pageBy(direction) {
        var amount = Math.max(220, Math.round(row.clientWidth * 0.85));
        row.scrollBy({ left: direction * amount, behavior: 'smooth' });
      }
      function refresh() {
        // The carousel can be removed from the DOM (new turn re-renders); stop
        // and release the window listener rather than leak one per carousel.
        if (!row.isConnected) { window.removeEventListener('resize', onResize); window.removeEventListener('orientationchange', onResize); return; }
        var maxScroll = row.scrollWidth - row.clientWidth - 1;
        var overflowing = row.scrollWidth > row.clientWidth + 2;
        // No overflow -> no arrows. Otherwise fade out the one you can't use.
        prev.hidden = !overflowing;
        next.hidden = !overflowing;
        prev.disabled = row.scrollLeft <= 1;
        next.disabled = row.scrollLeft >= maxScroll;
        // Mobile/touch swipe affordance: a soft right-edge fade signals "there's
        // more to see", and clears once the shopper has swiped to the end.
        carousel.classList.toggle('cap-ai-consultant__carousel--overflow', overflowing);
        var atEnd = overflowing && row.scrollLeft >= maxScroll;
        carousel.classList.toggle('cap-ai-consultant__carousel--at-end', atEnd);
        updateCount(overflowing, atEnd);
      }
      prev.addEventListener('click', function () { pageBy(-1); });
      next.addEventListener('click', function () { pageBy(1); });
      row.addEventListener('scroll', refresh, { passive: true });
      // Overflow/arrows/mask depend on viewport width, so recompute on resize and
      // orientation change (debounced); refresh() self-removes this when the row
      // leaves the DOM.
      var resizeRaf = null;
      function onResize() {
        if (resizeRaf) window.cancelAnimationFrame(resizeRaf);
        resizeRaf = window.requestAnimationFrame(refresh);
      }
      window.addEventListener('resize', onResize, { passive: true });
      window.addEventListener('orientationchange', onResize, { passive: true });
      // Recompute as layout settles and as hydrated images change card widths.
      window.requestAnimationFrame(refresh);
      window.setTimeout(refresh, 350);
      window.setTimeout(refresh, 1200);
      // On touch devices, one gentle nudge of the row tells the shopper it is
      // swipeable — only when it actually overflows and sits at the start.
      if (window.matchMedia && window.matchMedia('(pointer: coarse)').matches) {
        window.setTimeout(function () {
          if (row.scrollWidth > row.clientWidth + 2 && row.scrollLeft <= 1) {
            carousel.classList.add('cap-ai-consultant__carousel--hint');
            window.setTimeout(function () { carousel.classList.remove('cap-ai-consultant__carousel--hint'); }, 1500);
          }
        }, 700);
      }
      return carousel;
    }

    function buildCarouselArrow(direction) {
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'cap-ai-consultant__carousel-nav cap-ai-consultant__carousel-nav--' + direction;
      btn.setAttribute('aria-label', direction === 'prev' ? 'Previous recommendations' : 'Next recommendations');
      // Elegant chevron — swap this path for the exact Figma arrow when available.
      // Font Awesome 6 Free chevrons (CC BY 4.0), filled - see the icon snippet.
      btn.innerHTML = direction === 'prev' ? '<svg class="cap-ai-icon" viewBox="0 0 320 512" fill="currentColor" stroke="none" aria-hidden="true" focusable="false"><path d="M9.4 233.4c-12.5 12.5-12.5 32.8 0 45.3l192 192c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L77.3 256 246.6 86.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-192 192z"/></svg>' : '<svg class="cap-ai-icon" viewBox="0 0 320 512" fill="currentColor" stroke="none" aria-hidden="true" focusable="false"><path d="M310.6 233.4c12.5 12.5 12.5 32.8 0 45.3l-192 192c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L242.7 256 73.4 86.6c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l192 192z"/></svg>';
      return btn;
    }

    function buildRecommendationCard(item) {
      if (!item || typeof item !== 'object') return null;

      var url = cleanField(item.url || item.product_url || item.link || item.handle);
      if (url && url.indexOf('http') !== 0 && url.indexOf('/') !== 0) url = '/products/' + url;
      var image = cleanField(item.image || item.image_url || item.featured_image || item.thumbnail || item.imageUrl);
      var title = cleanField(item.title || item.name || item.product_title);
      var price = cleanField(item.price || item.price_text || item.price_range || item.priceRange);
      // Variable pricing reads "Starting at $X" — never a leading "from".
      if (price) price = price.replace(/^\s*from\s+/i, 'Starting at ');
      var label = cleanField(item.label || item.product_type || item.collection || item.vendor);

      // Require something to anchor the card (a link or a title). An image can
      // still arrive later via hydration, so never drop a card just for that.
      if (!url && !title) return null;

      var card = document.createElement('article');
      card.className = 'cap-home-product-card';
      card.setAttribute('role', 'listitem');

      var media = document.createElement(url ? 'a' : 'div');
      media.className = 'cap-home-product-card__media';
      if (url) media.href = url;
      card.appendChild(media);

      if (image) setCardImage(card, image, title);
      else showCardPlaceholder(card);

      var content = document.createElement('div');
      content.className = 'cap-home-product-card__content';

      if (label) {
        var labelEl = document.createElement('p');
        labelEl.className = 'cap-home-product-card__label';
        labelEl.textContent = label;
        content.appendChild(labelEl);
      }

      var titleEl = document.createElement(url ? 'a' : 'p');
      titleEl.className = 'cap-home-product-card__title';
      if (url) titleEl.href = url;
      titleEl.textContent = title || 'View product';
      content.appendChild(titleEl);

      if (price) {
        var priceEl = document.createElement('p');
        priceEl.className = 'cap-home-product-card__price';
        priceEl.textContent = price;
        content.appendChild(priceEl);
      }

      card.appendChild(content);
      return card;
    }

    // Add a small numbered position badge to a recommendation card so the answer
    // can refer to products by number ("the first ring", "#2") and the shopper
    // can match that to the card. Inserted into the media box (over the image) so
    // it reads as a rank marker; the CSS agent styles .cap-home-product-card__num.
    // Idempotent + fail-safe: never added twice, never throws.
    function addCardPositionBadge(card, position) {
      if (!card) return;
      try {
        if (card.querySelector('.cap-home-product-card__num')) return;
        var badge = document.createElement('span');
        badge.className = 'cap-home-product-card__num';
        badge.setAttribute('aria-hidden', 'true');
        badge.textContent = String(position);
        var media = card.querySelector('.cap-home-product-card__media');
        if (media) media.appendChild(badge);
        else card.insertBefore(badge, card.firstChild);
      } catch (error) {
        // Cosmetic only — a failure here never affects the card or the answer.
      }
    }

    // Render (or replace) the product image inside a card's media box. The
    // image starts hidden and only reveals once it has actually loaded, with a
    // shimmer placeholder behind it the whole time — so the shopper never sees a
    // broken-image icon or an empty gap, and a failed load falls back cleanly to
    // the placeholder.
    function setCardImage(card, src, title) {
      if (!card) return;
      var media = card.querySelector('.cap-home-product-card__media');
      if (!media) return;

      showCardPlaceholder(card);
      var placeholder = media.querySelector('.cap-home-product-card__image-placeholder');

      var img = document.createElement('img');
      img.className = 'cap-home-product-card__image';
      img.src = src;
      img.alt = title || 'Product';
      img.loading = 'lazy';
      img.decoding = 'async';
      img.style.opacity = '0';
      img.style.transition = 'opacity 200ms ease';

      img.addEventListener('load', function () {
        img.style.opacity = '1';
        if (placeholder && placeholder.parentNode) placeholder.parentNode.removeChild(placeholder);
      });
      img.addEventListener('error', function () {
        // Broken URL: drop the image and keep the shimmer placeholder.
        if (img.parentNode) img.parentNode.removeChild(img);
        showCardPlaceholder(card);
      });

      media.appendChild(img);
    }

    function showCardPlaceholder(card) {
      if (!card) return;
      var media = card.querySelector('.cap-home-product-card__media');
      if (!media || media.querySelector('.cap-home-product-card__image-placeholder')) return;

      var placeholder = document.createElement('span');
      placeholder.className = 'cap-home-product-card__image-placeholder';
      placeholder.setAttribute('aria-hidden', 'true');
      media.appendChild(placeholder);
    }

    function cleanField(value) {
      if (value === null || value === undefined) return '';
      return String(value).trim();
    }

    // Render the assistant answer as CLEAN prose: paragraphs + numbered/bulleted
    // lists only — never a markdown table, heading, or horizontal rule, and never
    // a raw markdown link / URL. The merchant explicitly wants short, readable
    // answers that reference the product CARDS below by number, not a table dump
    // of titles + links.
    //
    // We deliberately DO NOT delegate to window.CapucinneAIMarkdown.render here:
    // that shared renderer builds <table>/<th>/<td> chrome and __answer-heading /
    // __answer-rule blocks, which is exactly what produced the big table of raw
    // "[Hayley](https://…)" links in the live chat. This self-contained renderer
    // keeps full control of the output. Fully fail-safe: any unexpected input
    // falls back to plain text (see the final guard).
    function renderAnswer(container, text) {
      if (!container) return;

      // Normalise newlines, then drop any GFM table syntax entirely BEFORE we
      // split into blocks. A table row starts with "|"; its divider row is all
      // dashes/colons/pipes. Removing both means a table can never render — and
      // since each cell's content was just markdown anyway, nothing meaningful
      // (other than a layout the merchant rejected) is lost.
      var raw = (text || '').toString().replace(/\r/g, '');
      var keptLines = raw.split('\n').filter(function (line) {
        var t = line.trim();
        if (t.charAt(0) === '|') return false;                 // table cell row
        if (/^\|?\s*:?-{2,}:?(\s*\|\s*:?-{2,}:?)*\s*\|?$/.test(t)) return false; // divider
        return true;
      });
      var value = keptLines.join('\n');
      var blocks = value.split(/\n{2,}/);

      container.textContent = '';

      blocks.forEach(function (block) {
        var trimmed = block.trim();
        if (!trimmed) return;

        var imageMatch = trimmed.match(/^!\[([^\]]*)\]\((https?:\/\/[^)]+)\)$/i);
        if (imageMatch) {
          appendAnswerImage(container, imageMatch[2], imageMatch[1]);
          return;
        }

        var lines = trimmed.split(/\n/).filter(function (line) {
          // Drop heading (#…) and horizontal-rule (---/***/___) lines — the
          // merchant wants no heading/rule chrome in answers. A heading's label
          // is kept as plain text so no copy is lost.
          return line.trim() !== '';
        });
        if (!lines.length) return;

        // Strip leading markdown heading hashes from any line, keeping the label
        // as ordinary text (so "## Options" reads as "Options", not a heading).
        lines = lines.map(function (line) {
          return line.replace(/^\s*#{1,6}\s+/, '');
        }).filter(function (line) {
          // Remove pure horizontal-rule lines outright.
          return !/^\s*(?:-{3,}|\*{3,}|_{3,})\s*$/.test(line);
        });
        if (!lines.length) return;

        var isBulleted = lines.every(function (line) { return /^[-*]\s+/.test(line.trim()); });
        var isNumbered = lines.every(function (line) { return /^\d+[.)]\s+/.test(line.trim()); });

        if ((isBulleted || isNumbered) && lines.length) {
          var list = document.createElement(isNumbered ? 'ol' : 'ul');
          lines.forEach(function (line) {
            var item = document.createElement('li');
            appendInline(item, line.trim().replace(isNumbered ? /^\d+[.)]\s+/ : /^[-*]\s+/, ''));
            list.appendChild(item);
          });
          container.appendChild(list);
          return;
        }

        var paragraph = document.createElement('p');
        lines.forEach(function (line, index) {
          if (index > 0) paragraph.appendChild(document.createElement('br'));
          appendInline(paragraph, line);
        });
        container.appendChild(paragraph);
      });

      if (!container.childNodes.length) {
        // Last-resort: render the value as plain text, but still strip any
        // markdown link syntax down to its label so a raw URL can never appear.
        container.textContent = stripMarkdownLinks(value);
      }
    }

    // Collapse any "[label](url)" / bare-"(url)" markdown link syntax to just the
    // label text. Used only by the plain-text fallback path above; the structured
    // path handles links inline (see appendInline -> plain text).
    function stripMarkdownLinks(value) {
      return String(value || '')
        .replace(/!\[([^\]]*)\]\((?:https?:\/\/[^)]+)\)/gi, '$1')
        .replace(/\[([^\]]+)\]\((?:https?:\/\/[^)]+)\)/gi, '$1');
    }

    function appendInline(container, text) {
      var pattern = /(!\[([^\]]*)\]\((https?:\/\/[^)]+)\)|\[([^\]]+)\]\((https?:\/\/[^)]+)\)|\*\*([^*]+)\*\*|\*([^*\n]+)\*)/gi;
      var cursor = 0;
      var match;

      while ((match = pattern.exec(text)) !== null) {
        if (match.index > cursor) {
          appendTextWithEmails(container, text.slice(cursor, match.index));
        }

        if (match[3]) {
          if (match[2]) container.appendChild(document.createTextNode(match[2]));
        } else if (match[5]) {
          // Render a markdown link as PLAIN TEXT — keep the label, drop the URL —
          // so a raw "[name](url)" or bare URL can NEVER appear in an answer. The
          // shopper follows the product CARDS below (by number) instead.
          container.appendChild(document.createTextNode(match[4]));
        } else if (match[6]) {
          appendStrong(container, match[6]);
        } else if (match[7]) {
          appendEm(container, match[7]);
        }

        cursor = pattern.lastIndex;
      }

      if (cursor < text.length) {
        appendTextWithEmails(container, text.slice(cursor));
      }
    }

    // Render plain text, turning any email address into a clickable mailto link
    // (e.g. info@capucinne.com). Uses textContent + href only — no innerHTML — so
    // there is no injection surface.
    function appendTextWithEmails(container, text) {
      var emailRe = /[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}/g;
      var cursor = 0;
      var match;
      while ((match = emailRe.exec(text)) !== null) {
        if (match.index > cursor) {
          container.appendChild(document.createTextNode(text.slice(cursor, match.index)));
        }
        var link = document.createElement('a');
        link.href = 'mailto:' + match[0];
        link.textContent = match[0];
        link.className = 'cap-ai-consultant__mail-link';
        container.appendChild(link);
        cursor = emailRe.lastIndex;
      }
      if (cursor < text.length) {
        container.appendChild(document.createTextNode(text.slice(cursor)));
      }
    }

    function appendAnswerImage(container, src, alt) {
      var media = document.createElement('figure');
      var image = document.createElement('img');
      media.className = 'cap-ai-consultant__answer-media';
      image.className = 'cap-ai-consultant__answer-image';
      image.src = src;
      image.alt = alt || '';
      image.loading = 'lazy';
      image.decoding = 'async';
      // Don't leave a broken-image icon if the URL fails to load.
      image.addEventListener('error', function () {
        if (media.parentNode) media.parentNode.removeChild(media);
      });
      media.appendChild(image);
      container.appendChild(media);
    }

    function appendStrong(container, text) {
      var strong = document.createElement('strong');
      strong.textContent = text;
      container.appendChild(strong);
    }

    function appendEm(container, text) {
      var em = document.createElement('em');
      em.textContent = text;
      container.appendChild(em);
    }

    // Render a shopper-attached image as a tidy thumbnail inside their bubble.
    // The source is a local object URL (instant, offline-safe); it is revoked
    // once the browser has decoded it so it never leaks. A failed/aborted load
    // simply removes the figure, leaving the caption — the chat is never broken.
    function renderAttachment(bubble, attachment) {
      var figure = document.createElement('figure');
      figure.className = 'cap-ai-consultant__attachment';

      var img = document.createElement('img');
      img.className = 'cap-ai-consultant__attachment-image';
      img.src = attachment.src;
      img.alt = attachment.alt || 'Uploaded inspiration image';
      img.loading = 'lazy';
      img.decoding = 'async';

      var revoke = function () {
        if (attachment.src && attachment.src.indexOf('blob:') === 0 &&
          window.URL && window.URL.revokeObjectURL) {
          try { window.URL.revokeObjectURL(attachment.src); } catch (error) { /* ignore */ }
        }
      };

      img.addEventListener('load', function () {
        revoke();
        scrollMessages();
      });
      img.addEventListener('error', function () {
        revoke();
        if (figure.parentNode) figure.parentNode.removeChild(figure);
      });

      figure.appendChild(img);
      bubble.appendChild(figure);
    }

    // Small typewriter: reveal text one character at a time. Used for the
    // thinking-first acknowledgement so it types out while Claude works. Stops
    // itself if the element is removed (the answer replaces the bubble), and
    // shows the full line instantly under prefers-reduced-motion.
    function typeOut(el, text, speed, done) {
      if (!el) return;
      var value = String(text || '');
      if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        el.textContent = value;
        if (done) done();
        return;
      }
      el.textContent = '';
      var chars = Array.from(value);
      var i = 0;
      var timer = window.setInterval(function () {
        if (!el.isConnected) {
          // Replaced mid-type (the real answer landed): stop quietly, no callback.
          window.clearInterval(timer);
          return;
        }
        if (i >= chars.length) {
          window.clearInterval(timer);
          if (done) done();
          return;
        }
        el.textContent += chars[i];
        i += 1;
      }, speed || 26);
    }

    function addMessage(role, text, options) {
      var message = document.createElement('div');
      var avatar = document.createElement('span');
      var bubble = document.createElement('div');

      message.className = 'cap-ai-consultant__message cap-ai-consultant__message--' + role;
      avatar.className = 'cap-ai-consultant__avatar';
      bubble.className = 'cap-ai-consultant__bubble';

      var ackLine = options && options.loading && options.ack ? String(options.ack) : '';

      if (options && options.loading) {
        message.className += ' is-loading';
        if (ackLine) message.className += ' is-thinking-ack';
        // Announced by the aria-live messages region. When an ack line is shown
        // it carries the real, friendly wording; otherwise the generic "typing".
        bubble.setAttribute('aria-label', ackLine || 'Capucinne Consultant is typing');
      }

      avatar.innerHTML = role === 'assistant'
        ? SPARKLE_SVG
        : USER_SVG;

      if (options && options.loading) {
        // Thinking-first: a short rotating ack line (if provided) above a subtle
        // thinking indicator. The dots reuse the existing typing animation. The
        // ack text is real text content so the aria-live region reads it; the
        // dots are decorative (aria-hidden). Falls back to dots-only if no ack.
        var thinking = document.createElement('span');
        thinking.className = 'cap-ai-consultant__typing';
        thinking.setAttribute('aria-hidden', 'true');
        thinking.innerHTML = '<span></span><span></span><span></span>';

        if (ackLine) {
          var ack = document.createElement('span');
          ack.className = 'cap-ai-consultant__ack';
          bubble.appendChild(ack);
          // Said first, THEN thinking (merchant 2026-09-03): the acknowledgement
          // types out on its own after a short beat, and the three dots appear
          // only once the line has finished — so the consultant reads as having
          // said something and then started working on it. If the real answer
          // lands first, the bubble is replaced and the dots simply never mount.
          var ACK_START_MS = 260;
          window.setTimeout(function () {
            if (!ack.isConnected) return;
            typeOut(ack, ackLine, 55, function () {
              if (!ack.isConnected || !message.isConnected || !message.classList.contains('is-loading')) return;
              thinking.classList.add('is-after-ack');
              bubble.appendChild(thinking);
              scrollMessages();
            });
          }, ACK_START_MS);
        } else {
          bubble.appendChild(thinking);
        }
      } else if (role === 'assistant') {
        renderAnswer(bubble, text);
      } else if (options && options.attachment && options.attachment.src) {
        // Shopper-attached image: show a tidy thumbnail, then a short caption
        // instead of the raw "Uploaded inspiration: file.jpg" filename line.
        bubble.classList.add('cap-ai-consultant__bubble--attachment');
        renderAttachment(bubble, options.attachment);
        var caption = document.createElement('span');
        caption.className = 'cap-ai-consultant__attachment-caption';
        caption.textContent = 'Shared an inspiration image';
        bubble.appendChild(caption);
      } else {
        bubble.textContent = text;
      }

      message.appendChild(avatar);
      message.appendChild(bubble);
      // Restored (replayed) turns skip the entrance animation via CSS.
      if (options && options.restored) message.classList.add('is-restored');
      messages.appendChild(message);

      // The shopper's own message always pins the view to the bottom (and
      // re-arms stick-to-bottom); assistant turns follow only while stuck.
      scrollMessages(role === 'user');
      return message;
    }

    function updateMessage(message, text, originalQuery, options, onComplete) {
      var bubble = message.querySelector('.cap-ai-consultant__bubble');
      if (!bubble) return;

      message.classList.remove('is-loading');
      message.classList.remove('is-thinking-ack');
      message.classList.add('is-streaming');
      bubble.removeAttribute('aria-label');
      // The thinking-first ack + dots live inside this same bubble; clear them so
      // the real answer renders cleanly into a fresh container. renderAnswer also
      // wipes content, but doing it here keeps the transition tidy if the
      // markdown renderer ever early-returns on empty input.
      bubble.textContent = '';

      // Safety net: the caret (CSS on .is-streaming) must never outlive the
      // answer. The reveal/voice path normally calls finish(), but if a long
      // answer stalls (audio never fires onended, synthesis drops the utterance,
      // etc.) clear the streaming flag anyway so the caret can't blink forever.
      var streamingGuard = window.setTimeout(function () {
        message.classList.remove('is-streaming');
      }, 12000);

      var finished = false;
      var finish = function () {
        // Guard against a double finish (e.g. present() completing after the
        // safety timeout already fired) appending the fallback link twice.
        if (finished) return;
        finished = true;
        window.clearTimeout(streamingGuard);
        message.classList.remove('is-streaming');

        // Calm error treatment for a genuine service-down dead-end: tint the
        // bubble and offer a one-tap retry of the same question. Everything else
        // (the store-search fallback link below) still applies, so the shopper
        // is never stranded.
        if (options && options.error) {
          message.classList.add('is-error');
          if (options.retryMessage) appendRetryAction(bubble, options.retryMessage, options.retryMeta);
        }

        var searchQuery = options && options.searchQuery !== undefined
          ? options.searchQuery
          : getSearchQuery(originalQuery);

        // Only offer "View matching products" for a genuine product query — not
        // for a clarifying/conversational turn where the assistant is asking a
        // follow-up question. shouldShowFallbackLink() gates on a real catalog
        // query (stone/metal/category keywords) AND a non-clarifying answer so
        // the link never points at a nonsense search of the echoed sentence.
        var hasRecs = !!(options && Array.isArray(options.recommendations) && options.recommendations.length);
        if (options && options.fallbackLink && shouldShowFallbackLink(searchQuery, originalQuery, text, hasRecs)) {
          var link = document.createElement('a');
          link.className = 'cap-ai-consultant__fallback-link';
          link.href = buildSearchUrl(searchQuery);
          // Generic, semantically-correct copy: it's a store search for the
          // query — works whether the shopper wants products or answers.
          link.textContent = searchQuery
            ? 'Search the store for “' + searchQuery + '”'
            : 'Search the store';
          link.addEventListener('click', function () {
            trackAiEvent('fallback_search_click', { ai_query: searchQuery });
          });
          bubble.appendChild(link);
        }

        scrollMessages();
        if (typeof onComplete === 'function') onComplete();
      };

      // THREE INDEPENDENT PIPELINES — none blocks another.
      //
      // 1) TEXT: always render the answer immediately, the moment it arrives —
      //    never gated behind voice. (Previously, when voice was enabled the
      //    text was routed through voiceSession.present(), so the visible answer
      //    waited on the ElevenLabs audio. That coupling is removed here.)
      renderAnswer(bubble, text);
      // Smooth resolve: fade the freshly-rendered prose in once as it replaces
      // the thinking-first ack. A one-shot class (the CSS animation is `both`),
      // independent of the transient is-streaming flag. No-op under reduced
      // motion (the CSS forces opacity:1, no animation).
      bubble.classList.add('is-answer-reveal');

      // 2) FINISH: paint the error/fallback treatment + fire onComplete (which
      //    renders the recommendation carousel) right after the text paints — in
      //    the same tick, NOT awaiting any audio.
      finish();

      // 3) VOICE: start spoken playback on its OWN track, in parallel, only when
      //    spoken responses are on. speak() owns audio (+ an optional subtle word
      //    highlight) ONLY — it never re-renders or delays the text above. If it
      //    can't play (sound off, no audio, any error) the rendered text stands.
      if (voiceSession && voiceSession.speak) {
        try {
          voiceSession.speak(text, function () {
            clearSpokenProgress(bubble);
          }, bubble);
        } catch (error) {
          // Audio is best-effort; the visible answer is already complete.
        }
      }
    }

    // The voice-progress "wash" (word-by-word tint tracking the audio) was
    // removed by request; the answer text stands on its own while audio plays.
    // This now only defensively clears any stale highlight state from a prior
    // build. Kept as a no-op cleanup called when speech starts.
    function clearSpokenProgress(bubble) {
      if (!bubble) return;
      try {
        bubble.classList.remove('is-voice-reading');
        bubble.style.removeProperty('--cap-ai-voice-progress');
      } catch (error) {
        /* cosmetic cleanup; ignore */
      }
    }

    // Append a "Try again" button to a failed assistant turn. Tapping it re-asks
    // the same question (the normal sendMessage path), so a transient outage can
    // recover without the shopper retyping. Removed once tapped. A photo turn
    // (retryMeta) is asked again WITH the same photo.
    function appendRetryAction(bubble, retryMessage, retryMeta) {
      var action = document.createElement('div');
      action.className = 'cap-ai-consultant__error-actions';

      var button = document.createElement('button');
      button.type = 'button';
      button.className = 'cap-ai-consultant__retry';
      button.innerHTML = '<svg class="cap-ai-icon" viewBox="0 0 512 512" fill="currentColor" stroke="none" aria-hidden="true" focusable="false"><path d="M463.5 224H472c13.3 0 24-10.7 24-24V72c0-9.7-5.8-18.5-14.8-22.2s-19.3-1.7-26.2 5.2L413.4 96.6c-87.6-86.5-228.7-86.2-315.8 1c-87.5 87.5-87.5 229.3 0 316.8s229.3 87.5 316.8 0c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0c-62.5 62.5-163.8 62.5-226.3 0s-62.5-163.8 0-226.3c62.2-62.2 162.7-62.5 225.3-1L327 183c-6.9 6.9-8.9 17.2-5.2 26.2s12.5 14.8 22.2 14.8H463.5z"/></svg><span>Try again</span>';
      button.addEventListener('click', function () {
        trackAiEvent('retry_click', { ai_query: retryMessage });
        action.remove();
        sendMessage(retryMessage, true, retryMeta || undefined);
      });

      action.appendChild(button);
      bubble.appendChild(action);
    }

    // Decide whether the "View matching products" fallback link is meaningful
    // for this turn. It is shown ONLY when the derived query is a real product
    // query (a recognised product/stone/metal/category keyword) AND the turn is
    // not just a clarifying question. So a prompt like "perfect engagement ring"
    // — where the assistant asks follow-ups and returns no products — does NOT
    // get a link pointing at a nonsense search of the echoed sentence.
    function shouldShowFallbackLink(searchQuery, originalQuery, answerText, hasRecs) {
      var query = String(searchQuery || '').trim();
      if (!query) return false;

      // The link is a generic STORE SEARCH for the query (not "products"), so it
      // is valid for non-product asks too (policies, order help, etc.) — it just
      // must not appear on a clarifying turn or a bare echoed sentence below.

      // Reject the case where deriveQuery just returned the whole conversational
      // sentence verbatim (no real keyword extraction happened).
      var echoed = String(originalQuery || '').trim().toLowerCase();
      if (echoed && query.toLowerCase() === echoed && query.split(/\s+/).length > 4) {
        return false;
      }

      // A store-search link must read like a store search: the query has to
      // contain at least one recognised jewelry keyword (category, stone,
      // metal, occasion). Conversational residue that survives stopword
      // stripping ("instagram", "ring later" → "later") never qualifies.
      if (!/(jewel|ring|band|necklace|pendant|earring|bracelet|charm|chain|stone|gem|diamond|sapphire|emerald|ruby|opal|moissanite|topaz|tourmaline|tanzanite|amethyst|aquamarine|garnet|peridot|citrine|pearl|onyx|agate|alexandrite|morganite|quartz|gold|platinum|silver|engagement|wedding|bridal|eternity|anniversary|birthstone|gift)/.test(query.toLowerCase())) {
        return false;
      }

      // If the assistant is asking a clarifying follow-up (the answer reads as a
      // question) and surfaced no products this turn, a product search link is
      // nonsense — the conversation is still narrowing intent, not browsing.
      if (!hasRecs && isClarifyingQuestion(answerText)) return false;

      return true;
    }

    // Heuristic: does this answer read as a clarifying question rather than a
    // product result? True when the prose ends on a question mark (the assistant
    // is asking the shopper something) — e.g. "...which tone feels closest?".
    function isClarifyingQuestion(answerText) {
      var text = String(answerText || '').trim();
      if (!text) return false;
      // Strip trailing markdown/whitespace then test the final sentence.
      var stripped = text.replace(/[\s*_>`~)\]]+$/, '');
      return /\?$/.test(stripped);
    }

    // Drop every quick-reply row (only the newest assistant turn ever carries
    // chips, and a question the shopper has just answered by typing is done).
    function clearQuickReplies() {
      if (!messages) return;
      var stale = messages.querySelectorAll('.cap-ai-consultant__quick-replies');
      Array.prototype.forEach.call(stale, function (el) {
        if (el.parentNode) el.parentNode.classList.remove('has-quick-replies');
        el.remove();
      });
    }

    function addQuickReplies(message, suppliedReplies, options) {
      // Render the worker's quick_replies as tappable action chips under the
      // latest assistant reply (e.g. "Show rings", "Compare stones", "Talk
      // budget", "Start custom"), so a shopper can answer a discovery question
      // or opt straight into results with one tap. Only the newest reply carries
      // chips — clear any earlier row first.
      // options.limit  — chip cap (default 4; the starter prompts pass 5)
      // options.event  — analytics event name (default quick_reply_click)
      // options.starter — marks the greeting's starter-prompt row
      options = options || {};
      var limit = options.limit > 0 ? options.limit : 4;
      clearQuickReplies();

      var seen = {};
      var labels = [];
      (Array.isArray(suppliedReplies) ? suppliedReplies : []).forEach(function (reply) {
        var label = String(reply == null ? '' : reply).trim();
        if (!label || label.length > 32) return;
        var key = label.toLowerCase();
        if (seen[key]) return;
        seen[key] = true;
        labels.push(label);
      });
      labels = labels.slice(0, limit);
      if (!labels.length) return;

      var row = document.createElement('div');
      row.className = 'cap-ai-consultant__quick-replies' + (options.starter ? ' cap-ai-consultant__quick-replies--starter' : '');
      labels.forEach(function (label) {
        var chip = document.createElement('button');
        chip.type = 'button';
        chip.className = 'cap-ai-consultant__chip';
        chip.textContent = label;
        // "Upload a photo" / "Re-upload photo" opens the photo picker instead
        // of sending the words (audit ISS-18, 2026-09-28: the tap sent text and
        // the shopper was told to try again). "Email the photo" stays a message.
        // The chips stay until a photo is actually chosen.
        if (isUploadChip(label)) {
          chip.addEventListener('click', function () {
            trackAiEvent('quick_reply_click', { reply_text: label, reply_action: 'upload' });
            openUploadPicker();
          });
          row.appendChild(chip);
          return;
        }
        chip.addEventListener('click', function () {
          if (row.parentNode) row.parentNode.classList.remove('has-quick-replies');
          row.remove();
          if (voiceSession && voiceSession.prime) voiceSession.prime();
          if (options.event === 'prompt_click') trackAiEvent('prompt_click', { prompt_text: label });
          else trackAiEvent('quick_reply_click', { reply_text: label });
          sendMessage(label, true);
        });
        row.appendChild(chip);
      });

      // Attach inside the last assistant message so the chips wrap beneath its
      // bubble; fall back to the messages container if none is found.
      var assistantMsgs = messages.querySelectorAll('.cap-ai-consultant__message--assistant');
      var host = assistantMsgs.length ? assistantMsgs[assistantMsgs.length - 1] : null;
      if (host) {
        host.classList.add('has-quick-replies');
        host.appendChild(row);
      } else {
        messages.appendChild(row);
      }
      scrollMessages();
    }

    // Short, on-brand "thinking-first" acknowledgements shown the instant a
    // shopper sends a message — before the real answer returns. Rotated so the
    // line isn't identical every turn (the previous one is never repeated back
    // to back), giving the assistant an attentive, Sidekick-like presence.
    // Broad, elegant acknowledgements that suit ANY message (a question, a hello,
    // a request) — never assuming the shopper is searching, so the pretext always
    // reads gracefully no matter the prompt.
    var ACK_LINES = [
      'Of course — allow me a moment…',
      'With pleasure. One moment, please…',
      'It would be my pleasure — one moment…',
      'Certainly — let me attend to this with care…',
      'A moment, please — fine things deserve a careful eye…',
      'Of course. You have my full attention…',
      'Gladly — allow me a brief moment…',
      'With the greatest care — one moment…',
      'Let me see to this for you — just a moment…',
      'A pleasure — one moment while I attend to it…'
    ];
    var lastAckIndex = -1;

    function nextAckLine() {
      if (!ACK_LINES.length) return '';
      if (ACK_LINES.length === 1) return ACK_LINES[0];
      var index = Math.floor(Math.random() * ACK_LINES.length);
      // Never repeat the immediately-previous line.
      if (index === lastAckIndex) index = (index + 1) % ACK_LINES.length;
      lastAckIndex = index;
      return ACK_LINES[index];
    }

    function buildSearchUrl(query) {
      var glue = searchUrl.indexOf('?') === -1 ? '?' : '&';
      return searchUrl + glue + 'q=' + encodeURIComponent(query);
    }

    // Append UTM params to an INTERNAL product/search URL so analytics attribute
    // Internal analytics: emit a Capucinne AI engagement event to the dataLayer
    // (GTM), gtag (GA4) and a DOM CustomEvent (`capucinne:ai-event`). This lets us
    // measure how often shoppers engage with the AI's product responses — and
    // compute a real click-through rate from impression + click events — WITHOUT
    // UTM-tagging links (which would overwrite the visitor's true GA source).
    function trackAiEvent(name, params) {
      var detail = { ai_surface: AI_SURFACE, conversation_id: conversationId };
      if (params) {
        for (var key in params) {
          if (Object.prototype.hasOwnProperty.call(params, key)) detail[key] = params[key];
        }
      }
      if (window.CapucinneAITrack && window.CapucinneAITrack.track) {
        window.CapucinneAITrack.track(name, detail);
      }
    }

    // Fire recommendation_click when any link inside a product card is opened,
    // capturing the product, its position in the row, and the query that surfaced
    // it — so AI-driven product clicks are attributable internally.
    function trackRecommendationClick(card, item, index) {
      if (!card) return;
      var links = card.querySelectorAll('a[href]');
      Array.prototype.forEach.call(links, function (link) {
        link.addEventListener('click', function () {
          trackAiEvent('recommendation_click', {
            product_url: (item && item.url) || '',
            product_title: (item && item.title) || '',
            product_price: (item && item.price) || '',
            position: index + 1,
            ai_query: lastUserQuery
          });
        });
      });
    }

    function getSearchQuery(message, preferredQuery) {
      var api = window.CapucinneAISearch;
      if (!api || !api.deriveQuery) return '';

      if (preferredQuery) {
        var semanticQuery = api.deriveQuery(preferredQuery, searchState);
        if (semanticQuery) return semanticQuery;
      }

      return api.deriveQuery(message, searchState);
    }

    // The worker's reply shape always carries search_query, and it is EMPTIED
    // deliberately for policy/care/non-product questions. Treat that as
    // authoritative: when the server says "no search makes sense here", never
    // re-derive keywords from the raw sentence — that residue produced
    // nonsense links like "ring later" out of "can I resize my ring later?".
    function getServerSearchQuery(message, data) {
      var serverQuery = data && typeof data.search_query === 'string'
        ? data.search_query.trim()
        : null;
      if (serverQuery !== null) {
        if (!serverQuery) return '';
        return getSearchQuery(message, serverQuery) || serverQuery;
      }
      return getSearchQuery(message);
    }

    // Scroll the MESSAGE LIST (never the window) to its bottom. Honours the
    // stick-to-bottom flag: a shopper who scrolled up to read is left alone;
    // `force` (the shopper's own message, a restore, the Ask AI button) re-arms
    // the flag and pins the view regardless.
    var pinQueued = false;
    function pinToBottom() {
      if (!messages || !stickToBottom) return;
      // The shopper just scrolled away from our last pin (their scroll event
      // may not have been dispatched yet) — respect it instead of yanking.
      if (recentUserGesture(150) && lastAutoScrollTop >= 0 &&
        Math.abs(messages.scrollTop - lastAutoScrollTop) > 1 && !isNearBottom()) {
        stickToBottom = false;
        return;
      }
      messages.scrollTop = messages.scrollHeight;
      // Read back the clamped position so the scroll listener can tell this
      // pin apart from a shopper-driven scroll.
      lastAutoScrollTop = messages.scrollTop;
    }

    function scrollMessages(force) {
      if (!messages) return;
      if (force) {
        stickToBottom = true;
        lastAutoScrollTop = -1;
      }
      if (!stickToBottom) return;
      // Pin once the current task's DOM work is done (a microtask, coalesced —
      // it also runs while the tab is in the background, unlike rAF), then
      // again after the next paint so late layout (fonts, images, entrance
      // animations) is covered.
      if (!pinQueued) {
        pinQueued = true;
        Promise.resolve().then(function () {
          pinQueued = false;
          pinToBottom();
        });
      }
      window.requestAnimationFrame(pinToBottom);
    }

    // A REPLY WITH CARDS IS READ FROM THE TOP (UX walkthrough 2026-09-06: on
    // a 390px phone the answer text was scrolled clean out of view under a
    // carousel that pinned the list to its bottom). When the reply plus what
    // follows it (carousel, chips) is taller than the list, align the reply's
    // top edge to the list top and hand the scroll to the shopper; otherwise
    // the usual pin to the bottom already shows everything.
    function revealLatestReply(row) {
      // Only when the list is FOLLOWING the conversation: a shopper who
      // scrolled up to read is never yanked (the same rule as pinToBottom).
      if (!messages || !row || !row.isConnected || !stickToBottom) return;
      window.requestAnimationFrame(function () {
        if (!row.isConnected || !stickToBottom) return;
        var listRect = messages.getBoundingClientRect();
        var rowTop = row.getBoundingClientRect().top - listRect.top + messages.scrollTop;
        var tail = messages.scrollHeight - rowTop;
        if (tail <= messages.clientHeight + 8) return;
        messages.scrollTop = Math.max(0, Math.round(rowTop) - 6);
        lastAutoScrollTop = messages.scrollTop;
        stickToBottom = false;
      });
    }

    // --- Session capture helpers (all additive + fail-safe) -----------------

    // Per-session list of pages the shopper has viewed: {title, url, at}. Stored
    // in sessionStorage, de-duped on consecutive URL, capped at ~20. Best-effort:
    // any storage failure (private mode, quota) is swallowed.
    var VIEWED_PAGES_KEY = 'capucinne_ai_viewed_pages';
    var VIEWED_PAGES_CAP = 20;

    function getViewedPages() {
      try {
        var raw = window.sessionStorage.getItem(VIEWED_PAGES_KEY);
        if (!raw) return [];
        var parsed = JSON.parse(raw);
        return Array.isArray(parsed) ? parsed : [];
      } catch (error) {
        return [];
      }
    }

    function recordPageView() {
      try {
        var list = getViewedPages();
        var url = window.location.pathname;
        // De-dupe consecutive views of the same path (e.g. modal + page roots,
        // or a re-render) so the trail stays meaningful.
        var last = list.length ? list[list.length - 1] : null;
        if (last && last.url === url) return;
        list.push({
          title: String(document.title || '').slice(0, 300),
          url: url,
          at: Date.now()
        });
        if (list.length > VIEWED_PAGES_CAP) list = list.slice(-VIEWED_PAGES_CAP);
        window.sessionStorage.setItem(VIEWED_PAGES_KEY, JSON.stringify(list));
      } catch (error) {
        // sessionStorage unavailable/full: drop silently — capture is optional.
      }
    }

    // Fetch the live cart and build cart:[{title,image,price,quantity,url}] plus
    // a formatted cart_total. Never throws; on any failure the snapshot stays
    // empty and the chat request simply omits the cart.
    function refreshCartSnapshot() {
      try {
        fetch('/cart.js', {
          credentials: 'same-origin',
          headers: { 'Accept': 'application/json' }
        })
          .then(function (response) {
            return response && response.ok ? response.json() : null;
          })
          .then(function (data) {
            if (!data || !Array.isArray(data.items)) return;
            cartSnapshot = buildCartSnapshot(data);
          })
          .catch(function () {
            // Leave the prior snapshot in place.
          });
      } catch (error) {
        // Ignore — cart capture is optional.
      }
    }

    // --- Cart actions (AI-driven add / update / remove) ----------------------
    //
    // The /chat answer may carry an optional cart_actions array. Each entry is
    // { op:"add"|"update"|"remove", variant_id, quantity, title }. We execute
    // them against the REAL Online Store cart the shopper sees in the header:
    //   add            -> POST /cart/add.js    { items:[{ id, quantity }] }
    //   update/remove  -> POST /cart/change.js { id, quantity }   (0 removes)
    // then re-fetch /cart.js to refresh the snapshot + header count, and render
    // an in-chat confirmation card. EVERYTHING here is wrapped + fail-safe: any
    // error shows a calm inline note and NEVER disturbs the answer/recs. The
    // whole entry point is try/caught so a malformed payload can't break chat.
    function runCartActions(actions) {
      try {
        if (!Array.isArray(actions) || !actions.length) return;
        // Run sequentially so the header count + snapshot settle predictably and
        // Shopify's cart endpoints aren't hit concurrently for the same cart.
        actions.slice(0, 10).reduce(function (chain, action) {
          return chain.then(function () {
            return executeCartAction(action);
          });
        }, Promise.resolve()).then(function () {
          // Refresh the live snapshot (for the next AI turn) and the visible
          // header cart count once all actions in this turn have run.
          refreshCartSnapshot();
          refreshCartUI();
        }).catch(function () {
          // Any unexpected rejection is already surfaced per-action below; the
          // chat answer is untouched.
        });
      } catch (error) {
        // Defensive: a malformed cart_actions payload never breaks the chat.
      }
    }

    // Execute a single cart action against the real cart. Resolves regardless of
    // outcome (never rejects) so the sequential chain in runCartActions always
    // continues. On a Shopify error (out of stock / invalid variant / 422) it
    // renders a calm inline note instead of a confirmation.
    function executeCartAction(action) {
      if (!action || typeof action !== 'object') return Promise.resolve();

      var op = String(action.op || '').toLowerCase();
      // An add that carries a product handle (no resolved variant) means the
      // shopper should pick the exact variant from the product's REAL options.
      if (op === 'add' && action.handle && !normalizeVariantId(action.variant_id)) {
        renderVariantPicker(String(action.handle), action.title, action.quantity);
        return Promise.resolve();
      }
      // A remove carrying a product handle (no variant) -> resolve + remove the
      // matching cart line(s) on the client.
      if (op === 'remove' && action.handle && !normalizeVariantId(action.variant_id)) {
        removeByHandle(String(action.handle), action.title);
        return Promise.resolve();
      }
      var variantId = normalizeVariantId(action.variant_id);
      var title = cleanField(action.title) || 'that item';
      // Clamp 0..5 to mirror the worker's cap; coerce non-numerics safely.
      var quantity = Number(action.quantity);
      if (!isFinite(quantity)) quantity = (op === 'add') ? 1 : 0;
      quantity = Math.max(0, Math.min(5, Math.round(quantity)));

      // "remove" is an update to quantity 0; treat a 0-quantity update as remove.
      if (op === 'remove') quantity = 0;
      var effectiveOp = (op === 'add') ? 'add' : 'change';
      if (op !== 'add' && op !== 'update' && op !== 'remove') {
        // Unknown op: ignore (forward-compatible, fail-safe).
        return Promise.resolve();
      }

      if (!variantId) {
        renderCartActionError(title);
        return Promise.resolve();
      }

      var request;
      if (effectiveOp === 'add') {
        request = cartFetch('/cart/add.js', {
          items: [{ id: Number(variantId), quantity: quantity || 1 }]
        });
      } else {
        request = cartFetch('/cart/change.js', {
          id: Number(variantId),
          quantity: quantity
        });
      }

      return request
        .then(function (ok) {
          if (!ok) {
            renderCartActionError(title);
            return;
          }
          // op label for the confirmation: a 0-quantity change reads as removed,
          // an "update" stays "Updated", a non-zero change/add as appropriate.
          var label;
          if (op === 'add') label = 'added';
          else if (quantity === 0) label = 'removed';
          else label = 'updated';
          renderCartActionConfirmation(label, title);
        })
        .catch(function () {
          renderCartActionError(title);
        });
    }

    // US ring sizes (2..13, quarter steps) — matches snippets/ring-size.liquid.
    // Ring size is a LINE-ITEM PROPERTY ("Ring size"), not a variant.
    var RING_SIZES = (function () {
      var out = [], fr = ['', ' 1/4', ' 1/2', ' 3/4'];
      for (var n = 2; n <= 12; n += 1) for (var f = 0; f < 4; f += 1) out.push(n + fr[f]);
      out.push('13');
      return out;
    })();

    // A made-to-order RING needs a ring size chosen (added as a line-item
    // property). Ready-to-ship pieces ship in a fixed size, and anything that
    // already exposes a Size variant is handled by the chips — skip those.
    function productNeedsRingSize(product) {
      if (!product) return false;
      var type = String(product.type || '').toLowerCase();
      var title = String(product.title || '').toLowerCase();
      var tags = (Array.isArray(product.tags) ? product.tags.join(' ') : String(product.tags || '')).toLowerCase();
      var isRing = type.indexOf('ring') !== -1 || /\bring\b/.test(title);
      if (!isRing) return false;
      if (/ready\s*to\s*ship/.test(title) || /ready\s*to\s*ship/.test(tags)) return false;
      var hasSizeOption = (Array.isArray(product.options) ? product.options : []).some(function (o) {
        return /size/i.test(String(o && o.name ? o.name : o));
      });
      return !hasSizeOption;
    }

    // The AI queued an add by product HANDLE (no variant) -> show that product's
    // REAL Shopify options as chips, resolve the exact variant id on the client
    // when the shopper picks, then add it. Constrained to the actual variants:
    // no free-text, no guessing, no AI variant-id pinpointing. Fully fail-safe.
    function renderVariantPicker(handle, title, quantity, opts) {
      if (!messages || (!handle && !cleanField(title))) return;
      var qty = Math.max(1, Math.min(5, Math.round(Number(quantity) || 1)));
      var label = cleanField(title);
      var done = function () { if (opts && typeof opts.onDone === 'function') { try { opts.onDone(); } catch (error) { /* ignore */ } } };
      // 1) Try the handle the AI gave. 2) If it 404s (the AI sometimes derives a
      // handle from the name), resolve the REAL product by title via predictive
      // search, then render. Fully fail-safe.
      fetchProductJson(handle, function (product) {
        if (product) { buildVariantPicker(product, label || product.title, qty, opts); done(); return; }
        if (!label) { renderCartActionError('that piece'); done(); return; }
        resolveProductByTitle(label, function (found) {
          if (found && found.handle) {
            fetchProductJson(found.handle, function (p2) {
              if (p2) buildVariantPicker(p2, label || p2.title, qty, opts);
              else renderCartActionError(label);
              done();
            });
          } else {
            renderCartActionError(label);
            done();
          }
        });
      });
    }

    // /products/{handle}.js once per page view, shared by the card photo gallery
    // and the options picker (a failed fetch is forgotten so it can be retried).
    function loadProductJson(handle) {
      var h = cleanField(handle);
      if (!h) return Promise.resolve(null);
      var cache = loadProductJson.cache || (loadProductJson.cache = {});
      if (!cache[h]) {
        try {
          cache[h] = fetch('/products/' + encodeURIComponent(h) + '.js', {
            credentials: 'same-origin',
            headers: { 'Accept': 'application/json' }
          })
            .then(function (r) { return r && r.ok ? r.json() : null; })
            .catch(function () { return null; });
        } catch (error) {
          cache[h] = Promise.resolve(null);
        }
        cache[h].then(function (p) { if (!p) delete cache[h]; });
      }
      return cache[h];
    }

    // Fetch /products/{handle}.js -> the product object (with variants) or null.
    function fetchProductJson(handle, cb) {
      loadProductJson(handle).then(function (p) {
        cb(p && Array.isArray(p.variants) && p.variants.length ? p : null);
      });
    }

    // Resolve a product by title via Shopify predictive search -> the top product
    // ({ handle, title, ... }) or null. Same-origin; works in the shopper's browser.
    function resolveProductByTitle(title, cb) {
      var q = cleanField(title);
      if (!q) { cb(null); return; }
      try {
        fetch('/search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=4', {
          credentials: 'same-origin',
          headers: { 'Accept': 'application/json' }
        })
          .then(function (r) { return r && r.ok ? r.json() : null; })
          .then(function (d) {
            var products = d && d.resources && d.resources.results && d.resources.results.products;
            cb(Array.isArray(products) && products.length ? products[0] : null);
          })
          .catch(function () { cb(null); });
      } catch (error) { cb(null); }
    }

    // The chosen value of a variant for option index i (0-based), across the two
    // shapes /products/X.js returns: variant.options[] or variant.option1/2/3.
    function variantOptionValue(variant, index) {
      if (!variant) return '';
      if (Array.isArray(variant.options) && variant.options.length > index) {
        return String(variant.options[index] == null ? '' : variant.options[index]);
      }
      return String(variant['option' + (index + 1)] == null ? '' : variant['option' + (index + 1)]);
    }

    // Distinct values for option index i, in first-seen order.
    function uniqueOptionValues(variants, index) {
      var seen = {}, out = [];
      variants.forEach(function (v) {
        var val = variantOptionValue(v, index);
        if (val && !seen[val]) { seen[val] = true; out.push(val); }
      });
      return out;
    }

    // First variant whose option values equal every set selection.
    function matchVariant(variants, selections) {
      for (var i = 0; i < variants.length; i++) {
        var ok = true;
        for (var j = 0; j < selections.length; j++) {
          if (selections[j] == null) continue;
          if (variantOptionValue(variants[i], j) !== selections[j]) { ok = false; break; }
        }
        if (ok) return variants[i];
      }
      return null;
    }

    function buildVariantPicker(product, title, qty, opts) {
      if (!messages) return;
      var variants = product.variants;
      var optionNames = Array.isArray(product.options)
        ? product.options.map(function (o) { return (o && o.name) ? o.name : o; })
        : [];

      var card = document.createElement('div');
      card.className = 'cap-ai-consultant__variant-picker';
      if (product.handle) card.setAttribute('data-handle', String(product.handle));
      if (opts && opts.requestHandle) card.setAttribute('data-request-handle', String(opts.requestHandle));
      card.setAttribute('role', 'group');
      card.setAttribute('aria-label', 'Choose options for ' + (title || 'this piece'));

      var head = document.createElement('div');
      head.className = 'cap-ai-consultant__variant-picker-head';
      var imgSrc = cleanField(product.featured_image || (Array.isArray(product.images) && product.images[0]));
      if (imgSrc) {
        if (imgSrc.indexOf('//') === 0) imgSrc = 'https:' + imgSrc;
        var im = document.createElement('img');
        im.className = 'cap-ai-consultant__variant-picker-img';
        im.src = imgSrc;
        im.alt = '';
        im.loading = 'lazy';
        head.appendChild(im);
      }
      var ht = document.createElement('span');
      ht.className = 'cap-ai-consultant__variant-picker-title';
      ht.textContent = title || product.title || 'Choose your options';
      head.appendChild(ht);
      card.appendChild(head);

      var selections = [];

      optionNames.forEach(function (name, i) {
        var values = uniqueOptionValues(variants, i);
        var isDefault = values.length <= 1 && /^(title|default)/i.test(String(name || ''));
        if (isDefault) { selections[i] = values[0] || null; return; }

        var row = document.createElement('div');
        row.className = 'cap-ai-consultant__variant-row';
        var label = document.createElement('span');
        label.className = 'cap-ai-consultant__variant-label';
        label.textContent = name;
        row.appendChild(label);

        var chipsWrap = document.createElement('div');
        chipsWrap.className = 'cap-ai-consultant__variant-chips';
        var rowChips = [];
        values.forEach(function (val) {
          var chip = document.createElement('button');
          chip.type = 'button';
          chip.className = 'cap-ai-consultant__variant-chip';
          chip.textContent = val;
          chip.setAttribute('aria-pressed', 'false');
          chip.addEventListener('click', function () {
            selections[i] = val;
            rowChips.forEach(function (c) { c.classList.remove('is-selected'); c.setAttribute('aria-pressed', 'false'); });
            chip.classList.add('is-selected');
            chip.setAttribute('aria-pressed', 'true');
          });
          chipsWrap.appendChild(chip);
          rowChips.push(chip);
        });
        row.appendChild(chipsWrap);
        card.appendChild(row);

        // Pre-select the first value that resolves to an available variant.
        var preIdx = 0;
        for (var k = 0; k < values.length; k++) {
          var probe = selections.slice();
          probe[i] = values[k];
          var mv = matchVariant(variants, probe);
          if (mv && mv.available !== false) { preIdx = k; break; }
        }
        selections[i] = values[preIdx];
        if (rowChips[preIdx]) { rowChips[preIdx].classList.add('is-selected'); rowChips[preIdx].setAttribute('aria-pressed', 'true'); }
      });

      // Ring size = a required LINE-ITEM PROPERTY for made-to-order rings.
      var ringSizeSelect = null;
      if (productNeedsRingSize(product)) {
        var sizeRow = document.createElement('div');
        sizeRow.className = 'cap-ai-consultant__variant-row';
        var sizeLabel = document.createElement('span');
        sizeLabel.className = 'cap-ai-consultant__variant-label';
        sizeLabel.textContent = 'Ring size (US)';
        sizeRow.appendChild(sizeLabel);
        ringSizeSelect = document.createElement('select');
        ringSizeSelect.className = 'cap-ai-consultant__variant-select';
        var phOpt = document.createElement('option');
        phOpt.value = '';
        phOpt.textContent = 'Select your size';
        ringSizeSelect.appendChild(phOpt);
        RING_SIZES.forEach(function (s) {
          var o = document.createElement('option');
          o.value = s;
          o.textContent = s;
          ringSizeSelect.appendChild(o);
        });
        ringSizeSelect.addEventListener('change', function () { ringSizeSelect.classList.remove('is-error'); });
        sizeRow.appendChild(ringSizeSelect);
        card.appendChild(sizeRow);
      }

      var addBtn = document.createElement('button');
      addBtn.type = 'button';
      addBtn.className = 'cap-ai-consultant__variant-add cap-ai-consultant__cart-action-btn cap-ai-consultant__cart-action-btn--primary';
      addBtn.textContent = 'Add to cart';
      addBtn.addEventListener('click', function () {
        var variant = matchVariant(variants, selections);
        if (!variant || variant.available === false) { renderCartActionError(title || product.title); return; }
        var properties = null;
        if (ringSizeSelect) {
          var size = ringSizeSelect.value;
          if (!size) { ringSizeSelect.classList.add('is-error'); try { ringSizeSelect.focus(); } catch (e) {} return; }
          properties = { 'Ring size': size };
        }
        addBtn.disabled = true;
        var item = { id: Number(variant.id), quantity: qty };
        if (properties) item.properties = properties;
        cartFetch('/cart/add.js', { items: [item] }).then(function (ok) {
          if (!ok) { addBtn.disabled = false; renderCartActionError(title || product.title); return; }
          try { card.parentNode && card.parentNode.removeChild(card); } catch (e) { /* keep */ }
          var chosen = selections.filter(function (s, idx) {
            return s && !/^(title|default)/i.test(String(optionNames[idx] || ''));
          });
          if (properties) chosen.push('size ' + properties['Ring size']);
          var label = (title || product.title) + (chosen.length ? ' — ' + chosen.join(', ') : '');
          renderCartActionConfirmation('added', label);
          refreshCartSnapshot();
          refreshCartUI();
          openCartDrawer();
        });
      });
      card.appendChild(addBtn);

      var placeholder = opts && opts.placeholder;
      if (placeholder && placeholder.isConnected && placeholder.parentNode === messages) {
        messages.insertBefore(card, placeholder);
        placeholder.parentNode.removeChild(placeholder);
      } else {
        messages.appendChild(card);
      }
      if (opts && opts.reveal) revealInteraction(card, !!opts.focus, 'is-revealed');
      else scrollMessages();
    }

    // Best-effort: nudge the theme's cart drawer/badge open so the add feels live.
    // Never navigates; a theme without a drawer is simply left untouched.
    function openCartDrawer() {
      // Intentionally does NOT open the theme cart drawer. The theme drawer sits
      // at z-index 31, far below the consultant modal (~2.2e9), so auto-opening it
      // made the drawer bleed over / behind page elements. The in-chat confirmation
      // ("Added … — View cart / Checkout") plus the refreshed header count are the
      // real-time cart cue instead; the shopper opens the cart via View cart.
    }

    // Remove a piece by handle: find the matching cart line(s) in /cart.js and set
    // each to quantity 0 via /cart/change.js. Matches by handle, product url, or
    // title so it works even when the AI's handle is slightly off. Fail-safe.
    function removeByHandle(handle, title) {
      var h = String(handle || '').toLowerCase();
      var t = cleanField(title).toLowerCase();
      try {
        fetch('/cart.js', { credentials: 'same-origin', headers: { 'Accept': 'application/json' } })
          .then(function (r) { return r && r.ok ? r.json() : null; })
          .then(function (cart) {
            var items = cart && Array.isArray(cart.items) ? cart.items : [];
            var matches = items.filter(function (it) {
              var ih = String(it.handle || '').toLowerCase();
              var iu = String(it.url || '').toLowerCase();
              var itt = String(it.product_title || it.title || '').toLowerCase();
              return (h && (ih === h || iu.indexOf('/products/' + h) !== -1)) || (t && itt.indexOf(t) !== -1);
            });
            if (!matches.length) { renderCartActionError(cleanField(title) || 'that piece'); return; }
            matches.reduce(function (chain, it) {
              return chain.then(function () { return cartFetch('/cart/change.js', { id: it.key, quantity: 0 }); });
            }, Promise.resolve()).then(function () {
              renderCartActionConfirmation('removed', cleanField(title) || matches[0].product_title || matches[0].title || 'that piece');
              refreshCartSnapshot();
              refreshCartUI();
            });
          })
          .catch(function () { renderCartActionError(cleanField(title) || 'that piece'); });
      } catch (error) { renderCartActionError(cleanField(title) || 'that piece'); }
    }

    // POST a JSON body to a Shopify cart endpoint, same-origin. Resolves to true
    // on a 2xx response, false on any non-2xx (out of stock / invalid variant /
    // 422) or network error. NEVER rejects.
    function cartFetch(url, body) {
      try {
        return fetch(url, {
          method: 'POST',
          credentials: 'same-origin',
          headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(body)
        })
          .then(function (response) {
            return !!(response && response.ok);
          })
          .catch(function () {
            return false;
          });
      } catch (error) {
        return Promise.resolve(false);
      }
    }

    // Coerce a variant id to a digits-only string: strip any
    // gid://shopify/ProductVariant/ prefix and any non-digits, returning '' when
    // nothing usable remains (which surfaces the calm error path).
    function normalizeVariantId(value) {
      if (value == null) return '';
      var digits = String(value).replace(/[^0-9]/g, '');
      return digits;
    }

    // Re-fetch /cart.js and update any header cart-count element the theme
    // exposes, then dispatch a generic cart-updated event so a listening theme
    // can refresh its drawer/badge. All best-effort: a theme without these hooks
    // is simply left untouched.
    function refreshCartUI() {
      try {
        fetch('/cart.js', {
          credentials: 'same-origin',
          headers: { 'Accept': 'application/json' }
        })
          .then(function (response) {
            return response && response.ok ? response.json() : null;
          })
          .then(function (cart) {
            if (!cart) return;
            updateHeaderCartCount(cart);
            dispatchCartUpdated(cart);
          })
          .catch(function () { /* header refresh is best-effort */ });
      } catch (error) {
        /* fetch unavailable: skip */
      }
    }

    // Update the visible header cart count across the common selectors themes use
    // for the bubble/badge. item_count is the total quantity across line items.
    function updateHeaderCartCount(cart) {
      var count = Number(cart && cart.item_count);
      if (!isFinite(count)) return;
      var selectors = [
        '[data-cart-count]',
        '.cart-count',
        '.cart-count-bubble',
        '#CartCount',
        '.cart-link__bubble-num',
        '.header__cart-count',
        '[data-cart-item-count]'
      ];
      try {
        var nodes = document.querySelectorAll(selectors.join(','));
        Array.prototype.forEach.call(nodes, function (node) {
          // Some themes hide the bubble at 0; update text either way and reveal
          // it when there's at least one item.
          var textTarget = node.querySelector('[data-cart-count-text]') || node;
          textTarget.textContent = String(count);
          if (count > 0) node.removeAttribute('hidden');
        });
      } catch (error) {
        /* selector unsupported: skip */
      }
    }

    // Best-effort: tell the theme its cart changed so a cart drawer / badge that
    // listens for a refresh event can re-render. We fire the few generic events
    // common across themes; a theme that ignores them is unaffected.
    function dispatchCartUpdated(cart) {
      var detail = { cart: cart, source: 'capucinne-ai-consultant' };
      ['cart:updated', 'cart:refresh', 'cart-updated'].forEach(function (name) {
        try {
          document.dispatchEvent(new CustomEvent(name, { detail: detail, bubbles: true }));
        } catch (error) {
          /* CustomEvent unsupported (very old browsers): skip */
        }
      });
      // Shopify's Theme/Cart Ajax bus, when present, is the canonical signal.
      try {
        if (window.Shopify && window.Shopify.onCartUpdate) {
          window.Shopify.onCartUpdate(cart);
        }
      } catch (error) {
        /* ignore */
      }
    }

    // In-chat confirmation card for a completed cart action:
    // "Added/Updated/Removed <title> ✓" with View cart + Checkout buttons.
    function renderCartActionConfirmation(label, title) {
      if (!messages) return;
      var verb = label === 'removed' ? 'Removed'
        : label === 'updated' ? 'Updated'
        : 'Added';
      // Read naturally: "Added X to your cart" / "Updated X" / "Removed X".
      var headline = (label === 'added')
        ? (verb + ' ' + title + ' to your cart')
        : (verb + ' ' + title);

      var card = document.createElement('div');
      card.className = 'cap-ai-consultant__cart-action';
      card.setAttribute('role', 'status');
      card.setAttribute('aria-live', 'polite');

      var head = document.createElement('div');
      head.className = 'cap-ai-consultant__cart-action-head';

      var check = document.createElement('span');
      check.className = 'cap-ai-consultant__cart-action-check';
      check.setAttribute('aria-hidden', 'true');
      check.innerHTML = '<svg class="cap-ai-icon" viewBox="0 0 448 512" fill="currentColor" stroke="none" aria-hidden="true" focusable="false"><path d="M438.6 105.4c12.5 12.5 12.5 32.8 0 45.3l-256 256c-12.5 12.5-32.8 12.5-45.3 0l-128-128c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0L160 338.7 393.4 105.4c12.5-12.5 32.8-12.5 45.3 0z"/></svg>';
      head.appendChild(check);

      var text = document.createElement('span');
      text.className = 'cap-ai-consultant__cart-action-text';
      text.textContent = headline;
      head.appendChild(text);

      card.appendChild(head);

      var actions = document.createElement('div');
      actions.className = 'cap-ai-consultant__cart-action-buttons';

      var viewCart = document.createElement('a');
      viewCart.className = 'cap-ai-consultant__cart-action-btn cap-ai-consultant__cart-action-btn--secondary';
      viewCart.href = '/cart';
      viewCart.textContent = 'View cart';
      actions.appendChild(viewCart);

      var checkout = document.createElement('a');
      checkout.className = 'cap-ai-consultant__cart-action-btn cap-ai-consultant__cart-action-btn--primary';
      checkout.href = '/checkout';
      checkout.textContent = 'Checkout';
      actions.appendChild(checkout);

      card.appendChild(actions);
      messages.appendChild(card);
      scrollMessages();

      try {
        trackAiEvent('cart_action', { cart_action_op: label, cart_action_title: title });
      } catch (error) {
        /* analytics best-effort */
      }
    }

    // Calm inline note when a cart action fails (out of stock / invalid variant /
    // 422). Never breaks the chat; the AI's answer + recommendations still show.
    function renderCartActionError(title) {
      if (!messages) return;
      var note = document.createElement('div');
      note.className = 'cap-ai-consultant__cart-action cap-ai-consultant__cart-action--error';
      note.setAttribute('role', 'status');
      note.setAttribute('aria-live', 'polite');

      var head = document.createElement('div');
      head.className = 'cap-ai-consultant__cart-action-head';

      var icon = document.createElement('span');
      icon.className = 'cap-ai-consultant__cart-action-icon';
      icon.setAttribute('aria-hidden', 'true');
      icon.innerHTML = '<svg class="cap-ai-icon" viewBox="0 0 512 512" fill="currentColor" stroke="none" aria-hidden="true" focusable="false"><path d="M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm0-384c13.3 0 24 10.7 24 24V264c0 13.3-10.7 24-24 24s-24-10.7-24-24V152c0-13.3 10.7-24 24-24zM224 352a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z"/></svg>';
      head.appendChild(icon);

      var text = document.createElement('span');
      text.className = 'cap-ai-consultant__cart-action-text';
      text.textContent = 'I could not add that — it may be out of stock or unavailable.';
      head.appendChild(text);

      note.appendChild(head);
      messages.appendChild(note);
      scrollMessages();

      try {
        trackAiEvent('cart_action_error', { cart_action_title: cleanField(title) });
      } catch (error) {
        /* analytics best-effort */
      }
    }

    function buildCartSnapshot(cart) {
      var items = (cart.items || []).slice(0, 20).map(function (item) {
        return {
          title: cleanField(item.product_title || item.title),
          image: cleanField(cartItemImage(item)),
          price: formatCartMoney(item.final_line_price != null ? item.final_line_price : item.line_price),
          quantity: Number(item.quantity) || 1,
          url: cleanField(item.url)
        };
      });

      // Numeric total in MAJOR units (cart.js total_price is integer minor units)
      // for precise, locale-independent threshold checks by the proactive engine.
      // This field is internal-only and is NOT forwarded in the chat request meta
      // (sendMessage spreads cart + cart_total only), so the contract is unchanged.
      var totalValue = Number(cart.total_price);
      totalValue = isFinite(totalValue) ? totalValue / 100 : NaN;

      return {
        cart: items,
        cart_total: formatCartMoney(cart.total_price),
        cart_total_value: totalValue
      };
    }

    // Resolve a line item's image URL across Shopify's cart.js shapes:
    // item.image (string|null) or item.featured_image ({url}|string). Returns an
    // absolute URL (cart.js images are often protocol-relative //cdn...) so the
    // dashboard can render them off-domain.
    function cartItemImage(item) {
      if (!item) return '';
      var src = '';
      if (typeof item.image === 'string' && item.image) {
        src = item.image;
      } else {
        var featured = item.featured_image;
        if (typeof featured === 'string') src = featured;
        else if (featured && typeof featured === 'object' && featured.url) src = featured.url;
      }
      if (src.indexOf('//') === 0) src = 'https:' + src;
      return src;
    }

    // PRICES IN THE SHOPPER'S MARKET CURRENCY (Ivan 2026-10-26). The catalog the
    // consultant searches is priced in USD. A shopper browsing in another
    // currency sees each card's exact market price - the price its product
    // page shows, from /products/<handle>.js (shared with the photo pager and
    // the options card) - and the worker gets the market's rate so it reads
    // and writes budgets in that currency. Read at request time: the storefront
    // sets window.Shopify.currency = { active, rate } (rate = units per 1 USD).
    function marketCurrencyCode() {
      var shop = window.Shopify || {};
      var active = shop.currency && shop.currency.active ? String(shop.currency.active) : '';
      return String(currency || active || '').trim().toUpperCase();
    }

    // { currency_rate, country } for the request meta; the rate only when it
    // belongs to the currency the cart is in.
    function marketMeta() {
      var shop = window.Shopify || {};
      var out = {};
      var active = shop.currency && shop.currency.active ? String(shop.currency.active).toUpperCase() : '';
      var rate = shop.currency ? parseFloat(shop.currency.rate) : NaN;
      if (active && active === marketCurrencyCode() && isFinite(rate) && rate > 0) out.currency_rate = String(shop.currency.rate);
      if (shop.country) out.country = String(shop.country);
      return out;
    }

    function marketPricing() {
      var code = marketCurrencyCode();
      return !!code && code !== 'USD';
    }

    // A card's price in the market currency from its product JSON (integer
    // minor units, formatted like the cart): the cheapest variant of the metal
    // the worker priced the card in ("platinum", "18k gold"), else the
    // starting price. '' when the JSON has no price.
    function marketPriceText(product, item) {
      if (!product || typeof product !== 'object') return '';
      var metal = item && item.price_metal ? String(item.price_metal).toLowerCase() : '';
      var cents = Number(product.price_min != null ? product.price_min : product.price);
      if (metal && Array.isArray(product.variants)) {
        var key = metal.indexOf('18') !== -1 ? '18k' : metal.split(' ')[0];
        var best = null;
        product.variants.forEach(function (variant) {
          if (!variant) return;
          var label = String(variant.title || [variant.option1, variant.option2, variant.option3].join(' ')).toLowerCase();
          var value = Number(variant.price);
          if (label.indexOf(key) !== -1 && isFinite(value) && (best === null || value < best)) best = value;
        });
        if (best !== null) cents = best;
        else metal = '';
      }
      if (!isFinite(cents) || cents <= 0) return '';
      var text = formatCartMoney(cents);
      if (!text) return '';
      if (metal) return text + ' in ' + metal;
      return /^\s*(?:starting at|from)\b/i.test(String((item && item.price) || '')) ? 'Starting at ' + text : text;
    }

    // The card's USD reference price waits hidden (keeping its line, so nothing
    // moves) until the market price is in; if the product JSON cannot be read
    // the reference price shows, marked USD - never a bare "$" a CA$ or A$
    // shopper would read as their own dollars.
    function applyMarketPrice(card, item) {
      if (!card || !item) return Promise.resolve();
      var url = String(item.url || item.product_url || '');
      var handle = url.replace(/[?#].*$/, '').replace(/\/+$/, '').split('/').pop() || '';
      var priceEl = card.querySelector('.cap-home-product-card__price');
      if (!priceEl) {
        var content = card.querySelector('.cap-home-product-card__content');
        if (!content) return Promise.resolve();
        priceEl = document.createElement('p');
        priceEl.className = 'cap-home-product-card__price';
        content.appendChild(priceEl);
      }
      var reference = String(priceEl.textContent || '').trim();
      // The worker's price is USD. A bare amount ("1250.00", or { amount })
      // was formatted in the cart currency for the card ("€1,250.00"), so the
      // fallback is written from the raw amount instead - never a USD figure
      // with the shopper's currency sign (review B 2026-10-26).
      var raw = item.price;
      var rawAmount = typeof raw === 'number' ? raw
        : (raw && typeof raw === 'object' ? parseFloat(raw.amount != null ? raw.amount : raw.value)
          : (/^\s*[\d.,]+\s*$/.test(String(raw || '')) ? parseFloat(String(raw).replace(/,/g, '')) : NaN));
      if (isFinite(rawAmount) && rawAmount > 0) {
        reference = '$' + rawAmount.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
      } else if (typeof raw === 'string' && /\$/.test(raw)) {
        reference = raw.trim();
      }
      priceEl.style.visibility = 'hidden';
      return loadProductJson(handle).then(function (product) {
        var text = marketPriceText(product, item);
        if (!text && reference) text = /\b[A-Z]{3}\b/.test(reference) ? reference : reference + ' USD';
        priceEl.textContent = text;
        priceEl.style.visibility = '';
      });
    }

    // Shopify cart prices are integer minor units (cents). Format via the shared
    // money helper when available, falling back to a plain decimal.
    function formatCartMoney(cents) {
      if (cents == null || cents === '') return '';
      var amount = Number(cents) / 100;
      if (!isFinite(amount)) return '';
      var api = window.CapucinneAISearch;
      if (api && api.formatPrice) {
        var formatted = api.formatPrice(amount, locale, currency);
        if (formatted) return formatted;
      }
      return amount.toFixed(2);
    }

    // PHOTO UPLOADS (audit ISS-18, 2026-09-28). Every photo is redrawn in the
    // browser before it is sent: at most 2048 px on the long edge, JPEG at
    // 0.85, lower until it is under 2.5 MB. Phone photos over 5 MB used to be
    // dropped without a word and HEIC reached the API labelled as JPEG; the
    // redraw also applies the camera rotation and leaves the EXIF (location)
    // behind. HEIC converts wherever the browser can open it (Safari). A photo
    // that cannot be opened or made small enough is explained in the chat with
    // a way to pick another - never a text-only turn that claims a photo came
    // with it. The photo goes to Claude as meta.image in the JSON body.
    function handleUpload(file) {
      if (!file) return;
      if (!isLikelyImageFile(file)) { showUploadError('type'); return; }
      prepareUploadImage(file).then(function (prepared) {
        persistUpload(prepared.blob).then(function (attachment) {
          var meta = { upload: true, image: prepared.image, preview: makeUploadPreview(prepared.blob) };
          if (attachment) meta.attachments = [attachment];
          sendMessage('Here is an inspiration image — what can you tell me about it?', true, meta);
        });
      }, function (error) {
        showUploadError(error && error.reason ? error.reason : 'decode');
      });
    }

    // Some Windows and Android setups hand a photo over (HEIC especially) with
    // no MIME type, or a generic one: the file extension decides then.
    function isLikelyImageFile(file) {
      if (!file) return false;
      var type = String(file.type || '');
      if (type && !/^application\/octet-stream$/i.test(type)) return /^image\//i.test(type);
      return /\.(?:jpe?g|jfif|png|gif|webp|heic|heif|avif|bmp)$/i.test(String(file.name || ''));
    }

    function firstImageFile(files) {
      for (var i = 0; files && i < files.length; i++) {
        if (isLikelyImageFile(files[i])) return files[i];
      }
      return null;
    }

    function openUploadPicker() {
      var input = uploadInputs[0];
      if (!input) return;
      try { input.click(); } catch (error) { /* no file picker here */ }
    }

    // A quick reply in which the shopper offers THEIR photo ("Upload a photo",
    // "Re-upload photo", "Share my picture", "Send a photo of my ring").
    // "Email the photo" and "Send me more photos" (asking to SEE pictures)
    // are not.
    function isUploadChip(label) {
      var text = String(label || '');
      if (/e-?mail/i.test(text)) return false;
      return /\b(?:re-?)?(?:upload(?:ing)?|attach(?:ing)?)\b/i.test(text) ||
        /\b(?:send|share|add|choose)\s+(?:(?:a|my|another|one|the|your)\s+)?(?:photo|pic|picture|image|screenshot)\b/i.test(text);
    }

    function uploadFailure(reason) {
      var error = new Error('photo upload: ' + reason);
      error.reason = reason;
      return error;
    }

    // Resolves { blob, image: { media_type, data } } (base64, no data: prefix)
    // or rejects with .reason 'decode' (the browser cannot open it) or 'size'.
    function prepareUploadImage(file) {
      var MAX_BYTES = 2.5 * 1024 * 1024;
      var steps = [
        { edge: 2048, quality: 0.85 },
        { edge: 2048, quality: 0.75 },
        { edge: 2048, quality: 0.65 },
        { edge: 1600, quality: 0.7 },
        { edge: 1280, quality: 0.65 }
      ];
      return decodeUploadImage(file).then(function (decoded) {
        var canvas = null;
        var canvasEdge = 0;
        var index = 0;
        function attempt() {
          if (index >= steps.length) return Promise.reject(uploadFailure('size'));
          var step = steps[index++];
          if (!canvas || canvasEdge !== step.edge) {
            canvas = drawUploadCanvas(decoded, step.edge);
            canvasEdge = step.edge;
          }
          return canvasToJpeg(canvas, step.quality).then(function (blob) {
            if (!blob || !blob.size) throw uploadFailure('decode');
            return blob.size > MAX_BYTES ? attempt() : blob;
          });
        }
        return Promise.resolve().then(attempt).then(function (blob) {
          decoded.release();
          return blobToImagePayload(blob).then(function (image) {
            return { blob: blob, image: image };
          });
        }, function (error) {
          decoded.release();
          throw error && error.reason ? error : uploadFailure('decode');
        });
      });
    }

    // createImageBitmap first (it honours the camera rotation when asked),
    // then an <img> on an object URL for browsers that reject the option.
    function decodeUploadImage(file) {
      function viaImage() {
        return new Promise(function (resolve, reject) {
          var url = '';
          try { url = window.URL.createObjectURL(file); } catch (error) { reject(uploadFailure('decode')); return; }
          var revoke = function () { try { window.URL.revokeObjectURL(url); } catch (error) { /* ignore */ } };
          var img = new Image();
          img.onload = function () {
            resolve({ source: img, width: img.naturalWidth, height: img.naturalHeight, release: revoke });
          };
          img.onerror = function () {
            revoke();
            reject(uploadFailure('decode'));
          };
          img.src = url;
        });
      }
      if (typeof window.createImageBitmap !== 'function') return viaImage();
      var pending;
      try { pending = window.createImageBitmap(file, { imageOrientation: 'from-image' }); } catch (error) { return viaImage(); }
      return Promise.resolve(pending).then(function (bitmap) {
        return {
          source: bitmap,
          width: bitmap.width,
          height: bitmap.height,
          release: function () { try { if (bitmap.close) bitmap.close(); } catch (error) { /* ignore */ } }
        };
      }, viaImage);
    }

    function drawUploadCanvas(decoded, maxEdge) {
      var width = decoded.width;
      var height = decoded.height;
      if (!(width > 0 && height > 0)) throw uploadFailure('decode');
      var scale = Math.min(1, maxEdge / Math.max(width, height));
      var canvas = document.createElement('canvas');
      canvas.width = Math.max(1, Math.round(width * scale));
      canvas.height = Math.max(1, Math.round(height * scale));
      var context = canvas.getContext('2d');
      if (!context) throw uploadFailure('decode');
      // JPEG has no transparency: a PNG's clear areas turn white, not black.
      context.fillStyle = '#ffffff';
      context.fillRect(0, 0, canvas.width, canvas.height);
      context.imageSmoothingEnabled = true;
      if ('imageSmoothingQuality' in context) context.imageSmoothingQuality = 'high';
      context.drawImage(decoded.source, 0, 0, canvas.width, canvas.height);
      return canvas;
    }

    function canvasToJpeg(canvas, quality) {
      return new Promise(function (resolve) {
        if (!canvas.toBlob) { resolve(null); return; }
        try {
          canvas.toBlob(function (blob) { resolve(blob || null); }, 'image/jpeg', quality);
        } catch (error) {
          resolve(null);
        }
      });
    }

    function blobToImagePayload(blob) {
      return new Promise(function (resolve, reject) {
        if (!window.FileReader) { reject(uploadFailure('decode')); return; }
        var reader = new FileReader();
        reader.onload = function () {
          var result = String(reader.result || '');
          var comma = result.indexOf(',');
          var data = comma < 0 ? '' : result.slice(comma + 1);
          if (!data) { reject(uploadFailure('decode')); return; }
          resolve({ media_type: blob.type === 'image/png' ? 'image/png' : 'image/jpeg', data: data });
        };
        reader.onerror = function () { reject(uploadFailure('decode')); };
        try { reader.readAsDataURL(blob); } catch (error) { reject(uploadFailure('decode')); }
      });
    }

    // What "Try again" needs to resend a photo turn: the same prepared photo,
    // its thumbnail drawn again from a data: URL (the first object URL is
    // revoked once shown). Null for a turn without a photo.
    function uploadRetryMeta(meta) {
      var image = meta && meta.image;
      if (!image || !image.data) return null;
      var retry = {
        upload: true,
        image: image,
        preview: { src: 'data:' + (image.media_type || 'image/jpeg') + ';base64,' + image.data, alt: 'Uploaded inspiration image' }
      };
      if (meta.attachments) retry.attachments = meta.attachments;
      return retry;
    }

    // Said in the chat, with a way to pick another photo. A client-side note,
    // not a conversation turn: it is not saved to the thread. role="alert"
    // announces it; the row is --notice, never --assistant, so chips and
    // transcript probes keep to real replies.
    function showUploadError(reason) {
      var text = 'I could not open that photo in this browser (iPhone HEIC photos often do this on a computer). Please choose it again as a JPEG or PNG, send a screenshot of it, or email it to info@capucinne.com.';
      if (reason === 'type') text = 'That file is not a photo I can open. Please choose a JPEG or PNG photo or a screenshot, or email it to info@capucinne.com.';
      else if (reason === 'size') text = 'That photo is too large to send here. Please choose a smaller photo or a screenshot, or email it to info@capucinne.com.';
      trackAiEvent('upload_failed', { upload_error: reason || 'decode' });
      openChat();
      greetingReady.then(function () {
        if (!messages) return;
        var row = document.createElement('div');
        row.className = 'cap-ai-consultant__message cap-ai-consultant__message--notice is-error';
        var avatar = document.createElement('span');
        avatar.className = 'cap-ai-consultant__avatar';
        avatar.innerHTML = SPARKLE_SVG;
        var bubble = document.createElement('div');
        bubble.className = 'cap-ai-consultant__bubble';
        bubble.setAttribute('role', 'alert');
        var copy = document.createElement('p');
        appendTextWithEmails(copy, text);
        bubble.appendChild(copy);
        var actions = document.createElement('div');
        actions.className = 'cap-ai-consultant__error-actions';
        var again = document.createElement('button');
        again.type = 'button';
        again.className = 'cap-ai-consultant__retry cap-ai-consultant__upload-again';
        again.textContent = 'Choose another photo';
        again.addEventListener('click', function () {
          trackAiEvent('upload_retry_click', {});
          openUploadPicker();
        });
        actions.appendChild(again);
        bubble.appendChild(actions);
        row.appendChild(avatar);
        row.appendChild(bubble);
        messages.appendChild(row);
        scrollMessages(true);
      });
    }

    // Presentational thumbnail { src, alt } for the shopper's bubble, from the
    // prepared JPEG (every browser can show it, unlike a HEIC original). The
    // object URL is revoked once the thumbnail has loaded (renderAttachment).
    function makeUploadPreview(blob) {
      if (!blob || !window.URL || !window.URL.createObjectURL) return null;
      try {
        return { src: window.URL.createObjectURL(blob), alt: 'Uploaded inspiration image' };
      } catch (error) {
        return null;
      }
    }

    // A stored copy for the dashboard (R2), only when the section sets
    // data-upload-endpoint. It never holds the turn up for more than 4 s.
    function persistUpload(blob) {
      if (!uploadEndpoint || !blob) return Promise.resolve(null);
      return Promise.race([
        sendUpload(blob),
        new Promise(function (resolve) { window.setTimeout(function () { resolve(null); }, 4000); })
      ]);
    }

    // POST the file to the Worker upload route. Resolves to { url, type } on
    // success, or null when uploads are not configured / the route is absent /
    // any error occurs. NEVER rejects in a way that blocks the chat — callers
    // still send the message regardless.
    function sendUpload(file) {
      if (!uploadEndpoint || !file) return Promise.resolve(null);

      var form = new FormData();
      form.append('file', file, file.name || 'photo.jpg');
      if (conversationId) form.append('conversation_id', conversationId);
      if (shopDomain) form.append('shop_domain', shopDomain);

      return fetch(uploadEndpoint, {
        method: 'POST',
        credentials: 'same-origin',
        body: form
      })
        .then(function (response) {
          if (!response || !response.ok) return null;
          return response.json();
        })
        .then(function (data) {
          if (data && data.url) return { url: String(data.url), type: data.type || file.type || 'image' };
          return null;
        })
        .catch(function () {
          return null;
        });
    }

    // Derive the proactive route from the chat endpoint by swapping the trailing
    // /chat segment for /proactive. Returns '' when no usable endpoint exists,
    // which disables proactive nudges gracefully — the normal chat is
    // entirely unaffected.
    function deriveProactiveEndpoint(chatEndpoint) {
      var value = String(chatEndpoint || '').trim();
      if (!value) return '';
      if (/\/chat(\?|#|$)/.test(value)) return value.replace(/\/chat(\?|#|$)/, '/proactive$1');
      return value.replace(/\/+$/, '') + '/proactive';
    }

    // Derive the live-takeover poll route from the chat endpoint (/chat -> /poll),
    // mirroring the /proactive derivation above.
    function derivePollEndpoint(chatEndpoint) {
      var value = String(chatEndpoint || '').trim();
      if (!value) return '';
      if (/\/chat(\?|#|$)/.test(value)) return value.replace(/\/chat(\?|#|$)/, '/poll$1');
      return value.replace(/\/+$/, '') + '/poll';
    }

    // --- Live human takeover (short-poll) ------------------------------------
    //
    // When a merchant "joins" from the dashboard, the AI pauses and the merchant's
    // replies are stored server-side. While the chat is open we poll the Worker
    // /poll route (~3.5s, paused while the tab is hidden) for human-agent replies
    // and render each inline as a "Capucinne specialist" bubble. ADDITIVE +
    // FAIL-SAFE: any fetch/parse error, an empty response, or a missing endpoint
    // means nothing happens and the normal AI chat is entirely unaffected.
    var takeoverPollEndpoint = derivePollEndpoint(endpoint);
    var takeoverCursor = '';
    var takeoverSeen = {};
    var takeoverTimer = null;
    var takeoverNoticeShown = false;
    var takeoverWasPaused = false;
    var TAKEOVER_POLL_MS = 3500;

    function buildPollRequestEndpoint(value, since) {
      try {
        var url = new URL(value, window.location.origin);
        if (isShopifyProxyEndpoint(value)) {
          if (shopDomain) url.searchParams.set('shop_domain', shopDomain);
          if (locale) url.searchParams.set('locale', locale);
          if (currency) url.searchParams.set('currency', currency);
        }
        url.searchParams.set('conversation_id', conversationId);
        if (since) url.searchParams.set('since', since);
        return isShopifyProxyEndpoint(value) ? (url.pathname + url.search + url.hash) : url.toString();
      } catch (error) {
        return value;
      }
    }

    // A human teammate's reply, shown as an assistant-side bubble but labelled so
    // the shopper knows a person (not the AI) is speaking. Reuses the markdown
    // renderer for the body.
    function renderAgentMessage(text) {
      if (!messages) return;
      var message = document.createElement('div');
      var avatar = document.createElement('span');
      var bubble = document.createElement('div');
      message.className = 'cap-ai-consultant__message cap-ai-consultant__message--assistant cap-ai-consultant__message--agent';
      avatar.className = 'cap-ai-consultant__avatar';
      avatar.innerHTML = SPARKLE_SVG;
      bubble.className = 'cap-ai-consultant__bubble';
      var label = document.createElement('span');
      label.className = 'cap-ai-consultant__agent-label';
      label.textContent = 'Capucinne specialist';
      bubble.appendChild(label);
      var body = document.createElement('div');
      renderAnswer(body, String(text || ''));
      bubble.appendChild(body);
      message.appendChild(avatar);
      message.appendChild(bubble);
      messages.appendChild(message);
      scrollMessages();
    }

    function pollTakeoverOnce() {
      if (!takeoverPollEndpoint) return;
      try {
        fetch(buildPollRequestEndpoint(takeoverPollEndpoint, takeoverCursor), {
          method: 'GET',
          credentials: 'same-origin',
          headers: { 'Accept': 'application/json' }
        })
          .then(function (response) { return response && response.ok ? response.json() : null; })
          .then(function (data) {
            if (!data) return;
            if (data.cursor) takeoverCursor = String(data.cursor);
            if (data.paused && !takeoverNoticeShown) {
              takeoverNoticeShown = true;
              if (messages) {
                var note = document.createElement('div');
                note.className = 'cap-ai-consultant__system-note';
                note.textContent = 'A Capucinne specialist has joined the chat.';
                messages.appendChild(note);
                scrollMessages();
              }
            }
            if (!data.paused) takeoverNoticeShown = false;

            // Seamless hand-off BACK to the AI: the moment the merchant releases
            // (paused goes true -> false), the assistant posts a brief re-intro so
            // the shopper sees the AI resume — no refresh needed.
            if (takeoverWasPaused && !data.paused) {
              addMessage('assistant', 'Thanks for waiting! I am back and happy to keep helping. What else can I do for you?');
            }
            takeoverWasPaused = !!data.paused;

            // De-dup PURELY by per-message id. The server filter is now
            // inclusive (>=) on the cursor timestamp, so the boundary message
            // may be RE-returned on the next poll — that is expected and safe.
            // We render + mark each id exactly once; a re-sent id is skipped,
            // and a message we have not seen always renders even if it shares
            // the cursor's clock tick. Mark BEFORE rendering so a render throw
            // can never re-render the same id on a later poll.
            var list = Array.isArray(data.messages) ? data.messages : [];
            list.forEach(function (m) {
              var id = String((m && m.id) || '');
              if (!id || takeoverSeen[id]) return;
              takeoverSeen[id] = true;
              renderAgentMessage(m && m.text);
            });
          })
          .catch(function () { /* fail-safe: poll errors never disturb the chat */ });
      } catch (error) {
        /* fetch unavailable: skip */
      }
    }

    function startTakeoverPolling() {
      if (takeoverTimer || !takeoverPollEndpoint) return;
      pollTakeoverOnce();
      takeoverTimer = window.setInterval(function () {
        if (typeof document !== 'undefined' && document.hidden) return;
        pollTakeoverOnce();
      }, TAKEOVER_POLL_MS);
    }

    // --- Proactive nudges ----------------------------------------------------
    //
    // Merchant configures nudges in the dashboard ("Need help choosing the right
    // ring?"); the Worker serves the ENABLED rules at /proactive (derived from
    // the chat endpoint). On init we fetch them, evaluate each against its
    // trigger, and when one matches show a subtle, dismissible teaser inviting
    // the shopper to open the consultant with that message as the greeting.
    //
    // Everything here is ADDITIVE + FAIL-SAFE: any fetch/parse error, an empty
    // rule set, or a missing endpoint means nothing renders and the normal chat
    // and search are entirely unaffected. Each rule fires at most once per
    // session (sessionStorage dedupe by rule id).

    var PROACTIVE_FIRED_KEY = 'capucinne_ai_proactive_fired';
    var proactiveTeaser = null;

    function initProactive() {
      // The AI lives on the consultant PAGE (merchant 2026-09-01): site-wide
      // proactive teasers are retired; only the page's root runs the engine.
      var proactiveEndpoint = deriveProactiveEndpoint(endpoint);
      if (!proactiveEndpoint) return;

      try {
        fetch(buildProactiveRequestEndpoint(proactiveEndpoint), {
          method: 'GET',
          credentials: 'same-origin',
          headers: { 'Accept': 'application/json' }
        })
          .then(function (response) {
            return response && response.ok ? response.json() : null;
          })
          .then(function (data) {
            var rules = data && Array.isArray(data.rules) ? data.rules : [];
            if (rules.length) scheduleProactiveRules(rules);
          })
          .catch(function () {
            // Any failure => no nudge. The chat is unaffected.
          });
      } catch (error) {
        // fetch unavailable / threw synchronously: silently skip.
      }
    }

    // The proactive route is reached through the same app proxy as /chat, so when
    // the chat endpoint is a Shopify proxy path append the shop context as query
    // params (mirrors buildRequestEndpoint) so the Worker can verify the signature
    // and load the right shop's config. Absolute endpoints are used as-is.
    function buildProactiveRequestEndpoint(value) {
      if (!isShopifyProxyEndpoint(value)) return value;
      try {
        var url = new URL(value, window.location.origin);
        if (shopDomain) url.searchParams.set('shop_domain', shopDomain);
        if (locale) url.searchParams.set('locale', locale);
        if (currency) url.searchParams.set('currency', currency);
        return url.pathname + url.search + url.hash;
      } catch (error) {
        return value;
      }
    }

    function scheduleProactiveRules(rules) {
      // Cap defensively (the served config is already ~20) and evaluate each rule
      // independently so one malformed rule never blocks the others.
      rules.slice(0, 20).forEach(function (rule) {
        try {
          scheduleProactiveRule(rule);
        } catch (error) {
          // Ignore a single bad rule.
        }
      });
    }

    function scheduleProactiveRule(rule) {
      if (!rule || typeof rule !== 'object') return;
      var id = String(rule.id || '').trim();
      var message = String(rule.message || '').trim();
      var trigger = String(rule.trigger || '').trim();
      if (!id || !message || !trigger) return;
      if (hasProactiveFired(id)) return;

      var delayMs = Math.max(0, Number(rule.delaySeconds) || 0) * 1000;

      if (trigger === 'page_load' || trigger === 'time_on_site') {
        // Both are "after N seconds on the page" — page_load typically uses a
        // short delay, time_on_site a longer dwell. Identical client mechanics.
        window.setTimeout(function () {
          fireProactiveRule(rule);
        }, delayMs);
        return;
      }

      if (trigger === 'on_page') {
        if (proactivePathMatches(rule.pathPattern)) {
          window.setTimeout(function () {
            fireProactiveRule(rule);
          }, delayMs);
        }
        return;
      }

      if (trigger === 'cart_value') {
        scheduleCartValueRule(rule, delayMs);
        return;
      }
      // Unknown trigger: ignore (forward-compatible, fail-safe).
    }

    // location.pathname/href contains pathPattern (case-insensitive substring).
    // An empty/absent pattern is treated as "any page" so the rule still fires.
    function proactivePathMatches(pathPattern) {
      var pattern = String(pathPattern == null ? '' : pathPattern).trim().toLowerCase();
      if (!pattern) return true;
      try {
        var path = String(window.location.pathname || '').toLowerCase();
        var href = String(window.location.href || '').toLowerCase();
        return path.indexOf(pattern) !== -1 || href.indexOf(pattern) !== -1;
      } catch (error) {
        return false;
      }
    }

    // Fire once the live cart total reaches cartMin. The cart snapshot refreshes
    // best-effort from /cart.js; poll it briefly (after the initial delay) so a
    // cart that crosses the threshold during the visit still triggers. Bounded so
    // it never polls forever.
    function scheduleCartValueRule(rule, delayMs) {
      var cartMin = Number(rule.cartMin);
      if (!isFinite(cartMin)) return;

      var attempts = 0;
      var maxAttempts = 40; // ~2 min at 3s cadence after the initial delay.

      var check = function () {
        if (hasProactiveFired(String(rule.id || ''))) return;
        refreshCartSnapshot();
        if (proactiveCartTotal() >= cartMin) {
          fireProactiveRule(rule);
          return;
        }
        attempts += 1;
        if (attempts < maxAttempts) window.setTimeout(check, 3000);
      };

      window.setTimeout(check, delayMs);
    }

    // Current cart total as a number for comparison against cartMin. Prefers the
    // precise numeric value captured straight from /cart.js (major units, locale-
    // independent); falls back to parsing the formatted string only if absent.
    // Returns 0 when unknown/empty.
    function proactiveCartTotal() {
      if (cartSnapshot && isFinite(cartSnapshot.cart_total_value)) {
        return cartSnapshot.cart_total_value;
      }
      var raw = cartSnapshot && cartSnapshot.cart_total;
      if (raw == null || raw === '') return 0;
      if (window.CapucinneAISearch && window.CapucinneAISearch.numericPrice) {
        var viaApi = window.CapucinneAISearch.numericPrice(raw);
        if (isFinite(viaApi)) return viaApi;
      }
      var cleaned = String(raw).replace(/[^0-9.]/g, '');
      var parsed = parseFloat(cleaned);
      return isFinite(parsed) ? parsed : 0;
    }

    function fireProactiveRule(rule) {
      var id = String(rule.id || '').trim();
      var message = String(rule.message || '').trim();
      if (!id || !message) return;
      // Re-check dedupe at fire time (a delayed timer may race another root or a
      // prior fire) and claim the slot immediately so it can't double-show.
      if (hasProactiveFired(id)) return;
      markProactiveFired(id);
      // Never interrupt an active conversation with a teaser.
      if (isChatting) return;
      showProactiveTeaser(rule);
    }

    function showProactiveTeaser(rule) {
      var message = String(rule.message || '').trim();
      if (!message) return;
      // Only one teaser visible at a time.
      if (proactiveTeaser && proactiveTeaser.parentNode) {
        proactiveTeaser.parentNode.removeChild(proactiveTeaser);
        proactiveTeaser = null;
      }

      var teaser = document.createElement('div');
      teaser.className = 'cap-ai-consultant cap-ai-proactive';
      teaser.setAttribute('role', 'status');
      teaser.setAttribute('aria-live', 'polite');

      var bubble = document.createElement('button');
      bubble.type = 'button';
      bubble.className = 'cap-ai-proactive__bubble';
      bubble.setAttribute('aria-label', 'Open Capucinne Consultant: ' + message);

      var spark = document.createElement('span');
      spark.className = 'cap-ai-proactive__spark';
      spark.setAttribute('aria-hidden', 'true');
      spark.innerHTML = SPARKLE_SVG;
      bubble.appendChild(spark);

      var text = document.createElement('span');
      text.className = 'cap-ai-proactive__text';
      text.textContent = message;
      bubble.appendChild(text);

      var dismiss = document.createElement('button');
      dismiss.type = 'button';
      dismiss.className = 'cap-ai-proactive__dismiss';
      dismiss.setAttribute('aria-label', 'Dismiss');
      dismiss.innerHTML = '<svg class="cap-ai-icon" viewBox="0 0 384 512" fill="currentColor" stroke="none" aria-hidden="true" focusable="false"><path d="M342.6 150.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L192 210.7 86.6 105.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L146.7 256 41.4 361.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L192 301.3 297.4 406.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L237.3 256 342.6 150.6z"/></svg>';

      var removeTeaser = function () {
        if (!teaser.parentNode) return;
        teaser.classList.add('is-leaving');
        var done = function () {
          if (teaser.parentNode) teaser.parentNode.removeChild(teaser);
          if (proactiveTeaser === teaser) proactiveTeaser = null;
        };
        // Allow the leave transition to play unless reduced motion is preferred.
        if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
          done();
        } else {
          window.setTimeout(done, 220);
        }
      };

      dismiss.addEventListener('click', function (event) {
        event.stopPropagation();
        trackAiEvent('proactive_dismiss', { proactive_id: String(rule.id || ''), proactive_message: message });
        removeTeaser();
      });

      bubble.addEventListener('click', function () {
        trackAiEvent('proactive_click', { proactive_id: String(rule.id || ''), proactive_message: message });
        removeTeaser();
        openConsultantWithGreeting(message);
      });

      teaser.appendChild(bubble);
      teaser.appendChild(dismiss);
      document.body.appendChild(teaser);
      proactiveTeaser = teaser;

      // Entrance: add the visible class on the next frame so the CSS transition
      // runs (no-op under reduced motion, where the teaser simply appears).
      window.requestAnimationFrame(function () {
        teaser.classList.add('is-visible');
      });

      trackAiEvent('proactive_impression', { proactive_id: String(rule.id || ''), proactive_message: message, trigger: String(rule.trigger || '') });
    }

    // Open the consultant and show the proactive message as the assistant's
    // opening line. Proactive only runs on the standalone consultant page now
    // (initProactive returns early on the header-modal surface), so the root is
    // already on screen — just open the chat and paint the greeting.
    function openConsultantWithGreeting(message) {
      openChat({ showWelcome: false });
      addMessage('assistant', message);
      scrollMessages();
    }

    function readProactiveFired() {
      try {
        var raw = window.sessionStorage.getItem(PROACTIVE_FIRED_KEY);
        if (!raw) return {};
        var parsed = JSON.parse(raw);
        return parsed && typeof parsed === 'object' ? parsed : {};
      } catch (error) {
        return {};
      }
    }

    function hasProactiveFired(id) {
      if (!id) return false;
      return !!readProactiveFired()[id];
    }

    function markProactiveFired(id) {
      if (!id) return;
      try {
        var map = readProactiveFired();
        map[id] = Date.now();
        window.sessionStorage.setItem(PROACTIVE_FIRED_KEY, JSON.stringify(map));
      } catch (error) {
        // sessionStorage unavailable: the in-memory timers still avoid an
        // immediate re-fire within this page; cross-page dedupe is simply lost.
      }
    }

    function resolveEndpoint(value, localOrigin) {
      if (!value) return '';

      if (value.indexOf('/apps/') === 0 && localOrigin && isLocalPreviewHost(window.location.hostname)) {
        return localOrigin.replace(/\/$/, '') + value;
      }

      return value;
    }

    function buildRequestEndpoint(value, payload) {
      if (!isShopifyProxyEndpoint(value)) return value;

      try {
        var url = new URL(value, window.location.origin);
        url.searchParams.set('message', payload.message || '');
        url.searchParams.set('conversation_id', payload.conversation_id || '');
        url.searchParams.set('shop_domain', payload.shop_domain || '');
        url.searchParams.set('locale', payload.locale || '');
        url.searchParams.set('currency', payload.currency || '');
        url.searchParams.set('cart_id', payload.cart_id || '');
        url.searchParams.set('checkout_url', payload.checkout_url || '');

        if (payload.meta && Object.keys(payload.meta).length) {
          // The photo travels in the JSON body only (audit ISS-18, 2026-09-28):
          // its base64 in the query string made the URL megabytes long, far
          // past any proxy's URL limit (Cloudflare's is 16 KB), so a photo turn
          // could fail before the worker ever saw it.
          var urlMeta = {};
          Object.keys(payload.meta).forEach(function (key) {
            if (key !== 'image') urlMeta[key] = payload.meta[key];
          });
          url.searchParams.set('meta', JSON.stringify(urlMeta));
        }

        return url.pathname + url.search + url.hash;
      } catch (error) {
        return value;
      }
    }

    function isShopifyProxyEndpoint(value) {
      try {
        var url = new URL(value, window.location.origin);
        return url.pathname.indexOf('/apps/') === 0;
      } catch (error) {
        return value.indexOf('/apps/') === 0;
      }
    }

    function isLocalPreviewHost(hostname) {
      return hostname === 'localhost' || hostname === '127.0.0.1' || hostname === '::1';
    }

  });
})();

// Keep the third-party Tidio launcher clear of the consultant page's fixed
// bottom mobile nav. Tidio positions its widgets with inline !important styles,
// which no theme stylesheet can override, and its default bottom-right spot
// overlaps the Cart nav item — shrinking its tap target to ~14px (WCAG 2.5.8
// target-size; flagged by Lighthouse; ADA exposure). Setting the style property
// with the 'important' priority from JS wins, and a MutationObserver + slow
// interval re-apply it whenever Tidio re-renders.
(function keepTidioClearOfConsultant() {
  if (!document.querySelector('.cap-ai-consultant__mobile-nav')) return;
  // Below 1024px the consultant page locks the document while its chat is open
  // (html.cap-ai-chat-lock) and the composer sits right above the bottom nav -
  // the lifted launcher landed exactly on the send button (merchant iPhone
  // test 2026-09-06). The AI chat IS the chat on this page: hide the launcher
  // there. On desktop it is lifted clear of the composer instead.
  var narrow = window.matchMedia('(max-width: 1023px)');
  var OFFSET = 'calc(104px + env(safe-area-inset-bottom))';

  // Tidio renders its launcher inside an OPEN SHADOW ROOT on a host <div>
  // directly under <body> (path: BODY > DIV > #document-fragment >
  // div#body > div#tidio-chat-root > ... > button#button-body), so neither
  // theme CSS nor document.querySelectorAll can reach it — walk the hosts'
  // shadowRoots explicitly.
  function tidioShadowRoots() {
    var roots = [];
    var hosts = document.querySelectorAll('body > div');
    for (var i = 0; i < hosts.length; i++) {
      var sr = hosts[i].shadowRoot;
      if (sr && sr.querySelector('#tidio-chat-root')) roots.push(sr);
    }
    return roots;
  }

  function lift() {
    var chatOpen = !!document.querySelector('section.cap-ai-consultant.is-page-fit.is-chatting');
    // The Consultant page IS the chat (QA 4.5): the launcher hides at every width.
    var hide = chatOpen;
    // Light-DOM fallbacks (older Tidio embeds used a plain iframe) plus the host.
    var hosts = [].slice.call(document.querySelectorAll('#tidio-chat, iframe#tidio-chat-iframe'));
    var nodes = [].slice.call(document.querySelectorAll('#tidio-chat iframe, iframe#tidio-chat-iframe'));
    tidioShadowRoots().forEach(function (sr) {
      nodes = nodes.concat([].slice.call(sr.querySelectorAll('#tidio-chat-root, #tidio-chat-root #button, #tidio-chat-root iframe')));
    });
    // Desktop: the launcher keeps Tidio's spot unless it would sit on the
    // composer's send button (narrow desktop stages); then it is lifted to
    // just above the composer. Horizontal overlap decides, so the lift never
    // flickers against itself.
    var offset = narrow.matches ? OFFSET : '';
    if (!narrow.matches && chatOpen) {
      var send = document.querySelector('section.cap-ai-consultant.is-page-fit.is-chatting [data-cap-ai-chat-form] .cap-ai-consultant__send');
      var s = send ? send.getBoundingClientRect() : null;
      if (s && s.width) {
        for (var k = 0; k < nodes.length; k++) {
          var r = nodes[k].getBoundingClientRect ? nodes[k].getBoundingClientRect() : null;
          if (r && r.width && r.left < s.right + 8 && r.right > s.left - 8) {
            offset = Math.round(window.innerHeight - s.top + 12) + 'px';
            break;
          }
        }
      }
    }
    for (var i = 0; i < nodes.length; i++) {
      try {
        if (hide) nodes[i].style.setProperty('display', 'none', 'important');
        else nodes[i].style.removeProperty('display');
        if (offset) nodes[i].style.setProperty('bottom', offset, 'important');
        else nodes[i].style.removeProperty('bottom');
      } catch (e) { /* noop */ }
    }
    for (var j = 0; j < hosts.length; j++) {
      try {
        if (hide) hosts[j].style.setProperty('display', 'none', 'important');
        else hosts[j].style.removeProperty('display');
      } catch (e) { /* noop */ }
    }
  }

  try {
    new MutationObserver(lift).observe(document.documentElement, { childList: true, subtree: true });
  } catch (e) { /* noop */ }
  lift();
  window.setInterval(lift, 3000);
})();
